{
  "app.nama": "Smova",
  "app.tenantMarketing": "Tenant Marketing",
  "nav.hariIni": "Today",
  "nav.perluDijawab": "Needs a reply",
  "nav.prospek": "Prospects",
  "nav.meeting": "Meetings",
  "nav.konten": "Content",
  "umum.muat": "Loading…",
  "umum.gagal": "Could not load",
  "umum.cobaLagi": "Try again",
  "umum.kosong": "Nothing here yet",
  "umum.cari": "Search…",
  "umum.semua": "All",
  "umum.tutup": "Close",
  "umum.simpan": "Save",
  "umum.simpanPerubahan": "Save changes",
  "umum.batal": "Cancel",
  "umum.kembali": "Back",
  "umum.lihat": "View",
  "umum.buka": "Open",
  "umum.dari": "{{mulai}}–{{akhir}} of {{total}}",
  "umum.bahasa": "Language",
  "tema.label": "Theme",
  "tema.perangkat": "Device",
  "tema.terang": "Light",
  "tema.gelap": "Dark",
  "umum.keluar": "Sign out",
  "umum.jaringanMati": "Can't reach the server. Check your connection, or dev is down.",
  "umum.sesiHabis": "Your session expired. Sign in again.",
  "login.judul": "Sign in",
  "login.keterangan": "Use your dashboard account.",
  "login.username": "Email",
  "login.password": "Password",
  "login.tombol": "Sign in",
  "login.sedang": "Signing in…",
  "hariIni.judul": "Today",
  "hariIni.keterangan": "What's waiting on you — not on the team.",
  "hariIni.dmDiambil": "{{n}} DMs you took but haven't answered",
  "hariIni.dmBelumDiambil": "{{n}} DMs nobody has taken",
  "hariIni.komentarBelumDijawab": "{{n}} comments still unanswered",
  "hariIni.meetingBerikut": "Next meeting",
  "hariIni.meetingHariIni": "{{n}} meetings today",
  "hariIni.kontenMenunggu": "{{n}} pieces of content waiting for review",
  "hariIni.bersih": "Nothing is stuck. Enjoy it.",
  "hariIni.angka7hari": "Last 7 days",
  "hariIni.dmMasuk": "DMs received",
  "hariIni.prospekBaru": "New prospects",
  "hariIni.kontenTerbit": "Content published",
  "masuk.judul": "Needs a reply",
  "masuk.keterangan": "DMs and comments the bot couldn't answer on its own.",
  "masuk.datang": "Arrived",
  "masuk.dari": "From",
  "masuk.isi": "Message",
  "masuk.jenis": "Type",
  "masuk.keadaan": "Status",
  "masuk.bot": "Bot",
  "masuk.belumDiambil": "Unclaimed",
  "masuk.andaAmbil": "You took it",
  "masuk.diambil": "Taken by {{nama}}",
  "masuk.botHidup": "Replying",
  "masuk.botDipegang": "Held",
  "masuk.ambil": "Take",
  "masuk.abaikan": "No reply needed",
  "masuk.abaikanGagal": "Could not mark it: {{sebab}}",
  "masuk.balas": "Reply",
  "masuk.dm": "DM",
  "masuk.komentar": "Comment",
  "masuk.kosong": "Nothing is waiting for a reply.",
  "prospek.judul": "Prospects",
  "prospek.keterangan": "From Instagram, plus the ones you added yourself.",
  "prospek.perusahaan": "Company",
  "prospek.asal": "Source",
  "prospek.tahap": "Stage",
  "prospek.ditangani": "Handled by",
  "prospek.bergerak": "Last activity",
  "prospek.tambah": "Add manually",
  "prospek.kosong": "No prospects yet. Ones from Instagram show up here on their own.",
  "prospek.data": "Collected data",
  "prospek.percakapan": "Conversation",
  "prospek.ikhtisar": "Overview",
  "prospek.jadwalkanMeeting": "Schedule meeting",
  "prospek.ubahData": "Edit data",
  "prospek.ubahCatatan": "Old values are not lost — every change is kept in the history along with what it was before.",
  "prospek.tambahCatatan": "Add note",
  "prospek.simpanCatatan": "Save note",
  "prospek.simpanMeeting": "Schedule",
  "prospek.alamat": "Address",
  "prospek.pic": "Contact person",
  "prospek.email": "Email",
  "prospek.telepon": "Phone",
  "prospek.cJudul": "What happened",
  "prospek.cContoh": "Called, asked for a proposal",
  "prospek.cKapan": "Date it happened",
  "prospek.cKeterangan": "Details",
  "prospek.mTanggal": "Date",
  "prospek.mJam": "Time",
  "prospek.mTautan": "Meeting link",
  "prospek.mLokasi": "Location",
  "prospek.meeting": "Meetings",
  "prospek.meetingHitung": "{{n}} meetings",
  "prospek.meetingCatatan": "One prospect may have many meetings. All are tied to this prospect — delete the prospect and its meetings go with it.",
  "prospek.meetingKosong": "No meetings yet",
  "prospek.meetingKosongKet": "Meetings scheduled by the bot or by hand will appear here.",
  "prospek.meetingBerikutnya": "Next meeting · {{kapan}}",
  "prospek.mKapan": "When",
  "prospek.mBentuk": "Format",
  "prospek.mSiapa": "Run by",
  "prospek.mAgenda": "Agenda",
  "prospek.koreksiJadwal": "Correct the old schedule record (no notification)",
  "prospek.waktuTidakAda": "This time does not exist in the tenant time zone. Choose another time.",
  "meetingStatus.scheduled": "Scheduled",
  "meetingStatus.pending_confirmation": "Awaiting confirmation",
  "meetingStatus.done": "Done",
  "meetingStatus.no_show": "No show",
  "meetingStatus.cancelled": "Cancelled",
  "meetingStatus.claimed": "Scheduled",
  "meetingStatus.pending_claim": "Scheduled",
  "prospek.mHasil": "Outcome",
  "prospek.mRekaman": "Recording",
  "prospek.adaRingkasan": "Summary available",
  "prospek.tanpaRekaman": "No recording",
  "prospek.belumAdaHasil": "not filled in",
  "prospek.belumDijadwalkan": "not scheduled",
  "prospek.online": "Online",
  "prospek.offline": "Offline",
  "prospek.bentukBelum": "not decided",
  "prospek.siapaMembalas": "Who replied to this conversation",
  "prospek.siapaMembalasCatatan": "People who took over. Anything not from a name here came from the bot.",
  "prospek.belumAdaPenangan": "Nobody has taken over — every reply came from the bot.",
  "prospek.catatan": "Notes",
  "prospek.belumDiisi": "not filled in",
  "prospek.botDipegang": "You're holding this conversation",
  "prospek.botHidup": "Bot is replying automatically",
  "prospek.pegang": "Hold conversation",
  "prospek.lepas": "Release — let the bot reply again",
  "meeting.judul": "Meetings",
  "meeting.keterangan": "When you have meetings, and when you're unavailable.",
  "meeting.jadwalSaya": "My schedule",
  "meeting.ketersediaan": "My availability",
  "meeting.kapan": "When",
  "meeting.dengan": "With",
  "meeting.bentuk": "Format",
  "meeting.bersama": "Together with",
  "meeting.kosong": "No upcoming meetings.",
  "meeting.diblokir": "Blocked dates",
  "meeting.alasan": "Reason",
  "meeting.blokirKosong": "You haven't blocked any dates.",
  "konten.judul": "Content",
  "konten.keterangan": "What's scheduled, what's live, and what's waiting for review.",
  "konten.akanTayang": "Scheduled",
  "konten.sudahTayang": "Published",
  "konten.menungguTinjauan": "Awaiting review",
  "konten.menungguAnda": "Waiting on you",
  "konten.terjadwal": "Scheduled",
  "konten.setujuiKonsep": "Approve concept",
  "konten.stKonsep": "Awaiting concept approval",
  "konten.tayang": "Publishes",
  "konten.jenis": "Type",
  "konten.tujuan": "Destination",
  "konten.keadaan": "Status",
  "konten.setujui": "Approve",
  "konten.tolak": "Reject",
  "konten.kosong": "No content yet.",
  "konten.jangkauan": "Reach",
  "konten.belumTersedia": "not available yet",
  "masuk.semuaKeadaan": "All statuses",
  "masuk.hanyaBelum": "Unclaimed",
  "masuk.hanyaSaya": "Taken by me",
  "masuk.hanyaOrangLain": "Taken by others",
  "masuk.pesan": "Message",
  "hariIni.dmMenunggu": "{{n}} DMs & comments waiting for a reply",
  "app.deskripsi": "Chatbot, prospects, and content — in one place.",
  "login.selamat": "Welcome back",
  "login.lupa": "Forgot your password? Ask your company admin.",
  "login.lingkungan": "Connected to",
  "login.satuPintu": "One account for every dashboard — what you see depends on your role.",
  "login.panelJudul": "Marketing automation for your business team.",
  "login.fitur1": "DMs and comments answered automatically, grounded in your company's knowledge.",
  "login.fitur2": "Prospects are spotted, and your team is alerted on Telegram to take over.",
  "login.fitur3": "Content is drafted, approved by your team, then published on schedule.",
  "login.tampilkanSandi": "Show password",
  "masuk.balasKe": "Reply to {{nama}}",
  "masuk.tulisBalasan": "Write the reply that will be sent to Instagram…",
  "masuk.kirim": "Send reply",
  "masuk.mengirim": "Sending…",
  "masuk.langsungTerkirim": "Sends to Instagram immediately — it can't be taken back.",
  "app.smovaAdmin": "Admin",
  "adm.navTenant": "Tenants",
  "adm.navPemakaian": "Usage",
  "adm.navJalurMasuk": "Inbound",
  "adm.navKatalog": "Catalog",
  "adm.navSistem": "System",
  "adm.segera": "soon",
  "adm.belumTersedia": "Not available yet — the backend isn't built.",
  "adm.tenantJudul": "Tenants",
  "adm.tenantKeterangan": "Every client, and the door into each one's settings.",
  "adm.tenantBaru": "New tenant",
  "adm.namaTenant": "Tenant name",
  "adm.namaTenantContoh": "Client company name",
  "adm.lahirDraft": "New tenants start as 'draft': the bot stays silent and nothing is published. Move to 'test' once a test account is registered.",
  "adm.buatTenant": "Create tenant",
  "adm.membuat": "Creating…",
  "adm.belumAdaTenant": "No tenants yet.",
  "adm.kolNama": "Name",
  "adm.kolTipe": "Type",
  "adm.kolMode": "Mode",
  "adm.kolZona": "Time zone",
  "adm.kolDibuat": "Created",
  "adm.detailTenant": "Tenant detail",
  "adm.keOnboarding": "This tenant's onboarding",
  "adm.tabKoneksi": "Connection",
  "adm.tabOrang": "People",
  "adm.siapPenuh": "This tenant is ready and running normally.",
  "adm.siapTapiDibatasi": "Technically ready, but still limited by its mode.",
  "adm.belumSiap": "Can't receive DMs yet. What's missing:",
  "adm.akunPlatform": "Platform accounts",
  "adm.akunCatatan": "answers whose DM this is",
  "adm.kolPlatform": "Platform",
  "adm.kolIdAkun": "Account ID",
  "adm.kolKeadaan": "Account active?",
  "adm.aktif": "Active",
  "adm.nonaktif": "Inactive",
  "adm.aktifkan": "Activate",
  "adm.nonaktifkan": "Deactivate",
  "adm.idAkunInstagram": "Instagram account ID",
  "adm.daftarkan": "Register",
  "adm.mendaftarkan": "Registering…",
  "adm.kredensial": "Meta credentials",
  "adm.kredensialCatatan": "encrypted, never readable back",
  "adm.kolPenyedia": "Provider",
  "adm.kolJenis": "Type",
  "adm.kolKedaluwarsa": "Expires",
  "adm.kolDimuat": "Loaded",
  "adm.kedaluwarsa": "Expired",
  "adm.tokenMeta": "Meta token",
  "adm.tokenSekaliTulis": "Write once. After saving it can never be shown again — loading a new one rotates the old.",
  "adm.muatToken": "Load token",
  "adm.memuat": "Loading…",
  "adm.tokenTermuat": "Token saved and encrypted.",
  "adm.akunUji": "Test accounts",
  "adm.akunUjiCatatan": "only applies in 'test' mode",
  "adm.akunUjiKosong": "No test accounts yet. While in 'test' mode the bot won't reply to anyone.",
  "adm.tambahAkunUji": "Add test account",
  "adm.tambah": "Add",
  "adm.hapusAkunUji": "Remove from list",
  "adm.orangJudul": "People in this tenant",
  "adm.orangCatatan": "via the ordinary tenant route",
  "adm.kolPeran": "Role",
  "adm.kolTelegram": "Telegram",
  "adm.belumTertaut": "not linked",
  "adm.kolMasukTerakhir": "Last sign-in",
  "adm.akunPenjelasan": "With no active account here, Meta's webhook can't find this tenant and its DMs are recorded as 'no tenant'.",
  "adm.grupOperasi": "Operations",
  "adm.grupDataInduk": "Master data",
  "peran.smova_admin": "Smova Admin",
  "peran.tenant_admin": "Tenant Admin",
  "peran.tenant_marketing": "Tenant Marketing",
  "jm.judul": "Inbound",
  "jm.keterangan": "Every webhook that arrived, and the ones that got stuck before becoming a DM.",
  "jm.kejadian": "Events",
  "jm.semuaTenant": "All tenants",
  "jm.tanpaTenant": "No tenant",
  "jm.semuaStatus": "All statuses",
  "jm.status.diterima": "Received",
  "jm.status.diproses": "Processed",
  "jm.status.gagal": "Failed",
  "jm.status.tanpa_tenant": "No tenant",
  "jm.kolWaktu": "Time",
  "jm.kolPlatform": "Platform",
  "jm.kolAkun": "Account ID",
  "jm.kolTenant": "Tenant",
  "jm.kolStatus": "Accepted?",
  "jm.kolSebab": "Why it failed",
  "jm.kosong": "No matching events.",
  "jm.kosongKeterangan": "Try loosening the filters, or wait for the next webhook.",
  "jm.catatanIsi": "This list carries no message content. Opening it per event is possible, and every opening is recorded.",
  "jm.bukaPayload": "Open payload",
  "jm.pembukaanDicatat": "Opening this is recorded in the audit trail — who, when, and which event.",
  "pk.judul": "Usage",
  "pk.keterangan": "How much model capacity this tenant used, and by whom.",
  "pk.hari": "Last {{n}} days",
  "pk.totalPanggilan": "Model calls",
  "pk.totalToken": "Tokens used",
  "pk.perModel": "Models that replied to chats",
  "pk.belumAdaModel": "No replies with a recorded model yet.",
  "pk.kolModel": "Model",
  "pk.kolBalasan": "Replies produced",
  "pk.perHari": "By day",
  "pk.kolTanggal": "Date",
  "pk.kolJenis": "Type",
  "pk.kolPelaku": "Actor",
  "pk.kolJumlah": "Count",
  "pk.kolToken": "Tokens",
  "pk.kosong": "No usage recorded yet.",
  "pk.kosongKeterangan": "Nothing in the last {{n}} days. Try a longer range.",
  "kt.judul": "Catalog",
  "kt.keterangan": "Master data: features that can be sold, and AI models in the system.",
  "kt.tabModel": "AI models",
  "kt.tabFitur": "Features",
  "kt.fiturJudul": "Feature catalog",
  "kt.fiturCatatan": "read-only — comes from a migration",
  "kt.modelJudul": "AI models",
  "kt.modelCatatan": "level 1: what exists in the system",
  "kt.kolKunci": "Key",
  "kt.kolNama": "Name",
  "kt.kolButuh": "Requires",
  "kt.kolId": "Model ID",
  "kt.kolPenyedia": "Provider",
  "kt.kolPeran": "Role",
  "kt.kolTier": "Tier",
  "kt.kolTarif": "Rate",
  "kt.kolDipakai": "Tenants using",
  "kt.tanpaTier": "(no tier)",
  "kt.tambahModel": "Add model",
  "kt.simpanModel": "Save model",
  "kt.menambah": "Saving…",
  "kt.aktifkan": "Activate",
  "kt.nonaktifkan": "Deactivate",
  "kt.tarifKosong": "not set",
  "app.tenantAdmin": "Tenant Admin",
  "ta.navFitur": "Features",
  "ta.navModel": "AI models",
  "ta.fiturJudul": "Features",
  "ta.fiturKeterangan": "What's live for your company.",
  "ta.fiturCatatan": "Features that depend on each other can't be switched independently — the system refuses orders that don't make sense instead of allowing them and failing silently.",
  "ta.kolFitur": "Feature",
  "ta.kolButuh": "Requires",
  "ta.kolKeadaan": "On?",
  "ta.kolAktif": "Active?",
  "ta.kolAkunAktif": "Account active?",
  "ta.kolDipakaiBot": "Used by bot",
  "ta.hidup": "On",
  "ta.mati": "Off",
  "ta.nyalakan": "Turn on",
  "ta.matikan": "Turn off",
  "ta.modelJudul": "AI models",
  "ta.modelKeterangan": "Which models may be used, and in what order.",
  "ta.urutanCadangan": "order = fallback chain",
  "ta.belumAdaModel": "No models selected. Without these, that path uses the system defaults.",
  "ta.tambahkan": "Add",
  "ta.buang": "Remove",
  "ta.naik": "Move up",
  "ta.turun": "Move down",
  "ta.peranChat": "Chatbot — replying to DMs & comments",
  "ta.peranText": "Text — captions & content concepts",
  "ta.peranImage": "Image — content photos",
  "ta.peranVideo": "Video — content videos",
  "pk.totalBiaya": "Cost (USD)",
  "pk.kolBiaya": "Cost",
  "pk.biayaBelumLengkap": "{{n}} calls have no rate in the catalog, so the cost on this page is a LOWER BOUND — not a total. Fill in those models' rates on the Catalog screen to complete it.",
  "kt.kolKeadaan": "Still offered?",
  "kt.fiturDitawarkan": "offered",
  "kt.fiturDitarik": "withdrawn",
  "tk.judul": "Content",
  "tk.keterangan": "Outbound content chain settings — from finding material through to the upload.",
  "tk.scrapingJudul": "Sources & topics",
  "tk.scrapingCatatan": "Source material for the concepts the AI drafts.",
  "tk.scrapingMati": "Trend scraping is switched off, so its settings are hidden. Turn it on from the Features screen if you want it — the settings come back exactly as they were, nothing is lost.",
  "tk.kolTopik": "Topics",
  "tk.topikCatatan": "Separate with commas.",
  "tk.kolJadwal": "Schedule (cron)",
  "tk.jadwalCatatan": "When trends are fetched.",
  "tk.otomatis": "automatic, unreviewed",
  "umum.menyimpan": "Saving…",
  "ta.navKonten": "Content setup",
  "fp.judul": "Profile fields",
  "fp.keterangan": "The questions the bot asks prospects. Takes effect on the next conversation, no deploy.",
  "fp.daftarJudul": "Data the bot collects",
  "fp.tambah": "Add field",
  "fp.simpanField": "Save field",
  "fp.kolKunci": "Data name",
  "fp.kolLabel": "What the bot asks",
  "fp.kolTipe": "Type",
  "fp.kolWajib": "Required",
  "fp.kolTerisi": "Filled in",
  "fp.kolKeadaan": "Still asked",
  "fp.wajib": "Required",
  "fp.opsional": "Optional",
  "fp.ditanyakan": "Yes",
  "fp.tidakLagi": "No longer",
  "fp.matikan": "Switch off",
  "fp.nyalakan": "Switch on",
  "fp.bawaan": "built-in",
  "fp.kunciCatatan": "The key is this field's permanent identity and cannot be changed — the question itself can be edited any time. If the key changed too, every answer already collected would lose its place.",
  "ta.navField": "Profile fields",
  "adm.tabIkhtisar": "Overview",
  "adm.tabAlur": "Message flow",
  "adm.tabPengaturan": "Settings",
  "adm.tabPengetahuan": "Knowledge",
  "adm.tabAktivitas": "Activity",
  "adm.ikhPanggilan": "Model calls (30d)",
  "adm.ikhToken": "Tokens (30d)",
  "adm.ikhBiaya": "Cost (30d)",
  "adm.ikhKurangJudul": "Not yet complete",
  "adm.ikhKurangCatatan": "What still keeps this tenant from running fully.",
  "adm.ikhFiturJudul": "Switched-off features",
  "adm.ikhFiturCatatan": "The ones that are on aren't listed — the ones that are off explain the behaviour.",
  "adm.ikhSemuaNyala": "Every feature is on.",
  "adm.alurCatatan": "Webhooks that reached this tenant, newest first.",
  "adm.alurKosong": "No webhooks have arrived yet.",
  "adm.alurKosongKet": "If the bot isn't replying and this list is empty, the problem is upstream of this system — check the connection.",
  "adm.setCatatan": "Read-only. Editing belongs to the tenant admin — an operator changing a client's settings without the client knowing is a change nobody can explain later.",
  "adm.kolSetelan": "Setting",
  "adm.kolNilai": "Value",
  "adm.setJadwal": "Scraping schedule",
  "adm.setTopik": "Topics",
  "adm.setBalasOtomatis": "Auto-reply",
  "adm.setAkunUji": "Test accounts",
  "adm.pengCatatan": "Titles and state only. Contents aren't shown — documents can hold pricing and contract terms.",
  "adm.pengKosong": "No knowledge documents yet.",
  "adm.pengKosongKet": "The bot will answer with nothing to draw on. Load the documents first.",
  "adm.kolDokumen": "Document",
  "adm.kolVersi": "Version",
  "adm.kolPotongan": "Chunks",
  "adm.kolDipakaiBot": "Used by bot",
  "adm.belumDiproses": "not processed",
  "adm.kolPanjang": "Length",
  "adm.aktCatatan": "The last 50 changes in this tenant.",
  "adm.aktKosong": "No changes recorded yet.",
  "adm.kolObjek": "What changed",
  "adm.kolAksi": "Action",
  "adm.kolPelaku": "Who",
  "adm.kolPerubahan": "Change",
  "adm.kolWaktu": "Time",
  "adm.kolDiterima": "Accepted?",
  "adm.kolAkun": "Account",
  "sis.judul": "System",
  "sis.keterangan": "Service health and Smova operator accounts.",
  "sis.periksaJudul": "Checks",
  "sis.periksaCatatan": "All from the database already at hand — no outbound calls, so opening this page burns nobody's quota.",
  "sis.kolPeriksa": "Check",
  "sis.kolNilai": "Value",
  "sis.kolArti": "What it means",
  "sis.operatorJudul": "Smova operators",
  "sis.operatorCatatan": "Accounts with the smova_admin role — the ones who can see every tenant.",
  "sis.operatorKosong": "No operator accounts yet.",
  "sis.kolNama": "Username",
  "sis.kolPeran": "Role",
  "sis.kolMasukTerakhir": "Last login",
  "sis.belumPernahMasuk": "never logged in",
  "sis.kolKeadaan": "Account active?",
  "sb.platformJudul": "Platform accounts",
  "sb.platformCatatan": "Each platform can do different things — not one switch.",
  "sb.platformKaki": "“Not built” doesn't mean missing: the adapter simply doesn't exist yet, so registering an account now would only create a row that does nothing. Planned order: Facebook Page → LinkedIn → TikTok.",
  "sb.kolPlatform": "Platform",
  "sb.kolAkun": "Account",
  "sb.belumDihubungkan": "not connected",
  "sb.kap.bisa": "yes",
  "sb.kap.tidak_bisa": "no",
  "sb.kap.belum_dibangun": "not built",
  "sb.grupJudul": "Telegram group",
  "sb.grupCatatan": "Where team notifications go. This chat_id is what decides which tenant a Telegram message belongs to.",
  "sb.tambahGrup": "Add group",
  "sb.simpanGrup": "Save group",
  "sb.kolChatId": "Chat ID",
  "sb.kolLabel": "Label",
  "sb.kolKeadaan": "Active?",
  "sb.kolBisa": "Supported?",
  "sb.chatIdCatatan": "A group chat_id is always negative, e.g. -1001234567890. Get it by adding the bot to the group and reading its webhook log. One group may belong to only one tenant.",
  "sb.grupKosong": "No Telegram group yet.",
  "sb.grupKosongKet": "Without a group the team receives no notifications at all — prospects arrive and nobody knows.",
  "ta2.judul": "Add account",
  "ta2.catatan": "One flow: pick the platform, the fields adapt.",
  "ta2.platform": "Platform",
  "ta2.idAkun": "{{platform}} account ID",
  "ta2.token": "{{provider}} token",
  "ta2.tokenCatatan": "Write-once. No screen can read it back, and its value never enters the audit log — only the event does.",
  "ta2.tokenSudahAda": "The {{provider}} token already exists and is shared by every platform on this provider, so it isn't asked for again. Replacing it is a rotation — a separate, deliberate action in the Credentials panel.",
  "ta2.terkunci": "{{platform}} has no adapter yet, so registering an account now would only create a row that does nothing — DMs wouldn't be processed and the failure would surface only when the first message arrives. Planned order: Facebook Page → LinkedIn → TikTok.",
  "ta2.sambungkan": "Connect",
  "sesi.rusakJudul": "This session can't be trusted",
  "sesi.rusakKeterangan": "The role on this session isn't recognised ({{peran}}), so no dashboard can be shown without guessing — and guessing means showing the wrong client's data. Signing out and back in fixes it.",
  "sesi.tanpaPeran": "empty",
  "sesi.keluarMasuk": "Sign out and back in",
  "ta.grupKerja": "Work",
  "ta.grupBot": "Bot settings",
  "ta.grupPerusahaan": "Company",
  "ta.navBeranda": "Home",
  "ta.navChatbot": "Chatbot",
  "ta.navMeeting": "Meeting",
  "ta.navPengetahuan": "Knowledge",
  "ta.navSambungan": "Connections",
  "ta.navTim": "Team",
  "ta.navPemakaian": "Usage",
  "ta.tabFitur": "Features",
  "ta.tabPersona": "Persona & policy",
  "ta.tabDataProspek": "Prospect data",
  "ta.tabJadwalBalas": "Reply hours",
  "ta.tabModel": "Models",
  "ta.tabJadwalMeeting": "Hours & days",
  "ta.tabLibur": "Holidays",
  "ta.personaBelum": "The bot's persona and policy still live in code (app/ai/prompts/percakapan.py) and can't be edited here yet. Shown so it's clear this is planned, not missing — changing it today needs a deploy.",
  "ta.jadwal.chatbot": "When the bot replies",
  "ta.jadwal.meeting": "When meetings may be offered",
  "ta.jadwal.content": "Content hours",
  "ta.jadwalCatatan.chatbot": "Outside these hours the bot stays SILENT. Messages still queue and stay visible to the team.",
  "ta.jadwalCatatan.meeting": "Only these days and hours are offered when the bot schedules.",
  "ta.jadwalCatatan.content": "When the content chain may run.",
  "ta.jadwalMode": "Mode",
  "ta.modeAlways": "Always — unrestricted",
  "ta.modeWeekly": "Weekly schedule",
  "ta.jadwalHari": "Days",
  "ta.jadwalMulai": "From",
  "ta.jadwalSelesai": "Until",
  "ta.hariKosong": "No days selected — that means NEVER on, not back to default.",
  "ta.liburJudul": "One-off holidays",
  "ta.tambahLibur": "Add",
  "ta.hapus": "Delete",
  "ta.kolTanggal": "Date",
  "ta.kolKeterangan": "Note",
  "ta.liburKosong": "No holidays yet.",
  "ta.liburKosongKet": "Without these, the bot offers public holidays like any working day.",
  "ta.pengJudul": "Knowledge documents",
  "ta.pengCatatan": "What the bot draws on. Contents aren't shown.",
  "ta.pengKosong": "No documents yet.",
  "ta.pengKosongKet": "The bot will answer with nothing to draw on — and it will still answer, confidently.",
  "ta.pengRingkas": "{{aktif}} active of {{total}} documents.",
  "ta.pengUnggahBelum": "Uploading documents from this screen doesn't exist yet — loading still goes through files. Shown so it's clear this is planned, not missing.",
  "ta.kolDokumen": "Document",
  "ta.kolVersi": "Version",
  "ta.kolPanjang": "Length",
  "ta.berandaJudul": "Waiting for you",
  "ta.berandaCatatan": "A task list, not numbers. Anything already done isn't listed.",
  "ta.tidakAdaTugas": "Nothing is held up.",
  "ta.tidakAdaTugasKet": "The bot runs on the settings you've chosen.",
  "ta.tugasPengetahuan": "No knowledge documents yet",
  "ta.tugasPengetahuanKet": "The bot answers with nothing to draw on — and it still answers. Load the documents first.",
  "ta.tugasFitur": "{{n}} features are switched off",
  "ta.tugasJadwal": "No schedule set yet",
  "ta.tugasJadwalKet": "The bot replies and offers meetings at any hour, including the middle of the night.",
  "ta.timJudul": "Team",
  "ta.timCatatan": "Who can sign in, their role, and Telegram linking.",
  "ta.timKosong": "No people yet.",
  "ta.belumTertaut": "not linked",
  "ta.kolNama": "Name",
  "ta.kolPeran": "Role",
  "ta.kolTelegram": "Telegram",
  "ta.sambunganJudul": "Connections",
  "ta.sambunganCatatan": "This tenant's platform accounts.",
  "ta.sambunganBelum": "Connecting your own account from here isn't available yet. The design: you sign in with your own Meta account, so the credential never passes through our hands.",
  "ta.sambunganSementara": "For now, connecting is done by a Smova operator from their console. Contact us with your Instagram account ID.",
  "ta.pemakaianJudul": "Usage",
  "ta.pemakaianKeterangan": "What's been used this month. The limit is set by Smova.",
  "ta.biayaBatasBawah": "{{n}} calls have no rate in the catalog, so the cost above is a LOWER BOUND — not a total.",
  "konten.bahan": "Material",
  "konten.buatKonten": "Create content",
  "bh.judul": "Scraped material",
  "bh.catatan": "Why automatic content picked a particular story — the answer is in the reason column.",
  "bh.cariSekarang": "Fetch material now",
  "bh.mencari": "Fetching…",
  "bh.kolJudul": "Title",
  "bh.kolKataKunci": "Keyword",
  "bh.kolSkor": "Score",
  "bh.kolAlasan": "Why that score",
  "bh.kolWaktu": "Fetched",
  "bh.kosong": "No material yet.",
  "bh.kosongKet": "Scraping runs on schedule, or press Fetch material now. If it's still empty after that, the source key isn't filled in.",
  "bh.kaki": "Low scores aren't discarded, only dimmed — you can still use those rows. Machine scoring is good at picking the average; you're the one who knows a low-scoring story happens to involve a major prospect this week. The site name in the title is the article's publisher, not the search source.",
  "bk.judulInternal": "Internal title",
  "bk.judulCatatan": "For you and the team — not published.",
  "bk.jenis": "Type",
  "bk.foto": "Photo",
  "bk.video": "Video",
  "bk.caption": "Caption",
  "bk.pesanKunci": "Key message",
  "bk.hashtag": "Hashtags",
  "bk.promptGambar": "Image prompt",
  "bk.simpan": "Save & schedule",
  "bk.tersimpan": "\"{{judul}}\" scheduled for {{n}} target(s). No concept review — you wrote it.",
  "bk.grupIsi": "Content",
  "bk.grupGambar": "Image",
  "bk.grupKapan": "When & where",
  "bk.dariJudul": "Generate from title",
  "bk.buatkan": "Generate",
  "bk.dariCaption": "Generate from caption",
  "bk.templateLabel": "Image kind",
  "bk.templateBawaan": "Company default (set by admin)",
  "bk.templateOpsiFoto": "{{nama}} — Photo, no lettering in the image",
  "bk.templateOpsiPoster": "{{nama}} — Poster, with headline & CTA in the image",
  "bk.templateKet": "Decides the style of prompt the AI writes. “Photo” = a plain image, the words live in the caption. “Poster” = headline, subheadline and a CTA button are drawn inside the image. Kinds are set by your admin under Content settings › Prompt templates.",
  "bk.dikirimJudul": "See what was sent to the AI ({{gambar}} images attached)",
  "bk.bagianBahan": "Source images",
  "bk.bagianBrief": "Brief for the AI",
  "bk.bagianModel": "Model & ratio",
  "bk.bagianSlide": "Image per slide",
  "bk.bagianModelKet": "Applies to every slide — a carousel with a different model per slide does not read as one piece.",
  "bk.briefLabel": "Brief for the AI",
  "bk.briefContoh": "e.g. Use this template as the background, do not redraw the logo. Large headline + CTA button in the empty centre.",
  "bk.briefKet": "Your instructions to the AI that writes the prompt — this matters most. You may leave it empty; the AI will then use only your caption and the images you picked.",
  "bk.briefHitung": "{{jumlah}} / {{maks}} words",
  "bk.briefLebih": "Shorten the brief before generating a prompt.",
  "bk.promptSemuaSlide": "Generate prompts for all slides",
  "bk.promptSedang": "Writing the prompt…",
  "bk.bahanDiabaikan": "The images you picked were NOT seen by the AI: this tenant's text model does not accept image input. The prompt was written from the caption and brief only. Ask your admin to pick a text model that accepts images.",
  "bk.timpaCaption": "The caption you edited will be replaced by this option. Continue?",
  "bk.sudut.masalah": "Starts from the problem",
  "bk.sudut.angka": "Starts from the number",
  "bk.sudut.cerita": "Starts from a person's story",
  "bk.promptDariCaption": "Generate prompt from caption",
  "bk.promptMasihMelanggar": "The prompt was written, but still breaks the rules below. Fix it before generating — or generate the prompt again.",
  "bk.promptCaption": "Write one Indonesian Instagram caption for content titled \"{{judul}}\". At most 3 sentences, no hashtags, minimal emoji. Reply with the caption only.",
  "bk.promptPesan": "From this caption, write ONE sentence capturing the key message. Reply with the sentence only.\n\n{{caption}}",
  "bk.promptHashtag": "From this caption, produce 3-5 relevant Indonesian hashtags. Reply with hashtags only, space-separated, each starting with #.\n\n{{caption}}",
  "bk.promptPrompt": "From this caption, write one English image prompt for a supporting illustration. No text inside the image. Reply with the prompt only.\n\n{{caption}}",
  "bk.model": "Model",
  "bk.modelBawaan": "Use tenant default",
  "bk.modelBawaanCatatan": "Admin's order; the next one is used if it fails",
  "bk.modelTanpaTarif": "price unknown",
  "bk.modelCatatan": "Only from what your company admin allows. More expensive isn't always a better fit — for a consistent brand look, reusing the same model usually beats picking the best one.",
  "bk.buatGambar": "Generate image now",
  "bk.membuatGambar": "Generating…",
  "bk.gambarSiap": "Image ready — it's saved when you schedule.",
  "bk.tanggalJam": "Date & time",
  "bk.tanggalCatatan": "Leave empty to use the next publishing slot.",
  "bk.tujuan": "Targets",
  "bk.igFeed": "Instagram Feed",
  "bk.igReels": "Instagram Reels",
  "bk.fbPage": "Facebook Page",
  "bk.tujuanCatatan": "One piece of content, several targets — same caption and image. One queue row per target, because each platform can fail on its own.",
  "bk.simpanDraf": "Save as draft",
  "bk.alurCatatan": "appears under \"Upcoming\", publishes itself at its time",
  "bk.tersimpanDraf": "\"{{judul}}\" saved as a draft for {{n}} target(s). It won't enter the schedule and won't publish.",
  "bk.spanduk": "Content you create goes straight into the schedule, with no review queue",
  "bk.spandukIsi": "You made it, so you reviewed it the moment you pressed save. The review gate exists for automatic content — the kind with nobody present when it was made. Adding a gate here only produces a queue row waiting on the approval of the person who just wrote it.",
  "bk.spandukModel": "You can choose the model per piece, but only from what your company admin allows. More expensive isn't always a better fit — for a consistent brand look, reusing the same model usually beats reaching for the best one.",
  "bk.tigaPilihan": "Generate 3 options",
  "bk.pilihSatu": "Pick one — caption, key message and hashtags all change with it",
  "bk.promptTiga": "Write 3 Indonesian Instagram caption options for content titled \"{{judul}}\". Each at most 3 sentences, no hashtags, minimal emoji. Reply ONLY as a numbered list 1. 2. 3. — one caption per line, no commentary.",
  "bk.hargaSetelah": "cost shown after generating",
  "bk.modelTeksKosong": "Your company admin hasn't picked a text model. The generate buttons still work, using the default chain.",
  "bk.modelKosong": "Your company admin hasn't picked a model for this content type, so there is nothing to choose per piece yet. The system uses the default chain.",
  "bk.grupVideo": "Video",
  "bk.buatVideo": "Generate video now",
  "bk.hasil": "Result",
  "bk.hasilKosong": "No image yet. Content can be saved without one, but it won't publish until there is — the publisher rejects rows with an empty media_url.",
  "bk.alurJudul": "Save & schedule:",
  "bk.stBaru": "new",
  "bk.alurDraf": "\"Save as draft\" never enters the schedule and will not publish.",
  "bk.belumJudul": "Three parts of the design have nowhere to live yet",
  "bk.belumIsi": "Caption, key message, type, schedule and targets already have their columns in content_queue. Image references are a different kind: they are input, not output — they need file storage and a table of their own. A carousel needs two things: somewhere to store its editorial order, and a carousel publish path — today ig_publish() takes a single URL. Per-model pricing before you choose is also absent, because the model list deliberately carries no tariff; cost only becomes visible once the image is generated.",
  "ta.chatbotJudul": "Chatbot",
  "ta.chatbotKeterangan": "How the bot behaves: what is switched on, what it collects, when it replies, and which model writes those replies.",
  "ta.personaJudul": "Persona & policy can't be edited from here yet",
  "ta.meetingKeterangan": "When the bot may offer a meeting, and the dates it must never offer at all.",
  "ta.timHitung": "{{n}} people",
  "ta.akunMedsos": "Social accounts",
  "tk.tabBahan": "Find material",
  "tk.tabSlot": "Publish schedule",
  "tk.tabGerbang": "Automation",
  "tk.tabModel": "Models",
  "tk.slotJudul": "Publish slots",
  "tk.slotCatatan": "{{n}} posts per day",
  "tk.slotKosong": "No slots yet. Without a slot, the automatic content chain produces nothing.",
  "tk.slotTambah": "+ Add slot",
  "tk.slotSimpanCatatan": "Posts per day follows the number of slots — it isn't set separately.",
  "tk.modelBiayaJudul": "The image model shows up in cost, the caption model shows up in quality",
  "tk.modelBiayaIsi": "One image costs many times what one caption costs, so switching image model moves your monthly budget far faster. A weak caption, by contrast, is read by your customers — not by your invoice.",
  "meeting.klikUntukBlokir": "click a date to block it",
  "meeting.blokirSaya": "Blocked by me",
  "meeting.blokirTim": "Blocked by a colleague",
  "meeting.adaMeeting": "Meeting booked",
  "meeting.alasanCatatan": "Used for the next block you create. May be left empty.",
  "meeting.diblokirHitung": "{{n}} dates I blocked",
  "meeting.bukaBlokir": "Unblock",
  "meeting.blokirKosongKet": "While this is empty, the bot may offer any working day to a prospect.",
  "meeting.bentrokJudul": "You blocked {{tanggal}}, but there is a meeting that day",
  "meeting.bentrokIsi": "That meeting was agreed before this block was made. Blocking a date does not cancel an existing meeting — it only stops new offers. Move the meeting or remove the block.",
  "meeting.hariKerjaJudul": "Weekends are not disabled here",
  "meeting.hariKerjaIsi": "Working days come from the meeting feature schedule your company admin sets, and this screen isn't allowed to read it yet. So every date is clickable — blocking a day that isn't a working day breaks nothing, it is merely redundant.",
  "meeting.kosongKet": "Meetings are created from the prospect's page — that is where the context is.",
  "bk.referensi": "Image references",
  "bk.refTambah": "+ Add",
  "bk.refMengunggah": "Uploading…",
  "bk.refBuang": "Retire this reference",
  "bk.refUrutan": "Reference order",
  "bk.refUrutanKe": "Reference #{{n}}",
  "bk.refNaikkan": "Move earlier",
  "bk.refTurunkan": "Move later",
  "bk.refHilang": "(reference no longer exists)",
  "bk.refBrand": "B",
  "bk.refBrandKet": "Brand material — stays at the top instead of sinking",
  "bk.refJadikanBrand": "Mark as brand material (logo, product, palette)",
  "bk.refJadikanSekali": "Turn back into one-off material",
  "bk.refUrutanCatatan": "Order matters: image 1 is read by the model first. Change it with ↑ ↓.",
  "bk.refCatatan": "Click to use it. Click order is the order the AI reads — four sources at most.",
  "bk.refBawaanTakBisa": "None of the image models your admin selected accept references. Ask your admin to add one that does, or clear the references.",
  "bk.refModelSalah": "References are selected, but the image model does not accept image input. Pick {{model}}, or clear the references — otherwise generation will be refused.",
  "sb.spanduk": "Connecting an account is done with the tenant, not quietly on their behalf",
  "sb.spandukIsi": "What stays ours: social_accounts.external_account_id is globally unique and decides which tenant a Meta webhook lands in. A wrong link there breaks another tenant's routing — so we must always be able to see it, test it, and revoke it.",
  "sb.uji": "Test connection",
  "sb.kredJudul": "Credentials",
  "sb.kredCatatan": "tenant_credentials · pgcrypto",
  "sb.kredKosong": "No credentials yet",
  "sb.kredKosongKet": "While this is empty, no platform can be reached on this tenant's behalf.",
  "sb.kredKaki": "Values are never shown, not even masked. They are pgcrypto-encrypted and Python genuinely cannot read them — this screen follows that boundary rather than fighting it. Rotated rows are shown on purpose: a replaced token isn't gone, it stopped being used.",
  "sb.kolPenyedia": "Provider",
  "sb.kolDiisi": "Filled",
  "sb.kolKedaluwarsa": "Expires",
  "ta.luarJamJudul": "Outside those hours, what does the bot do?",
  "ta.luarJamTakBerlaku": "The schedule is set to “Always”, so there are no off-hours — the settings below do not apply right now and will never be sent. The value is still saved, and applies again once the schedule is set back to Weekly.",
  "ta.luarJamDiam": "Stay silent",
  "ta.luarJamBalas": "Send a short reply",
  "ta.luarJamTeks": "The reply text",
  "ta.luarJamCatatan": "This is the most often skipped choice, and the one people feel most. \"Stay silent\" means someone sends a DM at 9pm and gets nothing back — from their side, that is indistinguishable from being ignored. The conversation still reaches the team queue either way; what changes is only whether the sender knows their message arrived.",
  "ta.luarJamBawaan": "What you see now is Smova's default text. Saving creates a copy owned by your company — the default does not change for other clients.",
  "pk.keMana": "Where it went",
  "pk.keManaCatatan": "by activity, not by model",
  "pk.kolKegiatan": "Activity",
  "pk.tanpaTarif": "{{n}} calls with an unknown rate",
  "sb.gantiToken": "Replace token",
  "sb.gantiJudul": "Replacing the {{provider}} token",
  "sb.gantiPeringatan": "The old token is marked 'rotated' and stops being used immediately — it is not deleted, so there is still a record of when it stopped. If this new token is wrong, the connection stays down until you replace it again. Other providers are untouched.",
  "sb.tokenBaru": "New token",
  "sb.panjangToken": "{{n}} characters — a Facebook Page token is usually 190–250, Instagram around 185",
  "sb.kedaluwarsaOpsional": "Expires (optional)",
  "sb.kedaluwarsaCatatan": "Fill this in if the token has a deadline. Leave it empty if debug_token says 'Never'. What is filled in can be warned about before it dies; what is empty cannot.",
  "sb.simpanToken": "Save token",
  "ta.akunMedsosCatatan": "{{n}} connected",
  "ta.kolTerbit": "Publish",
  "ta.sambunganSiapa": "Adding and revoking accounts is done by the Smova operator. An account ID is globally unique and decides which tenant a Meta message lands in — a wrong link there breaks another tenant, so the button deliberately isn't here.",
  "ta.grupCatatanTenant": "where your team's notifications go",
  "ta.grupKosongTenant": "Without a group, notifications fall back to Smova's default group — your team will not receive them. Ask the Smova operator to register your group.",
  "ta.sambunganRencanaJudul": "Later you will connect this yourself",
  "ta.sambunganRencana": "The plan is one Meta app under Seleris, with you doing OAuth from this screen using your own Meta account — so your credentials never pass through our hands. That flow isn't built yet; until it is, connecting is done by the operator and the token does pass through us.",
  "ta.identitasJudul": "Bot identity",
  "ta.namaBot": "Bot name",
  "ta.namaBotCatatan": "The name it gives when introducing itself.",
  "ta.atasNama": "On behalf of",
  "ta.atasNamaCatatan": "The company it represents. This is what your customers read.",
  "ta.bidang": "Field",
  "ta.bidangCatatan": "One sentence: what your company does. Used when the bot explains itself.",
  "ta.emailRujukan": "Reference email",
  "ta.emailRujukanCatatan": "If filled in, the bot may not name any other email address. Leave empty if there is none.",
  "ta.gayaBahasa": "Tone",
  "ta.gayaFormal": "Formal",
  "ta.gayaRamah": "Friendly",
  "ta.gayaSantai": "Casual",
  "ta.kebijakanJudul": "Business policy",
  "ta.melayani": "Serves",
  "ta.b2b": "B2B only",
  "ta.b2c": "B2C only",
  "ta.keduanya": "Both",
  "ta.melayaniCatatan": "Decides how the bot answers someone outside your target.",
  "ta.demoTrial": "Demo / trial",
  "ta.demoMeeting": "Only during a meeting",
  "ta.demoMandiri": "Self-serve allowed",
  "ta.catatanKhusus": "Special notes",
  "ta.catatanKhususCatatan": "Extra rules the bot must obey. Appended at the end of the instructions, above every conversation stage.",
  "ta.personaBerlaku": "Takes effect on the next reply — there is no cache.",
  "ta.pratinjauJudul": "What the bot actually reads",
  "ta.pratinjauCatatan": "assembled by the backend, not a mock-up",
  "ta.pratinjauLama": "This is the currently saved value. Save first to see the effect of your changes.",
  "ta.pagarJudul": "Safety rails",
  "ta.pagarIsi": "The bot always admits to being a virtual assistant when asked, and may never claim to be human even under pressure. That rule lives in the code and is deliberately not offered as an option — a bot allowed to lie about itself is a risk that should not be switchable from a screen.",
  "ta.tabSyarat": "Conditions & format",
  "ta.syaratJudul": "Before the bot offers a meeting",
  "ta.dataLengkap": "Required data",
  "ta.dataLengkapCatatan": "The bot won't offer a meeting until these fields are filled. Clear them all for no condition. The list follows Profile Fields — a field you disable disappears here on its own.",
  "ta.tidakAdaField": "No active profile fields yet. Set them up under the Prospect data tab.",
  "ta.minatMinimal": "Minimum interest",
  "ta.minatCatatan": "Scale 1–5. Higher means the bot offers meetings less often — but the ones it offers are more ready.",
  "ta.jedaHari": "Earliest gap",
  "ta.jedaCatatan": "How many days ahead the earliest offer may be. 0 means today.",
  "ta.durasi": "Duration",
  "ta.bentukJudul": "Meeting format",
  "ta.format": "Format",
  "ta.onlineSaja": "Online only",
  "ta.offlineSaja": "In person only",
  "ta.lokasiOffline": "In-person location",
  "ta.lokasiCatatan": "The address the bot names when offering to meet in person.",
  "ta.lokasiWajib": "A format that includes meeting in person needs a location — without one the bot offers a meeting with no place to name.",
  "tk.tiapJam": "every {{n}} hours",
  "tk.mulaiJam": "starting at",
  "tk.cronAsing": "This schedule was written outside this screen and its shape isn't recognised. It keeps running as-is — this screen will not change it silently. Press the button below if you want to replace it with a normal schedule.",
  "tk.pakaiJadwalBiasa": "Replace with a normal schedule",
  "umum.tidakCocok": "Nothing matches",
  "bh.cariPlaceholder": "Search title, keyword, or reason…",
  "bh.tidakCocok": "No material matches",
  "bh.buatDariIni": "Create content",
  "bk.dariBahan": "Created from material: {{judul}}",
  "bk.dariBahanIsi": "The title is filled in as the internal title, and the image prompt is seeded from why the machine picked it: {{alasan}}. The caption is deliberately left empty — a news headline is an editorial summary, not a sentence that greets a reader. Press \"Generate from title\" to write one.",
  "bk.collaseAktif": "carousel · {{n}} slides",
  "bk.collaseBiaya": "Each slide is billed separately — a {{n}}-slide carousel costs {{n}} times one image. Images are also the first thing stopped when the budget is reached.",
  "bk.slideKosong": "no image yet",
  "bk.slidePertama": "shown in the feed",
  "bk.slidePrompt": "What should this slide show?",
  "bk.tambahSlide": "+ Add slide",
  "bk.slideRingkas": "{{jadi}} of {{total}} slides have an image",
  "bk.slideMaks": "Maximum {{n}} slides — that is Instagram's limit, not ours.",
  "bk.buatUlang": "Regenerate",
  "bk.ubahGambar": "Edit",
  "bk.ubahApa": "What should change? e.g. make the background dark blue",
  "bk.ubahKet": "Only the selected image and this sentence are sent. Brand references and the prompt above are NOT included — including them blends the result and can alter text inside the image.",
  "bk.ubahTakBisa": "This image came from older content, so it cannot be edited yet. Regenerate or re-upload it first.",
  "bk.hasilDeret": "What will be edited",
  "bk.hasilKe": "Result #{{n}}",
  "bk.hasilKet": "The outlined thumbnail is what Edit uses. Every new result lands here — click one to go back if the text starts to soften.",
  "sb.tukarJudul": "Exchange the Meta token for a long-lived one",
  "sb.tukarCatatan": "once, then it stops dying",
  "sb.tukarIsi": "Paste the USER token from Graph API Explorer — not the Page token. We exchange it for a long-lived one on the server (the exchange needs the app secret, which must never pass through a browser), then fetch the Page token via the already-registered Page ID. Pages owned by a Business Portfolio do not appear in /me/accounts, so this is the path we use — not the page list.",
  "sb.tokenPengguna": "User token",
  "sb.pageIdOpsional": "Page ID (optional)",
  "sb.pageIdCatatan": "Leave empty — we use the Page ID already registered for this tenant. Fill it in only if the Page differs from the registered one.",
  "sb.tukarSekarang": "Exchange & save",
  "sb.menukar": "Exchanging…",
  "sb.tukarBerhasil": "Saved — Page {{nama}}",
  "sb.tukarAbadi": "The Page token has no expiry. It stops only if you revoke the app's access in Facebook settings.",
  "sb.tukarMasihBerbatas": "The Page token STILL has a deadline: {{tanggal}}. It will die then and the Facebook connection stops without warning.",
  "sb.tukarSebabnya": "The cause is in the exchange step: the resulting user token also has a deadline ({{tanggal}}) when it should be long-lived. Usually this means the pasted token had already been exchanged once — take a genuinely fresh token from Graph API Explorer, not one you already used.",
  "bk.refTerlaluBesar": "That file is {{ukuran}} MB — the limit is {{maks}} MB. Shrink it first. A reference is sent to the model on every image generation, so a large one is billed over and over.",
  "bk.refDikecilkan": "The image was downscaled before upload: {{lebar}}×{{tinggi}} → {{lebarBaru}}×{{tinggiBaru}}, {{dari}} MB → {{jadi}} KB. A reference is sent to the model on every image generation, so a large one is billed over and over — and the model downscales it internally anyway.",
  "ta.timBelumTertaut": "{{n}} people have not linked Telegram — buttons in the group will reject them. Notifications are still readable; it is the buttons that stop working.",
  "ta.timSiapa": "added by Smova, linked by you",
  "ta.saringSemua": "All",
  "ta.saringBelum": "Not linked",
  "ta.saringSudah": "Linked",
  "ta.kolKode": "/join code",
  "ta.terbitkanKode": "Issue code",
  "ta.kodeBaru": "valid until {{sampai}}",
  "ta.kodeLama": "existing code · valid until {{sampai}}",
  "ta.kodeSatuOrangJudul": "The code belongs to ONE person, and is single-use",
  "ta.kodeSatuOrangIsi": "Not one shared code for the whole team — a shared code means anyone who sees it can link themselves as a member of your team. Give the code to the person, then they type /join CODE once in the Telegram group. The tenant comes from the group they type in, not from the code; the code only matches.",
  "pk.bulanIni": "This month",
  "pk.hariTersisa": "{{n}} days left",
  "pk.dariPagu": "of {{pagu}}",
  "pk.persenTerpakai": "{{n}}% used",
  "pk.tanpaPagu": "No budget",
  "pk.tanpaPaguCatatan": "This tenant has no spending budget, so nothing will stop it. Contact Smova if you want a limit set.",
  "pk.ambangCatatan": "You are notified at {{n}}%. The budget cannot be raised by you — contact Smova if you need more.",
  "pk.dihentikan": "Already stopped now: {{daftar}}",
  "pk.urutanJudul": "If the budget is hit, things stop in order",
  "pk.urutanIsi": "Images and video stop first, then content drafting, and replies to your customers last — because nobody is waiting on the other end when scheduled work stops, while the chatbot faces your clients' customers.",
  "ta.tabKetersediaan": "Team availability",
  "ta.rosterJudul": "Who can be assigned",
  "ta.rosterCatatan": "each person marks their own dates",
  "ta.rosterKosong": "No team members yet",
  "ta.rosterKosongKet": "People are added by Smova. Contact us to add team members.",
  "ta.rosterNolBisa": "No team member can be assigned — the bot stops offering meetings entirely, with no error at all. Enable at least one person.",
  "ta.kolBolehDitugaskan": "Can be assigned",
  "ta.kolDiblokir": "Blocked dates",
  "ta.kolMeetingBulanIni": "Meetings this month",
  "ta.nHari": "{{n}} days",
  "ta.rosterSatuSumberJudul": "The bot offers only genuinely free dates",
  "ta.rosterSatuSumberIsi": "Availability comes from the dates each team member marks, minus holidays, minus meetings already booked. One calculation for everything — no feature computes its own.",
  "ta.jedaMenit": "Gap between meetings",
  "ta.jedaMenitCatatan": "Breathing room between two meetings on the same day. Zero means the bot may offer two meetings back to back.",
  "umum.ya": "Yes",
  "umum.tidak": "No",
  "umum.tarifTidakDiketahui": "rate unknown",
  "umum.tarifTidakDiketahuiKet": "Usage of this model is not counted against the spending budget — its cost appears as a lower bound (≥) on the Usage screen.",
  "ta.kolPlatform": "Platform",
  "ta.kolAkun": "Account",
  "ta.kolTerakhirTerima": "Last received",
  "ta.kolBalasDm": "Reply DM",
  "ta.kolBalasKomentar": "Reply comment",
  "ta.kolIsiNotifikasi": "Notification content",
  "ta.kolLabel": "Label",
  "ta.kolChatId": "chat_id",
  "ta.belumDihubungkan": "not connected",
  "ta.belumPernah": "never",
  "ta.kapBisa": "Yes",
  "ta.kapTidak": "Not possible",
  "ta.kapBelum": "Not built yet",
  "ta.kapBedaJudul": "\"Not possible\" and \"not built yet\" are different",
  "ta.kapBedaIsi": "Not possible = the platform genuinely does not offer it; LinkedIn does not serve automated DM replies, so connecting it adds a publishing channel, not a reply channel. Not built yet = the platform can, our code cannot. The difference decides whether \"when?\" has an answer.",
  "ta.grupJudul": "Telegram groups",
  "ta.isiNotifikasiSemua": "DM · prospects · meetings",
  "ta.grupBukanIzinJudul": "Connecting a group ≠ people may press buttons",
  "ta.grupBukanIzinIsi": "Everyone in the group can read notifications. But buttons like \"Claim & handle\" only work for people who have linked their Telegram account — by typing /join CODE once in the group. Who has not is visible under Team.",
  "ta.kolPotongan": "Chunks",
  "ta.belumDiproses": "not processed",
  "ta.ujiAmbilJudul": "Retrieval test",
  "ta.ujiAmbilCatatan": "cheap, run it as often as you like",
  "ta.ujiPlaceholder": "Type a question the way your customers would…",
  "ta.ujiJalankan": "Run",
  "ta.ujiJalankanMahal": "Run (costs money)",
  "ta.ujiNolJudul": "0 chunks found",
  "ta.ujiNolIsi": "This question finds nothing in your documents. The bot will still answer it — with no material, and that is the state most likely to produce invention. Add a section covering it to one of your documents.",
  "ta.ujiKetemu": "{{n}} chunks found · {{karakter}} characters of context",
  "ta.ujiPercakapanJudul": "Conversation test",
  "ta.ujiPercakapanCatatan": "expensive, run it when documents change",
  "ta.ujiPakaiKonteks": "The answer uses the chunks that were found ({{n}} chunks).",
  "ta.ujiMengarang": "The answer does NOT use the chunks that were found ({{n}} chunks) — most likely invented. Check your documents.",
  "ta.duaUjiJudul": "Why two tests, not one",
  "ta.duaUjiIsi": "The retrieval test catches the cause — a question that finds no material. The conversation test catches the effect — an answer that comes out anyway. One test alone misses one of them.",
  "umum.menunggu": "Waiting…",
  "tk.kolSumber": "Search sources",
  "tk.sumberCatatan": "You choose keywords, not news sites. Which sites appear is decided by the search results.",
  "tk.sumberKosong": "No source selected — scraping will use both (the default), not stop.",
  "tk.kolBahasa": "Language",
  "tk.bahasaCatatan": "Sets the language and country of search results. Keywords in another language with the Indonesian setting will pull unrelated news — with no error at all.",
  "konten.adaGagal": "{{n}} posts failed to publish",
  "konten.gagalTanpaSebab": "Meta rejected it without stating a reason. Open the row in the table to see its schedule and target.",
  "adm.tabFitur": "Features",
  "adm.tabModel": "Models & budget",
  "adm.modelPaguJudul": "AI models in use",
  "adm.modelPaguCatatan": "chosen by the tenant admin — read-only here",
  "adm.belumPilihModel": "This tenant has not chosen any model.",
  "adm.belumPilihModelKet": "While empty, every role uses Smova's default model. The tenant admin picks them, on their own AI Models screen.",
  "adm.kolUrutanModel": "Order tried",
  "adm.fiturJudul": "Features this tenant bought",
  "adm.fiturCatatan": "{{hidup}} of {{total}} enabled",
  "adm.fiturJualJudul": "This is what we sell, so this is ours to set",
  "adm.fiturJualIsi": "The tenant admin only sees the list — they cannot enable anything themselves. Per-feature settings (scraping topics, profiling fields, meeting hours) remain theirs. Dependencies are enforced by the system: enabling chatbot without rag is refused, and so is disabling rag while chatbot is live.",
  "ta.fiturSiapaJudul": "Features are set together with Smova",
  "ta.fiturSiapaIsi": "This list shows what is active for your company. Turning features on or off is done by Smova — contact us to change your package. Settings inside each feature (search topics, what the bot collects, operating hours) remain yours, in their own menus.",
  "fp.nProspek": "{{n}} prospects",
  "fp.belumAda": "none yet",
  "st.draft": "Draft — no image/schedule yet",
  "st.pending_concept": "Concept — not approved yet",
  "st.scheduled": "Scheduled",
  "st.pending_approval": "Finished — not reviewed yet",
  "st.published": "Published",
  "st.rejected": "Rejected",
  "st.failed": "Failed to publish",
  "tahap.collecting": "Collecting data",
  "tahap.profiled": "Data complete",
  "tahap.exploring": "Exploring",
  "tahap.scheduling": "Arranging a time",
  "tahap.meeting_confirmed": "Meeting agreed",
  "tahap.wl_invite_sent": "Invite sent",
  "tahap.dropped": "Dropped",
  "tahap.won": "Became a customer",
  "pk.perModelCatatan": "chat replies only — image, video and content drafting are not broken down by model yet",
  "pk.modelTakTercatat": "not recorded",
  "adm.kolSambungan": "Connections",
  "adm.kolOrang": "People",
  "adm.kolDm30": "DMs 30 days",
  "adm.kolProspek": "Prospects",
  "adm.kolToken30": "Tokens 30 days",
  "adm.tanpaSambungan": "not connected",
  "jenisTenant.direct": "direct client",
  "jenisTenant.agency": "agency",
  "jenisTenant.internal": "internal",
  "mode.draft": "Draft — bot silent",
  "mode.test": "Test — test accounts only",
  "mode.live": "Live",
  "kt.kolFitur": "Feature",
  "kt.takadaPemakai": "none",
  "kt.kolModel": "Model",
  "kt.kolMunculDi": "Appears in",
  "munculDi.chat": "Chatbot",
  "munculDi.text": "Content captions",
  "munculDi.image": "Image",
  "munculDi.video": "Video",
  "ob.judul": "Onboarding · {{nama}}",
  "ob.keterangan": "Can be left and resumed tomorrow — nothing here has to be finished in one sitting.",
  "ob.bukaDetail": "Open tenant detail",
  "ob.majuJudul": "Progress",
  "ob.majuCatatan": "computed from the current state, not from checkboxes someone once ticked",
  "ob.dariTujuh": "{{n}} of 7",
  "ob.tanggaJudul": "Seven steps",
  "ob.tanggaCatatan": "steps that cannot start yet say what they are waiting for",
  "ob.keadaan.selesai": "done",
  "ob.keadaan.sekarang": "do this now",
  "ob.keadaan.menunggu": "not yet",
  "ob.keadaan.terkunci": "locked",
  "ob.kolDibutuhkan": "What is needed",
  "ob.kolSudah": "Done?",
  "ob.belumAda": "none yet",
  "ob.urutanJudul": "The order below is reversed from the natural one, and the reason must be read",
  "ob.urutanIsi": "The `tenants.mode` column has a `draft` value meaning \"not active\" — but that column has ZERO readers on the inbound path. Not one line of code holds back processing for a draft tenant. The consequence: the moment Instagram is connected, the bot serves the public, with whatever knowledge happens to be loaded at that time. That is why \"Connect Instagram\" sits at step 5, after knowledge and features are done.",
  "ob.l1": "1 · Tenant created",
  "ob.l1Isi": "Mode {{mode}} · time zone {{zona}} · created {{tanggal}}",
  "ob.l1Hilang": "No tenant with this id in the list. It may have been deleted.",
  "ob.l2": "2 · Telegram group & team",
  "ob.l2Isi": "Where notifications are sent, and the people allowed to press their buttons. Safe to do now — nothing faces the public yet. The /join code is issued after the group exists, because a link's tenant is decided by the group someone types in, not by the code.",
  "ob.l3": "3 · Knowledge documents",
  "ob.l3Isi": "The material the bot answers from — and anything not here, the bot must not invent. Onboarding stalls here more often than on anything technical. Waiting on the tenant to send it; we do not know their business.",
  "ob.l4": "4 · Purchased features & spending budget",
  "ob.l4Isi": "Which features are on for this tenant, which models may be used, and the monthly budget. This is the commercial part — set by us, not by them.",
  "ob.l5": "5 · Connect Instagram",
  "ob.takBisaKembali": "point of no return",
  "ob.l5Isi": "The tenant admin logs in with their own Meta account. From the minute the account connects, incoming DMs are processed and answered to real customers — there is no trial stage while `mode` is not enforced. Do not do this before steps 3 and 4 are done.",
  "ob.l6": "6 · Test with a real DM",
  "ob.l6Isi": "Send a DM from a personal account to the tenant's Instagram, then check three things at once: the reply makes sense, the notification lands in the right Telegram group, and the button in that notification works for someone who has already run /join. Never hand over a tenant without this — the three involve four different systems, and each link can fail without raising an error anywhere.",
  "ob.l6Terkunci": "Locked — waiting on steps 3 and 5. A test DM sent before the documents are in gets answered by a bot with no material, and the result reads as \"the bot is bad\" instead of \"it was never given anything\".",
  "ob.l7": "7 · Hand over to the client",
  "ob.l7Isi": "Send Tenant Admin access, and hand over what is theirs: bot persona, collected data, reply schedule, content schedule. From this point we stop setting the content and start watching it.",
  "ob.l7Terkunci": "Locked — waiting on step 6.",
  "ob.sGrup": "Active Telegram group",
  "ob.nGrup": "{{n}} group(s)",
  "ob.sOrang": "People on the roster",
  "ob.nOrang": "{{n}} people",
  "ob.sTertaut": "Have run /join",
  "ob.nTertaut": "{{n}} of {{total}}",
  "ob.sDokumen": "Documents the bot can use",
  "ob.nDokumen": "{{n}} of {{total}} documents",
  "ob.sFitur": "Features on",
  "ob.nFitur": "{{n}} of {{total}}",
  "ob.sModel": "Models chosen",
  "ob.nModel": "{{n}} choice(s)",
  "ob.pakaiBawaan": "using Smova defaults",
  "ob.sPagu": "Monthly budget",
  "ob.tanpaPaguTakApa": "not set — that is allowed",
  "ob.sWebhook": "A webhook has arrived",
  "ob.nWebhook": "{{n}} events",
  "ob.belumPernahSampai": "never",
  "ob.sAdminMasuk": "Tenant admin has logged in",
  "ob.nAdminMasuk": "{{n}} people",
  "ob.belumPernahMasuk": "never",
  "ob.keSambungan": "Open Connections",
  "ob.kePengetahuan": "Open Knowledge",
  "ob.keFitur": "Open Features",
  "ob.keJalur": "Open Inbound path",
  "ob.menungguJudul": "Why two steps wait on other people, and that is not a defect",
  "ob.menungguIsi": "Step 3 waits on documents from the tenant; step 5 waits on them logging in to Meta. Neither is ours to do — we must not hold their Meta password, and we do not know their business. All this screen can do is make the waiting VISIBLE, so that an onboarding stalled for three weeks is not discovered by accident.",
  "ob.turunanJudul": "The ticks are derived, not stored",
  "ob.turunanIsi": "No table records which step was ticked, and that is deliberate: state stored apart from reality drifts from it — a \"documents are in\" tick stays green after the documents are deleted. What is read here is the data that drives the system. The consequence is that this page also CANNOT say how long a step has been pending; that needs a history table which does not exist.",
  "ta.liburBedaIsi": "Owned by the whole tenant — different from one person's availability block. These days are never offered.",
  "ta.fpNonaktifIsi": "Fields marked \"No longer\" stop being asked by the bot but stay listed here — answers already collected are not deleted, and remain readable on the prospect screen.",
  "ta.identitasCatatan": "what your customers hear",
  "ta.kebijakanCatatan": "changes conversation branches, not just words",
  "ta.liburCatatan": "weekends are set on the “Hours & days” tab",
  "ta.liburBedaJudul": "This belongs to the whole tenant, not one person",
  "fp.daftarCatatan": "asked one at a time, only what is still missing",
  "ta.fpNonaktifJudul": "Switching a field off does not delete its data",
  "ta.pengRingkasJudul": "{{dok}} documents · {{potongan}} chunks",
  "ta.kolJenis": "Type",
  "ta.kolDiproses": "Processed",
  "ta.belumDiproses2": "not processed",
  "ta.pagarKunci": "locked by Smova",
  "ta.pagarSelalu": "Always in force, and nobody can switch them off",
  "ta.pagar1": "The bot must not claim to be human, however much the customer insists or complains.",
  "ta.pagar2": "The bot must not name a product that is not in your knowledge documents — better to say it does not know than to invent.",
  "ta.pagar3": "The bot promises nothing that is not in these settings.",
  "ta.pagarCatatan": "shown so it is visible that it EXISTS and is deliberately locked",
  "tk.frekuensiJudul": "How many times a day",
  "tk.frekuensiLabel": "Frequency",
  "tk.frekuensiNilai": "{{n}}× a day",
  "tk.frekuensiTiap": "every {{n}} hours",
  "tk.jamJalan": "Run times",
  "tk.kedaluwarsaLabel": "Discard waiting content after",
  "tk.kedaluwarsaKet": "days. Concepts and images left undecided for {{n}} days are discarded along with their data, from the automatic chain and /campaign alike. Enter 0 to never discard.",
  "tk.kedaluwarsaMati": "days — 0 means never discarded. The queue will keep growing.",
  "tk.gayaLabel": "Brand visual style",
  "tk.gayaContoh": "e.g. flat illustration, deep blue and green palette, plain background, leave empty space in the lower third",
  "tk.gayaKet": "Optional. Left empty, the style comes from reference images labelled as brand — one image teaches palette, style and composition at once. This box is for what an image cannot show.",
  "tk.hariJalan": "Days",
  "tk.frekuensiKosong": "No search schedule set, so no material is collected on its own.",
  "ta.tujuhHari": "Last {{n}} days",
  "ta.tujuhCatatan": "numbers, not tasks — deliberately below",
  "ta.angka.dm": "DMs in",
  "ta.angka.dmDari": "{{n}} answered by bot",
  "ta.angka.prospek": "New prospects",
  "ta.angka.prospekDari": "{{n}} past the collecting stage",
  "ta.angka.meeting": "Meetings",
  "ta.angka.meetingDari": "{{n}} with no attendees",
  "ta.angka.meetingAman": "all have attendees",
  "ta.angka.konten": "Content published",
  "ta.angka.kontenDari": "{{n}} awaiting approval",
  "ta.angka.pagu": "Budget left",
  "ta.angka.paguDari": "{{sisa}} left",
  "ta.angka.tanpaPagu": "not capped",
  "ta.tugasTelegram": "{{n}} team members have not linked Telegram",
  "ta.tugasTelegramKet": "Buttons in group notifications will refuse them until they link.",
  "fp.terlaluWajibJudul": "{{n}} required fields is near the comfortable limit",
  "fp.terlaluWajibIsi": "The bot asks required fields one at a time inside the conversation. The more are required, the more it feels like a form — and buyers stop halfway. Make optional whatever a person can ask later in the meeting.",
  "ta.bolehYa": "Yes",
  "ta.bolehTidak": "No",
  "tk.kolJam": "Time",
  "tk.kolJenis": "Type",
  "tk.kolTujuan": "Targets",
  "tk.tujuanKosong": "no platform is ready to publish yet",
  "tk.rantaiJudul": "Content chain, four steps",
  "tk.rantaiCatatan": "the order matters — switching off step 1 leaves the rest idle",
  "tk.langkah.cariBahan": "1 · Find material",
  "tk.langkah.susunKonsep": "2 · Draft concepts",
  "tk.langkah.setujuiKonsep": "3 · Approve concepts",
  "tk.langkah.setujuiAset": "4 · Approve images",
  "tk.langkahOn.cariBahan": "The bot finds news and trends on its own, on the schedule in the “Sources” tab.",
  "tk.langkahOff.cariBahan": "No new material comes in. The next three steps sit idle.",
  "tk.langkahOn.susunKonsep": "Incoming material is drafted into content concepts straight away.",
  "tk.langkahOff.susunKonsep": "Material piles up without becoming concepts. No model cost is incurred here.",
  "tk.langkahOn.setujuiKonsep": "Concepts from the automatic chain carry straight on: the AI writes the image prompt, then the image is generated. Reviewed by nobody. Concepts a person asked for (/campaign, /analyze, trend buttons) still wait in Telegram.",
  "tk.langkahOff.setujuiKonsep": "Concepts wait for your approval in Telegram. No image has been generated yet, so a concept you reject costs no image spend. Nothing is lost — it queues on the Content screen.",
  "tk.langkahOn.setujuiAset": "Images from the automatic chain are scheduled straight away and publish themselves at their slot time. Content made by a person still waits in Telegram until they choose Upload now or Schedule.",
  "tk.langkahOff.setujuiAset": "The image IS already generated, then sent to Telegram as a photo with buttons. It is only scheduled once you approve. The image spend is already incurred at this point.",
  "tk.langkahTakDibeli": "Your plan does not include {{fitur}}, so this switch has no effect. Contact Smova to add it.",
  "tk.fiturNama.scraping": "material search",
  "tk.fiturNama.drafting": "content drafting",
  "tk.mati": "Off",
  "tk.tinjauDulu": "I review first",
  "tk.rantaiBedaJudul": "Two kinds of “not automatic”, and the difference decides what you find tomorrow",
  "tk.rantaiBedaIsi": "Steps 1 and 2 off means NOTHING HAPPENS — no material, no concepts, no model cost. Steps 3 and 4 off means the work STILL HAPPENS and then stops, waiting for you, and both wait in Telegram: the concept as text with buttons, the image as a photo with buttons. The cost differs: a rejected concept has not yet incurred image spend, a rejected image has. Treating “off” and “waiting” as the same makes people think content stopped when it is in fact waiting.",
  "ta.pengUnggah": "Upload document",
  "ta.pengMemproses": "Processing…",
  "ta.pengJenis": "Text only: .txt .md .csv .json — re-save PDF/Word as .txt",
  "ta.pengTerunggah": "{{nama}} added · {{n}} chunks ready for the bot",
  "adm.orangHitung": "{{n}} people",
  "adm.tambahOrang": "Add person",
  "adm.kolTertaut": "Linked",
  "adm.kolTerakhirAktif": "Last active",
  "adm.sudahJoin": "Has /join",
  "adm.belumJoin": "No /join yet",
  "adm.kolAkunAktif": "Account active?",
  "adm.kolUsername": "Username",
  "adm.kolPassword": "Initial password",
  "adm.kolTelegram_username": "Telegram",
  "adm.suntingOrang": "Editing {{nama}}",
  "adm.sandiCatatan": "You type the password; the screen does not generate one — a password shown on screen ends up in screenshots and chat history. Send it by whatever channel you choose, and ask them to change it.",
  "adm.sandiMinimal": "Username at least 3 characters, password at least 8.",
  "adm.tgHandleCatatan": "This is the handle WE record. The real link is created when the person runs /join in the Telegram group themselves — filling this field does not link them.",
  "adm.orangSiapaJudul": "Adding people happens here; linking them happens in Tenant Admin",
  "adm.orangSiapaIsi": "The Linked column above is READ-ONLY here — the /join code is issued by the tenant admin, and the person types it in the Telegram group themselves. We add and edit the people; they link their own accounts.",
  "umum.sunting": "Edit",
  "umum.tersimpanOtomatis": "This tab saves every change immediately — nothing is waiting to be saved.",
  "tk.kolSlide": "Slides",
  "tk.slideVideo": "1 · video",
  "tk.slideVideoKet": "Reels has no carousel form, so a video slot is always a single file.",
  "tk.gambarPerHari": "{{n}} images generated per day — this is the number that drives spend, not the slot count.",
  "tk.collaseBiayaJudul": "A carousel raises spend by its slide count",
  "tk.collaseBiayaIsi": "Each slide is one image, generated and billed separately — your schedule now produces {{n}} images a day. Images are also the FIRST thing stopped when the spending budget is hit, so too many carousels make content stop earlier in the month. If the budget runs out mid-generation, the slot fails whole — no half carousel is published.",
  "bk.gambarHilang": "image not found",
  "konten.cobaLagi": "Retry",
  "konten.buang": "Discard",
  "konten.galatUrl": "Meta could not download the image — the file is no longer on the server. Discard this and recreate it from the same material.",
  "konten.galatToken": "The Meta permission expired. Contact Smova to refresh the token, then press Retry.",
  "konten.galatSambungan": "This platform's account is not connected, or its connection is inactive. Ask the Tenant Admin to check Connections, then press Try again.",
  "k6.toast.konsepTanpaGambar": "Concept approved, but its image could not be created. Open the content to create the image.",
  "k6.toast.konsepTerjadwal": "Concept approved and scheduled right away.",
  "konten.galatKuota": "Meta refused temporarily — too many requests. Try again in a few hours.",
  "konten.galatIzin": "This Meta account is not allowed to publish. Contact Smova.",
  "konten.galatIzinBaca": "The Meta app is not allowed to READ Facebook Page posts, so the numbers cannot be fetched. Publishing is unaffected — the content is still live. Contact Smova.",
  "konten.galatMedia": "Meta rejected the image or video — its size or format is not accepted.",
  "bh.kolBerita": "Story",
  "konten.cobaLagiN": "Retry ({{n}} targets)",
  "konten.buangN": "Discard ({{n}} targets)",
  "konten.suka": "Likes",
  "konten.komentar": "Comments",
  "konten.semuaKonten": "← All content",
  "konten.tanpaJudul": "(untitled)",
  "konten.insightJudul": "Numbers per target",
  "konten.insightCatatan": "numbers for the selected platform — never summed",
  "konten.bukaPostingan": "Open post",
  "konten.tanpaTautan": "link not stored",
  "konten.slideKe": "Slide {{n}}/{{dari}}",
  "konten.slideMundur": "Previous slide",
  "konten.slideMaju": "Next slide",
  "konten.yangTayangCollase": "Carousel of {{n}} slides — in the order they went live.",
  "konten.perbaruiAngka": "Refresh numbers",
  "konten.mengambil": "Fetching…",
  "konten.diambil": "Numbers fetched {{kapan}}.",
  "konten.belumDiambil": "These numbers have never been fetched from the platform.",
  "konten.kenapaKosongJudul": "Why some numbers are “—”",
  "konten.kenapaKosongIsi": "“—” means the platform DOES NOT REPORT that number, not zero — zero means nobody actually saw it. Reach counts PEOPLE, impressions count VIEWS: one person opening it three times adds three impressions and one reach. Saves exist only on Instagram, shares only on Facebook. Some numbers appear only hours after publishing. Content published before 12 September did not store its post id, so its numbers stay empty until “Refresh numbers” is pressed once — the id is found back by matching publish time. If the post has been deleted it will not be found, and that is said plainly.",
  "konten.detailKeterangan": "Published {{kapan}} · to {{tujuan}}",
  "konten.detailBelumJam": "Not scheduled yet · to {{tujuan}}",
  "konten.captionJudul": "Caption",
  "konten.yangTayangJudul": "What went out",
  "konten.yangTayangFoto": "photo · watermarked",
  "konten.yangTayangVideo": "video · watermarked",
  "konten.lihatPostingan": "view post",
  "konten.sumberIde": "Source idea",
  "konten.kolJenis": "Type",
  "konten.m.jangkauan": "Reach",
  "konten.m.tayangan": "Impressions",
  "konten.m.suka": "Likes",
  "konten.m.simpan": "Saves",
  "konten.m.dibagikan": "Shares",
  "konten.m.komentar": "Comments",
  "prospek.semuaProspek": "All prospects",
  "prospek.dariInstagram": "From Instagram",
  "prospek.dariManual": "Added manually",
  "prospek.manual": "Manual",
  "prospek.ditanganiOleh": "handled by {{siapa}}",
  "prospek.belumDitangani": "nobody has taken over yet",
  "prospek.meetingBerikut": "Next meeting",
  "prospek.dataTerisi": "{{terisi}} of {{total}} filled",
  "prospek.dataKet": "Collected by the bot through conversation, but you may correct it — and often need to: the PIC changes, the office moves, an email is mistyped. Old values are not lost: every change is stored in the history along with the previous value.",
  "prospek.tidakDikumpulkan": "no longer collected",
  "prospek.catatanProses": "Process notes",
  "prospek.catatanProsesCatatan": "written by the team, not the bot",
  "prospek.cTanggal": "Date",
  "prospek.cKejadian": "What happened",
  "prospek.cOleh": "By",
  "prospek.catatanKosong": "No process notes yet",
  "prospek.catatanKosongKet": "What happens outside the system — a phone call, a proposal sent, a rejection — is recorded here.",
  "prospek.riwayatDM": "Instagram conversation history",
  "prospek.riwayatDMCatatan": "what has been discussed, not just who",
  "prospek.dmKosong": "No conversation yet",
  "prospek.dmKosongKet": "A prospect added manually has no DM history.",
  "prospek.balasDariSini": "Reply from here",
  "prospek.balasDariSiniKet": "Your reply is sent as the company Instagram account, not on the bot's behalf.",
  "prospek.botMati": "Bot switched off",
  "prospek.botJalan": "Bot answering",
  "prospek.dipegangKet": "You are holding this conversation. While it is held the bot does not reply to this person at all — incoming messages are still recorded and still appear in Needs a reply, but the answer waits for you.",
  "prospek.botJalanKet": "The bot replies automatically. \"Hold conversation\" switches it off for this person only, until released.",
  "prospek.pernahMenangani": "Has stepped in: {{siapa}}.",
  "prospek.tidakMundur": "The prospect does not move backwards: its place in the funnel stays.",
  "prospek.ambilVsPegang": "\"Take\" and \"Hold conversation\" are two different things",
  "prospek.ambilVsPegangKet": "Take holds one message — you answer this one, and the bot stays alive for the next. Hold conversation switches the bot off for this person continuously until released. For a one-off pricing question, \"Take\" is enough; for a negotiation running over days, \"Hold\" is the right one.",
  "prospek.tanpaPeserta": "no attendees yet",
  "prospek.simpanPeserta": "Save attendees",
  "prospek.pesertaKet": "May change at any time — people added, removed, or replaced entirely.",
  "prospek.timKosong": "No team members available to pick.",
  "prospek.hasilBelum": "not filled in yet — fill it after the meeting",
  "prospek.simpanHasil": "Save outcome",
  "prospek.rekamanKe": "Recording {{n}}",
  "prospek.rekamanJumlah": "{{n}} recordings",
  "prospek.belumAdaRekaman": "No recording for this meeting yet.",
  "prospek.unggahRekaman": "Upload audio recording",
  "prospek.mengunggah": "Uploading…",
  "prospek.rekamanKet": "Audio is turned into a transcript then summarised into points and action items, stored on this meeting. A second recording is appended — it does not overwrite the first. Maximum {{mb}} MB per file.",
  "prospek.jadwalkanLagi": "Schedule another meeting",
  "prospek.rekamanTerlaluBesar": "The audio is over {{mb}} MB. Shrink it first (e.g. export as mono 64 kbps), or send it as a voice note in the Telegram group — that route is not subject to this limit.",
  "prospek.rekamanDitolakProxy": "Rejected by the proxy before it reached Smova because the body was too large. That is a server limit, not a Smova limit — ask the operator to raise it.",
  "prospek.rekamanSaldoKurang": "Not enough OpenRouter balance to transcribe audio (needs at least $0.50). Top up, then upload again.",
  "prospek.rekamanFiturMati": "Meeting recording is switched off for this tenant.",
  "umum.hapus": "Delete",
  "prospek.hapusRekamanYakin": "Delete this recording? The audio is not kept — what is lost cannot be restored.",
  "prospek.hapusRekamanIya": "Yes, delete",
  "prospek.lihatTranskrip": "View full transcript",
  "prospek.jamTidakTercatat": "time not recorded",
  "prospek.ringkasanGagal": "The summary was not saved — the transcript is below.",
  "konten.suntingMedia": "Change the images",
  "konten.unggahSlide": "Upload your own image",
  "konten.suntingMediaKet": "Model, references, per-slide prompt and ordering — the same as in Create Content. Only while the content is still unapproved.",
  "konten.simpanGambar": "Save images",
  "konten.simpanGambarKet": "The queue only changes when you save, and it changes for every destination at once.",
  "konten.ubahTeks": "Edit text",
  "konten.ubahTeksKet": "Applies to every destination at once.",
  "konten.captionHitung": "{{n}} of {{batas}} characters",
  "konten.pesanKunci": "Key message 💡",
  "konten.hashtag": "Hashtags",
  "konten.hashtagKet": "Separate with spaces or commas, no hash sign. {{n}} recognised, Instagram allows 30.",
  "sb.akunGanda": "{{n}} active accounts — the system refuses to choose. Deactivate all but one.",
  "sb.gantiAkun": "Change account",
  "sb.gantiAkunJudul": "Change the {{platform}} account",
  "sb.gantiAkunPeringatan": "The current account is deactivated, the new one is registered, and the token is rotated — all at once, in one step. The old one is not deleted: it remains the record that the account was once linked here.",
  "sb.gantiAkunId": "New account ID",
  "sb.gantiAkunToken": "Token for the new account",
  "sb.gantiAkunTokenKet": "Leave empty ONLY if the current token really is valid for that new account. An old account's token can almost never see a new account — the symptom is \"Object with ID … does not exist\" on the connection test.",
  "sb.gantiAkunSimpan": "Change account & token",
  "sb.gantiAkunSelesai": "Done. {{lama}} deactivated, {{baru}} is now active. Press Test connection to confirm.",
  "konten.draftJudul": "Still a draft — it will not publish",
  "konten.draftKet": "A draft has a date, but the publisher only picks up items marked scheduled. While it stays a draft it sits here and never goes out.",
  "konten.draftKapan": "Publish at",
  "konten.draftJadwalkan": "Schedule it now",
  "konten.belumDijadwalkan": "not scheduled yet",
  "konten.jadwalkanDulu": "Schedule…",
  "konten.belumJudul": "Not scheduled yet — pick a publish time",
  "konten.belumKet": "This content was made by a person and waits for you to choose when it publishes. The system does not pick a time. Once scheduled, it publishes by itself at that time to all its destinations.",
  "konten.draftTerjadwal": "Scheduled. The publisher will pick it up when the time comes.",
  "konten.draftSegera": "Scheduled, and the time has already passed — it goes out on the next sweep, within 10 minutes.",
  "bk.unggahSendiri": "Upload your own",
  "konten.hapusKonten": "Delete content",
  "konten.hapusJudul": "Permanent deletion — cannot be undone",
  "konten.hapusKet": "All {{n}} destinations of this content are removed from Smova, along with the reach and engagement figures already collected. Any report that used those figures will no longer match. The post itself is not touched — if it is still on Instagram or Facebook, it stays there.",
  "konten.hapusIya": "Yes, delete permanently",
  "tk.refJudul": "Images for the AI",
  "tk.refCatatan": "{{n}} of {{maks}} in use — included in every automatic image",
  "tk.refKet": "Checked images go to the prompt-writing AI and to the image model every time an image is made automatically, together with their “used for” text. Names and text are saved when you leave the box. The marketing team can still pick any image by hand in Create Content.",
  "tk.tabReferensi": "References",
  "bk.tempJudul": "My images (temporary)",
  "bk.tempLabel": "temporary",
  "bk.tempTambah": "+ my image",
  "bk.tempBuang": "Remove this image",
  "bk.tempKet": "Your own images are not stored; they disappear when the page closes.",
  "bk.tempTerlaluBesar": "That image is {{ukuran}} MB — the limit is {{maks}} MB. Shrink it first; it is sent to the model on every generation.",
  "bk.rasio": "Aspect ratio",
  "bk.rasioBawaan": "Model default · {{rasio}}",
  "bk.rasioPenyedia": "chosen by provider",
  "bk.rasioIkutModel": "No ratio · shape follows the model and references",
  "bk.rasioCatatan": "The list belongs to the selected model — each model has its own ratios.",
  "bk.rasioDiabaikan": "With reference images, this model ignores the chosen ratio and outputs its default shape (measured: square). Instagram feed is 4:5, so the result may be cropped. Pick another model if the shape matters.",
  "kt.kolKemampuan": "Capabilities",
  "kt.kemReferensi": "accepts references",
  "kt.kemRasioReferensiAbaikan": "ignores ratio with references",
  "kt.kemDetik": "s",
  "kt.kemBelumSinkron": "not synced yet",
  "kt.kemRasioBawaan": "Default ratio",
  "kt.kemRasioPenyedia": "provider",
  "tk.videoMasihManual": "Video slots stop at draft regardless of this switch. Only images are produced automatically; video is uploaded or made by a person on the Content screen.",
  "tk.refNamaLabel": "Material name",
  "tk.refOrang": "Person",
  "tk.refJenisOrangKet": "Included only when the Person checker answers YES for the image prompt.",
  "prospek.tambahJudul": "New prospect",
  "prospek.simpanProspek": "Save prospect",
  "prospek.tambahKet": "For prospects from outside Instagram — events, calls, referrals. All five fields are required. Once saved, the prospect page opens and a meeting can be scheduled from there.",
  "tk.refUnggah": "+ Upload image",
  "tk.refBelumDipakai": "No image is checked. Automatic images are made without any logo or brand asset.",
  "tk.refPenuh": "Already {{maks}} images — the most that can go in one run. Uncheck one to use another.",
  "tk.refLain": "Other images not in use ({{n}})",
  "tk.refPakai": "Use {{nama}}",
  "tk.refLepas": "Remove {{nama}}",
  "tk.refUntukApa": "What this image is for",
  "tk.refUntukApaContoh": "e.g. Official Seleris logo. Put it top left, do not redraw it.",
  "tk.phJudul": "Daily prompt",
  "tk.phCatatan": "Written once, used for every automatic post. The AI reads it together with the news topic, the caption, and the images above, then writes the image prompt.",
  "tk.phKosong": "No daily prompt yet. Automatic images use the fallback prompt from the draft, and the Write prompt button in Create Content refuses until there is one.",
  "tk.phContoh": "Write the instruction for the AI here. Insert the topic and caption with the buttons below.",
  "tk.phSisipkan": "Insert",
  "tk.phTempel": "Topic, caption, brief, and image list you do not insert are still sent — appended at the end of the prompt. Apart from that, the system adds no sentence of its own.",
  "tk.phTopik": "Topic",
  "tk.phTopikKet": "headline and summary of the scraped news",
  "tk.phCaption": "Caption",
  "tk.phCaptionKet": "the caption the AI already wrote for this post",
  "tk.phPesan": "Key message",
  "tk.phPesanKet": "the post's key message",
  "tk.phBrief": "Brief",
  "tk.phBriefKet": "direction from the Fix button in Telegram or the brief in Create Content",
  "tk.phBahan": "Image list",
  "tk.phBahanKet": "attached images, numbered, with their used-for text",
  "tk.phSlideKe": "Slide no.",
  "tk.phSlideKeKet": "the slide being written (carousel: one call per slide)",
  "tk.phJumlah": "Slide count",
  "tk.phJumlahKet": "number of carousel slides",
  "pintu.judul": "Sign in to Smova",
  "pintu.sandi": "Password",
  "pintu.tampilkanSandi": "Show password",
  "pintu.lupa": "Forgot your password? Contact your tenant admin.",
  "pintu.ket": "Use the account your team admin gave you.",
  "pintu.merek": "About Smova",
  "pintu.janji": "One place for conversations, prospects, meetings, and content.",
  "pintu.janjiKet": "The bot answers and prepares; your team decides.",
  "pintu.r1": "Conversations",
  "pintu.r1Ket": "Incoming messages are answered by the bot from your company knowledge.",
  "pintu.r2": "Prospects",
  "pintu.r2Ket": "Serious leads are recognised and handed to the team on Telegram.",
  "pintu.r3": "Meetings",
  "pintu.r3Ket": "Times are agreed in chat, and reminders go out automatically.",
  "pintu.r4": "Content",
  "pintu.r4Ket": "Drafted by AI, approved by the team, then published on schedule.",
  "pintu.oleh": "Smova by Seleris",
  "akun.label": "Account {{nama}}",
  "akun.nama.judul": "Change name",
  "akun.nama.ket": "This is the name the team reads when you act inside a tenant, for example in Telegram group messages. Your sign-in name does not change.",
  "akun.nama.label": "Name",
  "akun.nama.isianKet": "Leave it empty to be referred to by your account name again.",
  "akun.nama.simpan": "Save name",
  "akun.nama.toast": "Your name is now {{nama}}.",
  "akun.nama.toastKosong": "Name cleared. You are referred to by your account name again.",
  "akun.nama.gagalMuat": "The current name could not be loaded: {{sebab}}",
  "sandi.judul": "Change password",
  "sandi.ket": "After the change you are signed out of every device and sign in again with the new password.",
  "sandi.ketKotor": "After the change you are signed out of every device and sign in again with the new password. Unsaved changes on this page will be lost.",
  "sandi.lama": "Current password",
  "sandi.baru": "New password",
  "sandi.baruKet": "At least {{n}} characters.",
  "sandi.ulang": "Repeat new password",
  "sandi.simpan": "Change password",
  "sandi.pendek": "The new password must be at least {{n}} characters.",
  "sandi.tidakSama": "The new password and its repeat do not match.",
  "sandi.samaLama": "The new password must differ from the current one.",
  "sandi.berhasil": "Password changed. Sign in again with the new password.",
  "kerangka.lompatKeIsi": "Skip to content",
  "kerangka.galatJudul": "This page could not be displayed",
  "kerangka.muatUlang": "Reload",
  "kerangka.tenant": "Tenant",
  "kerangka.tenantGagal": "Tenant did not load. Try again",
  "jaring.kueri": "Some data on this screen could not be loaded ({{sebab}}). What you see may be incomplete or out of date.",
  "jaring.aksi": "Something failed and was not handled: {{sebab}}",
  "kerangka.hitungK2": "conversations waiting for staff",
  "kerangka.hitungK6": "content items waiting for you",
  "kerangka.hitungP5": "people who have not used /join on Telegram",
  "kerangka.hitungS5": "flows failed in the last 24 hours",
  "mode.pendek.draft": "Draft",
  "mode.pendek.test": "Test",
  "mode.pendek.live": "Live",
  "mode.ket.draft": "Draft: the bot is silent for everyone.",
  "mode.ket.test": "Test: the bot only answers test accounts.",
  "mode.ket.live": "Live: the bot answers every message.",
  "k1.tujuh.judul": "Last {{n}} days",
  "k1.tujuh.ket": "Numbers for oversight, not a task list.",
  "k1.tujuh.dm": "DMs received",
  "k1.tujuh.dmDari": "{{n}} answered by the bot",
  "k1.tujuh.prospek": "New prospects",
  "k1.tujuh.prospekDari": "{{n}} past data collection",
  "k1.tujuh.meeting": "Meetings",
  "k1.tujuh.meetingDari": "{{n}} without attendees yet",
  "k1.tujuh.meetingAman": "all have attendees",
  "k1.tujuh.konten": "Content published",
  "k1.tujuh.kontenDari": "{{n}} awaiting approval",
  "k1.tujuh.gagal": "The last seven days' numbers did not load",
  "k1.tujuh.kosong": "No numbers yet.",
  "k1.sub.menunggu": "{{tanggal}} · {{n}} things waiting for you",
  "k1.sub.kosong": "{{tanggal}} · Nothing is waiting for you",
  "k1.angka.dm": "Needs reply",
  "k1.angka.dmTerlama": "Oldest: {{lamanya}}",
  "k1.angka.dmBeres": "All handled",
  "k1.angka.prospek": "Prospects managed",
  "k1.angka.prospekTindakLanjut": "{{n}} need follow-up",
  "k1.angka.prospekCalon": "{{n}} lead(s) still with the bot",
  "k1.angka.meeting": "Meetings today",
  "k1.angka.meetingSatu": "{{jam}} · {{nama}}",
  "k1.angka.meetingLagi": "{{meeting}}, and {{n}} more",
  "k1.angka.meetingKosong": "None today",
  "k1.angka.konten": "Content waiting for you",
  "k1.angka.kontenKosong": "Nothing waiting",
  "k1.angka.gagal": "Did not load",
  "k1.rincian.belumDijadwalkan": "{{n}} unscheduled",
  "k1.rincian.konsep": "{{n}} concepts",
  "k1.rincian.persetujuan": "{{n}} awaiting approval",
  "k1.rincian.gagal": "{{n}} failed to publish",
  "k1.rincian.tanpaGambar": "{{n}} without an image",
  "k1.tugas.judul": "Waiting for you",
  "k1.tugas.keterangan": "Most urgent first.",
  "k1.tugas.dmJudul": "{{nama}}: “{{cuplikan}}”",
  "k1.tugas.dmKeterangan": "{{asal}} · the bot handed it to the team {{lamanya}} ago",
  "k1.tugas.asalDm": "{{platform}} DM",
  "k1.tugas.asalKomentar": "{{platform}} comment",
  "k1.tugas.jawab": "Reply",
  "k1.tugas.lewatJudul": "{{nama}} has been waiting {{lamanya}}",
  "k1.tugas.lewatKeterangan": "Past 24 hours: reply directly on {{platform}}",
  "k1.tugas.lainJudul": "{{n}} more conversations waiting",
  "k1.tugas.bukaSemua": "Open all",
  "k1.tugas.kontenJudul": "{{n}} content items waiting for you",
  "k1.tugas.tinjau": "Review",
  "k1.tugas.meetingJudul": "Meeting with {{nama}} at {{jam}}",
  "k1.tugas.meetingTanpaNama": "Meeting at {{jam}}",
  "k1.tugas.prospekJudul": "{{n}} lead(s) with incomplete data",
  "k1.tugas.prospekKeterangan": "The bot is still collecting; they cannot be offered a meeting yet",
  "k1.tugas.lanjutJudul": "{{n}} prospect(s) need follow-up",
  "k1.tugas.lanjutKeterangan": "A past meeting is not closed yet, or there is no next meeting",
  "k1.tugas.kosongJudul": "Nothing is waiting for you",
  "k1.tugas.kosongKeterangan": "Conversations, content, and meetings that need you will appear here.",
  "k1.gagal.percakapan": "Conversations did not load",
  "k1.gagal.konten": "Content did not load",
  "k1.gagal.meeting": "Meetings did not load",
  "k1.gagal.prospek": "Prospects did not load",
  "k1.meeting.berikutnya": "Next meeting",
  "k1.meeting.tanpaNama": "No business name",
  "k1.meeting.hariIni": "Today",
  "k1.meeting.kapan": "{{hari}} · {{zona}}",
  "k1.meeting.bentuk": "Format",
  "k1.meeting.online": "Online",
  "k1.meeting.tatapMuka": "In person",
  "k1.meeting.tatapMukaDi": "In person · {{lokasi}}",
  "k1.meeting.peserta": "Attendees",
  "k1.meeting.anda": "You",
  "k1.konten.judul": "Content today",
  "k1.konten.tanpaJudul": "Untitled",
  "k1.konten.st.published": "Published",
  "k1.konten.st.scheduled": "Scheduled",
  "k1.konten.st.rejected": "Rejected",
  "k1.konten.st.failed": "Failed to publish",
  "k1.konten.st.menunggu": "Waiting for you",
  "k1.konten.kosongJudul": "No content is timed for today",
  "k1.konten.kosongKeterangan": "Content scheduled for today will appear here.",
  "k1.tugas.putusJudul": "{{n}} lead(s) waiting for a decision",
  "k1.tugas.putusKeterangan": "Data complete; the bot waits for Accept or Reject",
  "k1a.judul": "Bot readiness: {{nama}}",
  "k1a.judulTanpaNama": "Bot readiness",
  "k1a.keterangan": "Anything not ready links to where you fix it.",
  "k1a.cincin": "{{beres}} of {{jumlah}} ready",
  "k1a.tanda.beres": "Ready",
  "k1a.tanda.belum": "Not ready",
  "k1a.bereskan": "Fix",
  "k1a.gagal": "Bot readiness did not load",
  "k1a.persona.beres": "Bot persona is filled in",
  "k1a.persona.belum": "Bot persona is not filled in yet",
  "k1a.pengetahuan.beres": "{{n}} active Knowledge documents",
  "k1a.pengetahuan.belum": "No active document in Knowledge; the bot has nothing to answer from",
  "k1a.jadwal.beres": "Weekly reply schedule",
  "k1a.jadwal.selalu": "The bot replies around the clock, as set in Reply hours",
  "k1a.jadwal.belum": "Reply hours not set yet: the bot replies around the clock, including at midnight",
  "k1a.tim.beres": "Everyone on the team has used /join",
  "k1a.tim.belum": "{{n}} people have not used /join on Telegram",
  "k1a.grup.beres": "Telegram group connected",
  "k1a.grup.belum": "No Telegram group connected; news for the team does not arrive",
  "k1a.rantai.beres": "Content chain is running",
  "k1a.rantai.belum": "Part of the content chain is switched off",
  "k1a.slot": "Publishing slots: {{n}} per day",
  "percakapan.tanpaNama": "No name",
  "percakapan.jenis.dm": "DM",
  "percakapan.jenis.comment": "Comment",
  "percakapan.sebab.ai_kosong": "the bot did not have an answer.",
  "percakapan.sebab.perlu_tim": "the bot replied, but this needs a person.",
  "percakapan.sebab.di_luar_jam": "the message arrived outside chatbot hours.",
  "percakapan.sebab.chatbot_mati": "the chatbot is switched off.",
  "percakapan.sebab.mode": "this tenant is not Live yet, so the bot did not reply.",
  "percakapan.sebab.tanpa_teks": "the message has no text (photo, sticker, voice note, or story mention).",
  "percakapan.sebab.ai_gagal": "the AI failed to answer.",
  "percakapan.sebab.gagal_kirim": "the bot's reply could not be delivered.",
  "percakapan.sebab.dipegang": "this message arrived while the team was holding the conversation.",
  "percakapan.sebabLain": "the bot did not reply to this message.",
  "k2.menunggu": "{{n}} conversations waiting for staff",
  "k2.menungguSatu": "1 conversation waiting for staff",
  "k2.tidakMenunggu": "No one is waiting for staff",
  "k2.cari": "Search conversations",
  "k2.cariContoh": "Search by name or @account",
  "k2.daftar": "Conversation list",
  "k2.chip.dipegangSaya": "Held by you",
  "k2.chip.dipegang": "Held by {{nama}}",
  "k2.chip.dipegangTim": "Held by the team",
  "k2.chip.lewat24": "Past 24 hours",
  "k2.chip.menunggu": "Bot gave up",
  "k2.chip.perluOrang": "Needs a person",
  "k2.chip.bot": "Answered by bot",
  "k2.tidakCocok": "Nothing matches",
  "k2.tidakCocokIsi": "No conversations for “{{kata}}”.",
  "k2.hapusCari": "Clear search",
  "k2.kosongJudul": "Inbox is clear",
  "k2.kosongIsi": "Conversations the bot hands over will appear here.",
  "k2.kosongRingkas": "No conversations yet.",
  "k2.sebagian": "Showing {{n}} of {{total}} conversations. Narrow it down with search.",
  "k3.semua": "All",
  "k3.gagal": "Prospects did not load",
  "k3.kosongJudul": "No prospects yet",
  "k3.kosongIsi": "Prospects appear here once their meeting is being arranged. People still handled by the bot are under Leads.",
  "k3.baru.buka": "New prospect",
  "k3.baru.judul": "New prospect",
  "k3.baru.ket": "For prospects from outside the conversation: an exhibition, a call, a referral. All fields are required, because no bot will ask for them.",
  "k3.baru.perusahaan": "Company name",
  "k3.baru.alamat": "Company address",
  "k3.baru.pic": "Contact name",
  "k3.baru.email": "Contact email",
  "k3.baru.telepon": "Contact phone",
  "k3.baru.simpan": "Add prospect",
  "k3.baru.toast": "{{nama}} added",
  "k3.dikelola": "{{n}} prospect(s) managed",
  "k3.tindakLanjutN": "{{n}} need follow-up",
  "k3.cari": "Search prospects",
  "k3.cariContoh": "Search by name or contact",
  "k3.jalur": "Prospect stages",
  "k3.keCalon": "Still handled by the bot",
  "k3.semuaKet": "Currently managed",
  "k3.tahap.jadwal": "Arranging a time",
  "k3.tahap.terjadwal": "Meeting scheduled",
  "k3.tahap.tindakLanjut": "Needs follow-up",
  "k3.tahap.selesai": "Closed",
  "k3.tahapKet.jadwal": "A time is being arranged",
  "k3.tahapKet.terjadwal": "A date is set",
  "k3.tahapKet.tindakLanjut": "Waiting for you",
  "k3.selesaiKet": "{{jadi}} won · {{tidak}} lost",
  "k3.hasil.jadi": "Became a customer",
  "k3.hasil.tidak": "Not continued",
  "k3.daftar": "Prospect list",
  "k3.tahapKosong": "No prospects at this stage",
  "k3.cariKosong": "Nothing matches “{{kata}}”",
  "k3.kolom.prospek": "Prospect",
  "k3.kolom.tahap": "Stage",
  "k3.kolom.meeting": "Meeting",
  "k3.kolom.langkah": "Next step",
  "k3.kolom.dipegang": "Handled by",
  "k3.kolom.aktif": "Last active",
  "k3.meeting.jumlah": "{{n}} meeting(s)",
  "k3.meeting.belumBertanggal": "No date yet",
  "k3.meeting.belum": "None yet",
  "k3.langkah.tutupMeeting": "Close the {{kapan}} meeting",
  "k3.langkah.jadwalkanLanjutan": "Schedule a follow-up meeting",
  "k3.langkah.tunjukPeserta": "Assign who attends",
  "k3.langkah.hadir": "Attend the meeting",
  "k3.langkah.isiTanggal": "Set the meeting date",
  "k3.langkah.botMenawarkan": "The bot is offering times",
  "k3.langkah.tambahMeeting": "Schedule the first meeting",
  "k3.langkahKet.tutupMeeting": "then schedule the next one",
  "k3.langkahKet.jadwalkanLanjutan": "or close the prospect",
  "k3.langkahKet.tunjukPeserta": "nobody is assigned yet",
  "k3.langkahKet.hadir": "attendees are assigned",
  "k3.langkahKet.isiTanggal": "they asked for a time outside the bot's options",
  "k3.langkahKet.botMenawarkan": "waiting for their answer",
  "k3.langkahKet.tambahMeeting": "entered by the team, no conversation",
  "k3.belumDipegang": "Nobody yet",
  "k3.kaki": "{{n}} prospect(s) · those waiting for you first",
  "k3.langkah.botMelengkapi": "The bot completes their details first",
  "k3.langkahKet.botMelengkapi": "accepted by the team before their details were complete",
  "k3.langkah.botAkanMenawarkan": "The bot offers a meeting once they reply",
  "k3.langkahKet.botAkanMenawarkan": "accepted by the team",
  "k4.remah": "Breadcrumb",
  "k4.gagal": "Prospect did not load",
  "k4.tidakAda": "This prospect was not found",
  "k4.bukaPercakapan": "Open conversation",
  "k4.dataJudul": "Prospect data",
  "k4.dataKet": "Filled in by the bot from the conversation. The team may complete it.",
  "k4.dataPensiun": "Questions no longer collected",
  "k4.dataTidakLagi": "no longer collected",
  "k4.catatanJudul": "All notes",
  "k4.catatanKet": "Written about {{nama}}, newest first.",
  "k4.catatanKosong": "No notes yet.",
  "k4.catatanBaru": "New note",
  "k4.catatanContoh": "What happened? For example: a call, a proposal sent, a visit",
  "k4.catatanTambah": "Add note",
  "k4.toast.catatan": "Note added",
  "k4.percakapanJudul": "Latest conversation",
  "k4.percakapanGagal": "Conversation did not load",
  "k4.percakapanKosong": "No messages yet.",
  "k4.bukaDiPerluDijawab": "Open in Needs a reply",
  "k4.botJudul": "Bot for this prospect",
  "k4.botKet": "Turn it off while the team handles this conversation itself.",
  "k4.botLabel": "The bot replies to this prospect",
  "k4.botNyala": "The bot replies to their messages. Turning it off makes you the holder of the conversation.",
  "k4.botMati": "The bot is silent for this person; the team replies. Turning it on hands the conversation back to the bot.",
  "k4.meetingBelum": "No meeting with {{nama}} yet.",
  "k4.dataKurangJudul": "Complete the prospect's data first",
  "k4.dataKurang": "Still empty: {{daftar}}. A meeting can be scheduled after that.",
  "k4.dataKurangKe": "Complete them on the Summary tab",
  "k4.jadwalBaru": "Meeting schedule",
  "k4.jadwalUbah": "Change schedule",
  "k4.tanggal": "Date",
  "k4.jam": "Time",
  "k4.bentuk": "Format",
  "k4.tautan": "Meeting link",
  "k4.tempat": "Place",
  "k4.agenda": "Agenda",
  "k4.agendaIsi": "Agenda: {{isi}}",
  "k4.jadwalkan": "Schedule",
  "k4.jadwalSimpan": "Save schedule",
  "k4.jadwalKet": "Times are tenant time. The team is notified in the Telegram group; the prospect is not notified automatically.",
  "k4.koreksi": "This is a record correction: the meeting already took place at the time I entered.",
  "k4.koreksiKet": "The old time has passed. A correction notifies no one.",
  "k4.tetapJadwalkan": "Schedule anyway, even if the day is full or the time clashes.",
  "k4.tetapJadwalkanKet": "Recorded in Activity as a deliberate override.",
  "k4.toast.jadwalBaru": "Meeting scheduled",
  "k4.toast.jadwalUbah": "Schedule saved",
  "k4.catatanMeeting": "Meeting notes",
  "k4.catatanMeetingSimpan": "Save notes",
  "k4.toast.catatanMeeting": "Meeting notes saved",
  "k4.rekamanMeeting": "Recordings of the {{kapan}} meeting",
  "k4.rekamanTanpaRingkasan": "No summary; the transcript is stored.",
  "k4.transkripLihat": "View transcript",
  "k4.rekamanHapus": "Delete recording",
  "k4.rekamanHapusTanya": "Delete {{judul}}?",
  "k4.rekamanHapusKet": "Its summary and transcript are deleted too and cannot be restored.",
  "k4.toast.rekamanHapus": "Recording deleted",
  "k4.rekamanUnggah": "Upload recording",
  "k4.rekamanMengunggah": "Uploading and summarising…",
  "k4.rekamanUnggahKet": "An audio file, at most {{mb}} MB. Added to the existing recordings.",
  "k4.toast.rekamanUnggah": "Recording added",
  "k4.tab.label": "Prospect detail sections",
  "k4.tab.ringkasan": "Summary",
  "k4.tab.meeting": "Meetings & recordings",
  "k4.tab.percakapan": "Conversation",
  "k4.tab.catatan": "Notes",
  "k4.posisi.judul": "Where things stand",
  "k4.posisi.ket": "Taken from the latest meeting, so nobody has to read every recording.",
  "k4.posisi.terakhir": "Last meeting",
  "k4.posisi.hasil": "Outcome",
  "k4.posisi.berikutnya": "Next",
  "k4.posisi.keadaan.perluDitutup": "past, not closed yet",
  "k4.posisi.keadaan.selesai": "done",
  "k4.posisi.keadaan.tidakHadir": "prospect did not show up",
  "k4.posisi.rekaman": "{{n}} recording(s)",
  "k4.posisi.belumAda": "No meeting has taken place yet.",
  "k4.posisi.hasilKosong": "No notes or recording yet. Write the notes in the Meetings & recordings tab.",
  "k4.posisi.dariCatatan": "From the meeting notes written by the team.",
  "k4.posisi.dariRekaman": "From the recording summary, written automatically.",
  "k4.posisi.kapan": "{{hari}} {{jam}}",
  "k4.posisi.tanpaPeserta": "no participants yet",
  "k4.posisi.menunggu": "There is a meeting request without a date.",
  "k4.posisi.belumBerikut": "No next meeting yet.",
  "k4.posisi.lihat": "View meetings & recordings",
  "k4.berikut.judul": "Next meeting",
  "k4.berikut.belum": "Not scheduled yet.",
  "k4.berikut.buka": "Open this meeting",
  "k4.berikut.isiTanggal": "Set its date",
  "k4.tambahMeeting": "Add meeting",
  "k4.meetingBaru": "New meeting with {{nama}}",
  "k4.meetingPertama": "First meeting",
  "k4.meetingKe": "Meeting {{n}}",
  "k4.meetingSaja": "Meeting",
  "k4.daftar.judul": "{{n}} meeting(s) with {{nama}}",
  "k4.daftar.ket": "Each card holds the meeting's schedule, note and recordings.",
  "k4.keadaan.selesai": "Done",
  "k4.keadaan.tidakHadir": "No-show",
  "k4.keadaan.batal": "Cancelled",
  "k4.tertutup": "{{meeting}} · {{kapan}}",
  "k4.tutup.tanya": "This meeting has passed. How did it go?",
  "k4.tutup.ket": "Closing it only records it here; nobody is notified.",
  "k4.tutup.selesai": "Mark as done",
  "k4.tutup.tidakHadir": "Prospect did not show up",
  "k4.tutup.jadiSelesai": "Change to done",
  "k4.tutup.jadiTidakHadir": "Change to no-show",
  "k4.toast.selesai": "Meeting marked as done",
  "k4.toast.tidakHadir": "Meeting marked as no-show",
  "k4.catatanUbah": "Edit notes",
  "k4.catatanTulis": "Write notes",
  "k4.rekaman.judul": "Recordings ({{n}})",
  "k4.rekaman.kosong": "No recordings yet. Reply to the meeting message in the Telegram group with a voice note, or upload one here.",
  "k4.selengkapnya": "Show more",
  "k4.ringkasLagi": "Show less",
  "k4.transkrip.judul": "Transcript",
  "k4.transkrip.isi": "Transcript text",
  "k4.transkrip.ket": "{{rekaman}} · meeting on {{kapan}}",
  "k4.transkrip.salin": "Copy transcript",
  "k4.transkrip.disalin": "Transcript copied",
  "k4.transkrip.gagalSalin": "Could not copy. Select the text and copy it yourself.",
  "k4.percakapanTanpa": "This prospect has no conversation",
  "k4.percakapanTanpaKet": "Its data was entered by the team, not from a message to the bot.",
  "k4.langkah.label": "How far this prospect has come",
  "k4.langkah.sudah": ", done",
  "k4.langkah.kini": ", current stage",
  "k4.akhiri.judul": "Close prospect",
  "k4.akhiri.judulCalon": "Set this lead aside",
  "k4.akhiri.judulSudah": "Closed",
  "k4.akhiri.judulDini": "Decide now",
  "k4.akhiri.ketDini": "Their details are not complete yet. Accept now if the team is already sure, or set them aside if they are not a potential customer.",
  "k4.akhiri.ketProspek": "When there is a decision. Nobody is notified, and it can be reopened.",
  "k4.akhiri.ketCalon": "When this is not a potential customer. The bot still answers general questions.",
  "k4.akhiri.sudah.jadi": "Closed as a customer.",
  "k4.akhiri.sudah.tidak": "Closed: not continued.",
  "k4.akhiri.sudah.disisihkan": "This lead was set aside.",
  "k4.akhiri.bukaLagi": "Reopen",
  "k4.akhiri.toast.jadi": "{{nama}} closed as a customer",
  "k4.akhiri.toast.tidak": "{{nama}} not continued",
  "k4.akhiri.toast.buka": "{{nama}} reopened",
  "k4.putus.judul": "Decision",
  "k4.putus.ket": "The data is complete. The bot waits for the team's decision before offering a meeting.",
  "k5.terjadwal": "{{n}} meetings scheduled",
  "umum.dan": "and",
  "k6.buat": "Create content",
  "k7.gagal": "Content did not load",
  "k7.tidakAda": "This content was not found",
  "k7.hapusTanya": "Delete this content permanently?",
  "k7.hapusKet": "The content and its numbers are removed from Smova. Posts already published on Instagram or Facebook are not deleted.",
  "k7.hapusYa": "Delete permanently",
  "k7.toastHapus": "“{{judul}}” deleted",
  "k7.jamLain": "Another time…",
  "k7.ubahJadwal": "Change schedule",
  "k7.batalJadwal": "Cancel schedule",
  "k7.toastBatalJadwal": "Schedule cancelled. The content is a draft again.",
  "k7.arah.produk.dari": "Written with product, from Knowledge: {{daftar}}.",
  "k7.arah.produk.tanpaBahan": "Requested with product, but no Knowledge document fits the topic. Written as general.",
  "k7.arah.iklan.dari": "Product ad, written from Knowledge: {{daftar}}.",
  "k7.arah.iklan.tanpaBahan": "A product ad was requested, but its Knowledge document is missing or switched off. Written as general.",
  "k7.teks.judul": "Text",
  "k7.teks.ket": "The caption, hashtags and key message that get published.",
  "k7.teks.terbitKet": "What is already published cannot be changed from Smova.",
  "k7.teks.terjadwalKet": "Its publish time has arrived, so the text can no longer be changed.",
  "k7.teks.ketTerjadwal": "Already scheduled. You can still change it until its publish time.",
  "k7.teks.caption": "Caption",
  "k7.teks.tagar": "Hashtags",
  "k7.teks.pesan": "Key message",
  "k7.teks.tagarKet": "Separate with spaces. The # sign is optional.",
  "k7.teks.hitungan": "{{n}} / {{batas}} characters",
  "k7.jadwal.judul": "Schedule",
  "k7.jadwal.belum": "Not scheduled",
  "k7.jadwal.belumKet": "Choose the publish time and the platforms.",
  "k7.jadwal.usulan": "Proposed {{jam}}",
  "k7.jadwal.usulanKet": "The time comes from an automatic slot. It publishes by itself once approved.",
  "k7.jadwal.konsepUsulanKet": "The image is created after the concept is approved, then waits for image approval.",
  "k7.jadwal.konsepKet": "The image is created after the concept is approved. The time is chosen once the content is ready.",
  "k7.jadwal.drafKet": "Create the image first, then schedule it.",
  "k7.platform.label": "Add a platform",
  "k7.platform.tambah": "Add {{nama}}",
  "k7.platform.tanya": "Add {{nama}} to this content?",
  "k7.platform.ket": "{{nama}} uses the same text and image and follows this content: waiting, scheduled, or published together with the other platforms.",
  "k7.platform.ketTerjadwal": "{{nama}} will also be published {{jam}}, with the same text and image.",
  "k7.platform.ya": "Add {{nama}}",
  "k7.platform.toast": "{{nama}} added to this content",
  "k7.platform.terbitJuga": "Also publish to {{nama}}",
  "k7.platform.tanyaTerbit": "Publish this content to {{nama}} now?",
  "k7.platform.ketTerbit": "This content is already live. {{nama}} uses the same text and image and is published right now; what is published cannot be withdrawn from Smova.",
  "k7.platform.yaTerbit": "Publish to {{nama}}",
  "k7.platform.toastTerbit": "Published to {{nama}}",
  "k7.platform.toastGagal": "Publishing to {{nama}} failed. The reason is on the Schedule card.",
  "k7.jadwal.ditolakKet": "This content will not be published.",
  "k7.angka.judul": "Numbers per platform",
  "k7.angka.ket": "Not added up across platforms.",
  "k7.angka.diambil": "Fetched {{waktu}}",
  "k7.angka.belum": "The numbers have never been fetched",
  "k7.angka.segarkan": "Refresh {{nama}} numbers",
  "k7.angka.toast": "{{nama}} numbers updated",
  "k7.angka.lihat": "View the {{nama}} post",
  "k7.gambar.judul": "Image",
  "k7.gambar.judulKonsep": "Image concept",
  "k7.gambar.ketKonsep": "The image is created when the concept is approved.",
  "k7.gambar.ketSatu": "One slide · up to 10 slides for a carousel",
  "k7.gambar.ketSlide": "{{n}} slides · up to 10 slides for a carousel",
  "k7.gambar.slide": "Slides",
  "k7.gambar.slideKe": "Slide {{n}}",
  "k7.gambar.prompt": "Prompt used",
  "k7.gambar.tanpaPrompt": "The image prompt was not stored.",
  "k7.gambar.regenerate": "Regenerate image",
  "k7.gambar.buat": "Create image",
  "k7.gambar.editPrompt": "Edit prompt",
  "k7.gambar.unggah": "Upload image",
  "k7.gambar.arahan": "Direction for the image",
  "k7.gambar.arahanContoh": "Example: make the logo smaller, brighter colours",
  "k7.gambar.arahanKetKonsep": "AI rewrites the prompt. The image is created when the concept is approved.",
  "k7.gambar.arahanKet": "AI rewrites the prompt, then creates a new image (paid).",
  "k7.gambar.perbaruiPrompt": "Update prompt",
  "k7.gambar.buatBaru": "Create new image",
  "k7.gambar.berbayar": "Regenerate and Edit prompt create a new image, which is paid.",
  "k7.gambar.toastPrompt": "Prompt updated. The image is created when the concept is approved.",
  "k7.gambar.toastBaru": "New image created",
  "k7.gambar.toastUnggah": "Image replaced",
  "k6.gagal": "Content did not load",
  "k6.tanpaJudul": "Untitled content",
  "k6.dibuang": "items waiting {{n}} days are discarded",
  "k6.tidakDibuang": "waiting items are not discarded",
  "k6.tab.label": "Content sections",
  "k6.tab.menunggu": "Waiting for you",
  "k6.tab.terjadwal": "Scheduled",
  "k6.tab.tayang": "Published",
  "k6.tab.bahan": "Materials",
  "k6.urut.label": "Order",
  "k6.urut.menunggu.mendesak": "Most urgent",
  "k6.urut.menunggu.terbaru": "Newest created",
  "k6.urut.menunggu.terlama": "Oldest created",
  "k6.urut.terjadwal.terdekat": "Soonest",
  "k6.urut.terjadwal.terjauh": "Latest",
  "k6.urut.tayang.terbaru": "Newest published",
  "k6.urut.tayang.terlama": "Oldest published",
  "k6.kosong.menungguJudul": "Nothing is waiting",
  "k6.kosong.menungguIsi": "Content appears here when a concept or an image is ready, and when something fails to publish.",
  "k6.kosong.terjadwalJudul": "Nothing scheduled yet",
  "k6.kosong.terjadwalIsi": "Scheduled content appears here until it is published.",
  "k6.kosong.tayangJudul": "Nothing published yet",
  "k6.kosong.tayangIsi": "Content published in the last 30 days appears here, with its numbers.",
  "k6.tayangKet": "Each platform's numbers are shown separately, not added up.",
  "k6.status.konsep": "Concept waiting",
  "k6.status.siap": "Content ready",
  "k6.status.menunggu": "Content waiting",
  "k6.status.gagal": "Failed to publish",
  "k6.status.gagalDi": "Failed to publish · {{daftar}}",
  "k6.status.gambarGagal": "Image failed",
  "k6.status.draf": "Draft",
  "k6.status.terjadwal": "Scheduled",
  "k6.status.terbit": "Published",
  "k6.status.ditolak": "Rejected",
  "k6.poster.konsep": "Concept · no image yet",
  "k6.poster.prompt": "Image prompt: {{isi}}",
  "k6.poster.tanpaPrompt": "The image prompt has not been written.",
  "k6.poster.kosong": "No image yet",
  "k6.gambar": "Image of {{judul}}",
  "k6.belumDijadwalkan": "not scheduled",
  "k6.terbitPada": "Published {{jam}}",
  "k6.tidakDipakai": "{{nama}} not used",
  "k6.asal.otomatis": "From the automatic search",
  "k6.asal.telegram": "Created via Telegram",
  "k6.asal.smova": "Created in Smova",
  "k6.tolak": "Reject",
  "k6.setujuiKonsep": "Approve concept",
  "k6.jadwalkan": "Schedule…",
  "k6.setujuiJam": "Approve · {{jam}}",
  "k6.buang": "Discard",
  "k6.cobaLagi": "Try again",
  "k6.buangTanya": "Discard this content from the queue?",
  "k6.buangKet": "The failed ones are not retried.",
  "k6.buangKetSudah": "What is already published on {{daftar}} is not deleted. The failed ones are not retried.",
  "k6.toast.ditolak": "“{{judul}}” rejected",
  "k6.toast.konsep": "Concept approved. Its content is in Waiting for you.",
  "k6.toast.disetujui": "Approved · publishes {{jam}}",
  "k6.toast.dibuang": "“{{judul}}” discarded from the queue",
  "k6.toast.cobaLagi": "Retrying. The publisher picks it up within 10 minutes.",
  "k6.toast.dijadwalkan": "Scheduled {{jam}} · {{daftar}}",
  "k6.toast.terbit": "Published to {{daftar}}",
  "k6.toast.sebagianGagal": "{{terbit}} published, {{gagal}} failed. The failed ones are in Waiting for you.",
  "k6.angka.jangkauan": "Reach",
  "k6.angka.suka": "Likes",
  "k6.angka.disimpan": "Saved",
  "k6.angka.dibagikan": "Shared",
  "k6.jadwal.judul": "Schedule “{{judul}}”",
  "k6.jadwal.jam": "Publish time",
  "k6.jadwal.slotKosong": "Free slot",
  "k6.jadwal.lain": "Another time",
  "k6.jadwal.lainKet": "Choose yourself",
  "k6.jadwal.tanggalJam": "Date & time",
  "k6.jadwal.zona": "Tenant time zone: {{zona}}.",
  "k6.jadwal.platform": "Platforms",
  "k6.jadwal.minimalSatu": "Tick at least one platform.",
  "k6.jadwal.dilepas": "{{daftar}} is not used for this content.",
  "k6.jadwal.sekarang": "Upload now",
  "k6.jadwal.sekarangTanya": "This content publishes right now",
  "k6.jadwal.sekarangKet": "To {{daftar}}. It cannot be pulled back from Smova.",
  "k6.jadwal.sekarangYa": "Yes, upload now",
  "k6.jadwal.jadwalkan": "Schedule",
  "k6.bahan.judul": "Materials from the search",
  "k6.bahan.ket": "Found automatically from the sources set by the Tenant Admin.",
  "k6.bahan.matiJudul": "Material search is turned off",
  "k6.bahan.matiKet": "No new materials come in until the Tenant Admin turns it on again.",
  "k6.bahan.cari": "Search now",
  "k6.bahan.toastCari": "The material search has started. Results appear here in a few minutes.",
  "k6.bahan.gagal": "Materials did not load",
  "k6.bahan.kosongJudul": "No materials yet",
  "k6.bahan.kosongIsi": "Materials appear here after the next search runs.",
  "k6.bahan.jadiKonsep": "Became a concept",
  "k6.bahan.jadikan": "Make content",
  "k6.bahan.dibuatKonten": "Content already made",
  "k6.bahan.dibuatKontenN": "{{n}} contents already made",
  "k6.bahan.jadikanDari": "Make content from {{judul}}",
  "k5.gagal": "Meetings did not load",
  "k5.kosongJudul": "No meetings scheduled yet",
  "k5.kosongIsi": "Meetings appear here once the bot or the team schedules one with a prospect.",
  "k5.baris": "Meeting with {{nama}}",
  "k5.tanpaNama": "No business name",
  "k5.belumBertanggalN": "{{n}} without a date",
  "k5.belumBertanggal": "No date yet",
  "k5.tanpaTanggal": "Date not set",
  "k5.tanpaTanggalKet": "The prospect asked for a time outside the bot's options. Contact them, then set the date.",
  "k5.isiTanggal": "Set date",
  "k5.peserta": "Participants: {{daftar}}",
  "k5.pesertaBelum": "none yet",
  "k5.tanpaPeserta": "No participants yet. Choose who will attend.",
  "k5.bentrok": "{{daftar}} is on leave on this date. Change the participants.",
  "k5.aturPeserta": "Set participants",
  "k5.pilihPeserta": "Choose participants",
  "k5.pilihKet": "People on leave on this date cannot be chosen. Everyone sets their own leave in Meeting.",
  "k5.tidakIkut": "does not attend meetings",
  "k5.pesertaLain": "Other participants",
  "k5.tanpaAkun": "no Smova account",
  "k5.akunNonaktif": "account inactive",
  "k5.lainKet": "They are not in the team list, so they cannot be ticked above. They stay as participants; untick to remove them.",
  "k5.izinTanggal": "on leave {{tanggal}}",
  "k5.simpanPeserta": "Save participants",
  "k5.gagalTim": "The team list did not load.",
  "k5.batal": "Cancel meeting",
  "k5.batalTanya": "Cancel the meeting with {{nama}}?",
  "k5.batalKet": "The team is notified in the Telegram group. The prospect is not notified automatically; tell them by chat.",
  "k5.batalKetDiam": "The prospect is not notified automatically; tell them by chat.",
  "k5.toast.batalDiam": "Meeting with {{nama}} cancelled.",
  "k5.toast.batal": "Meeting with {{nama}} cancelled. The team was notified in the Telegram group.",
  "k5.toast.peserta": "Participants saved",
  "k5.izinJudul": "My leave dates",
  "k5.izinKet": "On these dates you cannot be chosen as a participant. The bot still offers the date as long as another team member is available.",
  "k5.izinKosong": "None yet.",
  "k5.izinDaftar": "Your leave dates",
  "k5.izinHapus": "Remove leave {{tanggal}}",
  "k5.izinTanggalLabel": "Leave date",
  "k5.izinTambah": "Add leave",
  "k5.gagalIzin": "Leave dates did not load",
  "k5.toast.izinTambah": "Leave on {{tanggal}} recorded",
  "k5.toast.izinHapus": "Leave on {{tanggal}} removed",
  "prospek.tanpaNama": "Unnamed",
  "prospek.picBelum": "Contact not known yet",
  "prospek.diisiTim": "Added by team",
  "prospek.kelengkapan": "{{terisi}}/{{dari}} data collected",
  "prospek.hariIni": "Today",
  "k2.gagalDaftar": "The inbox did not load",
  "k2.gagalUtas": "The conversation did not load",
  "k2.utas": "Conversation with {{nama}}",
  "k2.utasKosong": "Conversation",
  "k2.sumberDm": "{{akun}} · {{platform}} DM",
  "k2.sumberKomentar": "{{platform}} comment",
  "k2.botDiam": "Bot is silent",
  "k2.kembalikan": "Return to bot",
  "k2.abaikan": "No reply needed",
  "k2.ambil": "Take over",
  "k2.pesan": "Messages",
  "k2.bot": "Bot",
  "k2.anda": "You",
  "k2.tim": "Team",
  "k2.sebab": "The bot handed this to the team: {{sebab}}",
  "k2.dariAplikasi": "Replied from the {{platform}} app",
  "k2.balasan": "Reply",
  "k2.tulis": "Write a reply…",
  "k2.tulisKomentar": "Write a comment reply…",
  "k2.sedangDipegang": "Currently held by {{nama}}",
  "k2.ambilDulu": "Take over first to reply",
  "k2.kirim": "Send",
  "k2.lewat24Judul": "More than 24 hours since the last message from {{akun}}",
  "k2.lewat24Isi": "{{platform}} no longer allows replies from Smova. Reply directly on {{platform}}.",
  "k2.bukaPlatform": "Open {{platform}}",
  "k2.tabBaru": "(new tab)",
  "k2.drafTertahan": "Unsent reply",
  "k2.toast.ambil": "You now hold this conversation. The bot stays silent until you return it.",
  "k2.toast.kembalikan": "Conversation returned to the bot",
  "k2.toast.abaikan": "Marked as no reply needed",
  "k2.toast.terkirim": "Reply sent via {{platform}}",
  "k2.toast.gagalKirim": "The reply to {{nama}} was not sent: {{sebab}}",
  "k2.toast.aksiGagal": "{{nama}}: {{sebab}}",
  "k2.toast.ambilNama": "You now hold the conversation with {{nama}}. The bot stays silent until you return it.",
  "k2.toast.kembalikanNama": "Conversation with {{nama}} returned to the bot",
  "menu.label": "{{peran}} menu",
  "menu.kerja": "Work",
  "menu.pengaturan": "Settings",
  "menu.operasi": "Operations",
  "menu.dataInduk": "Master data",
  "layar.B0": "Home page",
  "layar.B1": "Sign in",
  "layar.K1": "Today",
  "layar.K2": "Needs reply",
  "layar.K3": "Prospects",
  "layar.K4": "Prospect detail",
  "layar.K5": "Meetings",
  "layar.K6": "Content",
  "layar.K7": "Content detail",
  "layar.K8": "Create content",
  "layar.P1": "Chatbot",
  "layar.P2": "Meeting rules",
  "layar.P3": "Automatic content",
  "layar.P4": "Knowledge",
  "layar.P5": "Team",
  "layar.P6": "Connections",
  "layar.P7": "Usage",
  "layar.S1": "Overview",
  "layar.S2": "Tenants",
  "layar.S3": "New tenant",
  "layar.S4": "Tenant detail",
  "layar.S5": "Flow trace",
  "layar.S6": "Usage",
  "layar.S7": "Catalog",
  "layar.S8": "System",
  "layar.bagian": "{{nama}} sections",
  "layar.belumJudul": "This screen is not built yet",
  "layar.belumKeterangan": "{{nama}} is built in stage {{tahap}} of the redesign. Its address, role, and menu already apply.",
  "layar.keTampilanLama": "Open the old interface",
  "layar.K9": "Leads",
  "tab.K4.ringkasan": "Summary",
  "tab.K4.meeting": "Meetings & recordings",
  "tab.K4.percakapan": "Conversation",
  "tab.K4.catatan": "Notes",
  "tab.K6.menunggu": "Waiting for you",
  "tab.K6.terjadwal": "Scheduled",
  "tab.K6.sudah-tayang": "Published",
  "tab.K6.bahan": "Sources",
  "tab.P1.persona": "Persona & policy",
  "tab.P1.data-prospek": "Prospect data",
  "tab.P1.jadwal-balas": "Reply schedule",
  "tab.P1.model": "Model",
  "tab.P3.rantai": "Chain & schedule",
  "tab.P3.sumber": "Sources & style",
  "tab.P3.referensi": "References",
  "tab.P3.model": "Model",
  "tab.S4.ikhtisar": "Overview",
  "tab.S4.sambungan": "Connections",
  "tab.S4.orang": "People",
  "tab.S4.paket": "Plan & cap",
  "tab.S4.aktivitas": "Activity",
  "tab.S5.jalan": "Run records",
  "tab.S5.masuk": "Inbound messages",
  "tab.S7.fitur": "Features",
  "tab.S7.model": "AI models",
  "jaga.judul": "Unsaved changes",
  "jaga.akibat": "If you leave now, these changes are discarded.",
  "jaga.perubahan": "{{n}} changes",
  "jaga.tetap": "Back to the form",
  "jaga.buang": "Discard and leave",
  "jaga.hanyaAdmin": "The {{nama}} page is for Tenant Admin only. You were taken to Today.",
  "jaga.tidakTersedia": "That page is not available to {{peran}}. You were taken to {{beranda}}.",
  "sesi.habisJudul": "Your session has expired",
  "sesi.habisKeterangan": "Sign in again to continue. Unsaved changes are still on this page.",
  "sesi.masukLagi": "Sign in again",
  "sesi.sudahMasukLagi": "You are signed in again.",
  "sesi.masukLagiAdaUbahan": "You are signed in again. Your unsaved changes are still here.",
  "ui.pemberitahuan": "Notifications",
  "ui.urungkan": "Undo",
  "ui.dibatalkan": "Undone.",
  "ui.gagalDibatalkan": "Could not undo: {{sebab}}",
  "ui.tersimpan": "Saved",
  "ui.langsungTersimpan": "Saves instantly",
  "ui.terkunci": "Locked",
  "ui.saklarNyala": "{{nama}}: on",
  "ui.saklarMati": "{{nama}}: off",
  "ui.saklarBatalNyala": "Undone. {{nama}}: on again.",
  "ui.saklarBatalMati": "Undone. {{nama}}: off again.",
  "ui.semuaTersimpan": "All saved",
  "ui.belumDisimpan": "{{n}} unsaved changes",
  "ui.tersimpanPukul": "Saved at {{jam}}",
  "ui.batalkan": "Discard",
  "ui.disimpan": "{{judul}} saved",
  "ui.tidakTersimpan": "Not saved",
  "ui.tabBerubah": "has unsaved changes",
  "k8.ket": "Content you make yourself is not reviewed again. You choose the time.",
  "k8.acuan.label": "Make this content like",
  "k8.acuan.tanpa": "No reference (set it up yourself)",
  "k8.acuan.ketTanpa": "You choose the writing direction, number of slides, and brand images below, and you write the image prompt yourself. The frame and closing page are not used.",
  "k8.acuan.judul": "Reference",
  "k8.acuan.ketKartu": "Choose the shape of the content first. The writing and images follow this choice.",
  "k8.acuan.hasil.video": "Result: 1 video",
  "k8.acuan.hasil.satu": "Result: 1 image, made by AI",
  "k8.acuan.hasil.banyak": "Result: a {{n}}-slide carousel, all made by AI",
  "k8.acuan.hasil.penutup": "Result: a {{n}}-slide carousel ({{ai}} made by AI + the closing page)",
  "k8.acuan.tulisan": "Writing",
  "k8.acuan.gambar": "Images",
  "k8.acuan.tulisanKet.umum": "without product knowledge",
  "k8.acuan.tulisanKet.produk": "AI picks one fitting product",
  "k8.acuan.tulisanKet.iklan": "you pick the product under Content text",
  "k8.acuan.tulisanKet.iklanKosong": "AI picks the product that best fits the title",
  "k8.acuan.gambarKet.bingkai": "1080 × 1350 (4:5), framed",
  "k8.acuan.gambarKet.polos": "No frame; the size follows the image model",
  "k8.acuan.dipakai": "Images this reference uses",
  "k8.acuan.hilang": "Some images of this reference are no longer in the library, so they are left out. A Tenant Admin can fix this under Automatic content.",
  "k8.acuan.diatur": "References are managed by the Tenant Admin under Settings › Automatic content.",
  "k8.acuan.sendiri": "You set everything up yourself",
  "k8.dariBahan": "From a source item",
  "k8.bahanSudah": "Content has already been made from this item. You can still make another.",
  "k8.isi.judul": "Content text",
  "k8.isi.ket": "The text that gets published.",
  "k8.isi.ketKe": "What gets published to {{daftar}}.",
  "k8.isi.judulInternal": "Internal title",
  "k8.isi.judulKet": "Only visible in Smova.",
  "k8.arah.label": "AI writing direction",
  "k8.arah.umum": "Without product knowledge.",
  "k8.arah.produk": "AI reads Knowledge and ties the text to one product.",
  "k8.arah.iklan": "AI writes an ad for the product in Knowledge that best fits the title.",
  "k8.arah.dari": "The last AI text used Knowledge: {{daftar}}.",
  "k8.arah.tanpaBahan": "No Knowledge document fits this title, so the last AI text was written without a product.",
  "k8.arah.ikut": "Writing direction:",
  "k8.arah.ikutKet": "follows the reference",
  "k8.produk.label": "Product to advertise",
  "k8.produk.ket": "The list comes from the reference. The caption is written from this product's document in Knowledge.",
  "k8.produk.kosong": "This reference has no product list yet, so AI picks the product that best fits the title.",
  "k8.isi.tulis": "Write from the title",
  "k8.isi.tiga": "Three options",
  "k8.isi.aiKet": "AI writes the caption, key message and hashtags from the title.",
  "k8.isi.aiButuhJudul": "Fill in the internal title first so AI can write it.",
  "k8.isi.tanpaHasil": "AI returned no text. Try again.",
  "k8.isi.toastTulis": "Text written by AI",
  "k8.isi.toastPilih": "Option applied",
  "k8.isi.pilih": "Pick one",
  "k8.isi.sudut.masalah": "Starts from a problem",
  "k8.isi.sudut.angka": "Starts from a number",
  "k8.isi.sudut.cerita": "Starts from a person's story",
  "k8.gambar.arahanContoh": "Example: a coffee shop owner replying to chats on a phone, morning light",
  "k8.gambar.buatUlang": "Make again",
  "k8.gambar.buatVideo": "Make video",
  "k8.gambar.videoUlang": "Make video again",
  "k8.gambar.berbayar": "Every image made is billed.",
  "k8.gambar.videoKet": "Creating a video with AI is billed and takes 1 to 4 minutes. Uploading your own video is free.",
  "k8.gambar.toastBuat": "Image made from your direction",
  "k8.gambar.toastVideo": "Video made from your direction",
  "k8.gambar.butuhArahan": "Write a direction first, or fill in the caption.",
  "k8.gambar.promptKosong": "AI returned no prompt for this slide. Write it under More settings, or try again.",
  "k8.gambar.promptPanjang": "The prompt is longer than {{batas}} characters. Shorten it first.",
  "k8.gambar.tanpaHasil": "The server returned no result. Try again.",
  "k8.gambar.alt": "Image of slide {{n}}",
  "k8.gambar.ketAcuan": "Follows the reference “{{nama}}”.",
  "k8.gambar.ketTanpa": "You write the prompt, or upload your own image.",
  "k8.gambar.ketTanpaVideo": "You write the prompt, or upload your own video.",
  "k8.gambar.buatN": "Make {{n}} images",
  "k8.gambar.arahanBoleh": "(optional)",
  "k8.gambar.arahanKetAcuan": "AI writes each slide's prompt from the caption, the reference, and this direction. Want to write the prompt yourself? Open “More settings” below.",
  "k8.gambar.unggahSendiri": "Upload your own image",
  "k8.gambar.berbayarPenutup": "Every image made is billed. The closing page is not made by AI, so it is not billed.",
  "k8.gambar.belum": "Slide {{n}} not made yet",
  "k8.gambar.belumVideo": "Video not made yet",
  "k8.gambar.belumKetAcuan": "Made by AI following the reference, or upload your own.",
  "k8.gambar.belumKetTanpa": "Made from your prompt, or upload your own.",
  "k8.gambar.promptWajib": "Write the image prompt first.",
  "k8.gambar.promptWajibAtauAi": "Write the prompt first, or ask AI to write it.",
  "k8.gambar.toastBuatN": "{{n}} images made following the reference",
  "k8.gambar.toastBuatPrompt": "Image made from this prompt",
  "k8.prompt.label": "Image prompt",
  "k8.prompt.contoh": "Describe the image you want. Example: an Eid greeting card in light green tones",
  "k8.prompt.ket": "This text is sent as is to the image model, together with the ticked brand images. AI rewrites nothing.",
  "k8.prompt.ketVideo": "This text is sent as is to the video model.",
  "k8.penutup.judul": "Closing page",
  "k8.penutup.isi": "A fixed image from the reference. Not made by AI, not billed, and always the last slide.",
  "k8.penutup.isiKonten": "A fixed image from the content's reference. AI does not change it, and it stays the last slide.",
  "k8.penutup.ket": "The Tenant Admin replaces the image under Settings › Automatic content › Image library.",
  "k8.penutup.ketBuat": "Don't want it? Choose a reference without a closing page.",
  "k8.penutup.petak": "Slide {{n}}, closing page, locked",
  "k8.penutup.keterangan": "Slide {{n}} · closing page · fixed",
  "k8.gambar.dibuat": "Made with {{model}} · {{biaya}}",
  "k8.gambar.dibuatTanpaTarif": "Made with {{model}} · rate not known yet",
  "k8.unggah.ket": "Uploads: PNG, JPG, or WEBP, up to {{maks}} MB.",
  "k8.unggah.terlaluBesar": "The file is {{ukuran}} MB. The limit is {{maks}} MB.",
  "k8.unggah.toast": "{{nama}} is now the image",
  "k8.slide.tambah": "Add slide",
  "k8.slide.kiri": "Move slide left",
  "k8.slide.kanan": "Move slide right",
  "k8.slide.hapus": "Remove slide {{n}}",
  "k8.slide.ketSatu": "More than one slide makes a carousel.",
  "k8.slide.ketBanyak": "A carousel of {{n}} slides. Slide 1 shows in the feed; each slide is made and billed separately.",
  "k8.slide.maks": "At most {{n}} slides. That is Instagram's limit.",
  "k8.slide.ketAcuanSatu": "One image. The count follows the reference.",
  "k8.slide.ketAcuanBanyak": "A carousel of {{n}} slides. Slide 1 shows in the feed. The count follows the reference.",
  "k8.slide.ketLebih": "This reference draws {{n}} slides. The extra slides can be deleted.",
  "k8.ref.judul": "Brand references included",
  "k8.ref.kosong": "This tenant has no brand references yet.",
  "k8.ref.gambarSaya": "My image",
  "k8.ref.tambah": "Add my image",
  "k8.ref.judulTambahan": "Extra images for this content",
  "k8.ref.ketTambahan": "For example a product photo or an app screenshot. AI sees them after the reference's images, and they are not saved to the library. Up to {{n}}.",
  "k8.ref.tambahSendiri": "Add your own image",
  "k8.ref.buang": "Remove this image of mine",
  "k8.ref.ket": "At most {{n}}. Your own images are not stored and are gone when the page closes.",
  "k8.ref.urutan": "Reference order",
  "k8.ref.naik": "Move {{nama}} up",
  "k8.ref.turun": "Move {{nama}} down",
  "k8.ref.hilang": "A reference that no longer exists",
  "k8.ref.terlaluBesar": "The image is {{ukuran}} MB. The limit is {{maks}} MB.",
  "k8.ref.tidakTerbaca": "The file could not be read.",
  "k8.ref.tanpaModel": "None of this tenant's image models accepts references. Remove the references, or ask the Tenant Admin to add a model that does.",
  "k8.ref.modelSalah": "The chosen model does not accept references. Choose {{model}}, or remove the references.",
  "k8.ref.rasioDiabaikan": "With references, this model ignores the ratio choice and uses its default shape.",
  "k8.ref.tidakDilihat": "The prompt-writing AI did not see the references, because its text model does not accept images. The prompt was written from the caption and direction only.",
  "k8.lanjut.judul": "More settings",
  "k8.lanjut.jenis": "Type",
  "k8.lanjut.foto": "Photo",
  "k8.lanjut.video": "Video",
  "k8.lanjut.jenisKet": "Changing the type clears the images already made.",
  "k8.lanjut.videoKet": "One video per content. Video uses no reference images: AI makes it from the prompt, or you upload your own.",
  "k8.lanjut.model": "Model",
  "k8.lanjut.modelBawaan": "Tenant default",
  "k8.lanjut.modelBawaanKet": "In the Tenant Admin's order. The next one is used if the first fails.",
  "k8.lanjut.modelKosong": "The Tenant Admin has not chosen a model for this type. The system uses its default.",
  "k8.lanjut.tanpaTarif": "rate not known yet",
  "k8.lanjut.rasio": "Ratio",
  "k8.lanjut.rasioBawaan": "Model default · {{rasio}}",
  "k8.lanjut.rasioPenyedia": "set by the provider",
  "k8.lanjut.rasioIkut": "No ratio · follows the model and references",
  "k8.lanjut.prompt": "Prompt",
  "k8.lanjut.promptSlide": "Prompt of slide {{n}}",
  "k8.lanjut.promptContoh": "Leave empty to let AI write it. Or describe the image you want for this slide yourself.",
  "k8.lanjut.promptHitung": "{{n}} / {{batas}} characters",
  "k8.lanjut.promptKet": "This is what is sent to the image model. Edit it, then press the button below.",
  "k8.lanjut.tulis": "Ask AI to write the prompt first",
  "k8.lanjut.tulisSemua": "Ask AI to write the prompt for every slide",
  "k8.lanjut.toastPrompt": "Prompt written",
  "k8.lanjut.dikirim": "See what was sent to AI ({{n}} images attached)",
  "k8.lanjut.isi.prompt": "prompt",
  "k8.lanjut.isi.tambahan": "extra images",
  "k8.lanjut.isi.brand": "brand images",
  "k8.lanjut.isi.model": "model",
  "k8.lanjut.promptKetBingkai": "The frame is still pasted afterwards, so there is no need to mention the logo or contacts.",
  "k8.lanjut.buatDariPrompt": "Make the image from this prompt",
  "k8.lanjut.ulangDariPrompt": "Make it again from this prompt",
  "k8.lanjut.videoDariPrompt": "Make the video from this prompt",
  "k8.lanjut.videoUlangDariPrompt": "Make the video again from this prompt",
  "k8.lanjut.tulisUlang": "Ask AI to rewrite the prompt",
  "k8.lanjut.rasioBingkai": "The 1080 × 1350 size follows the reference's frame.",
  "k8.ubah.judul": "Change this image",
  "k8.ubah.contoh": "Write what to change. Example: make the background dark blue",
  "k8.ubah.ket": "Billed. Only this image and the sentence above are sent.",
  "k8.ubah.takBisa": "This image is not stored in Smova, so it cannot be changed with a direction. Make it again, or upload it again.",
  "k8.ubah.tombol": "Change",
  "k8.ubah.toast": "Image changed",
  "k8.ubah.saranLabel": "Example changes",
  "k8.ubah.saran.judul": "Make the title bigger",
  "k8.ubah.saran.latar": "Make the background dark blue",
  "k8.ubah.saran.teks": "Remove the small text under the title",
  "k8.ubah.saran.utama": "Make the main image bigger",
  "k8.ubah.ketBingkai": "Billed. The frame is pasted again afterwards, so the logo and contacts in the corners do not change.",
  "k8.ganti.judul": "Or replace it entirely",
  "k8.ganti.ket": "Make again creates a new image for this slide only (billed). An uploaded image is used as is; the frame is not pasted.",
  "k8.hasil.judul": "Earlier results",
  "k8.hasil.ke": "Result {{n}}",
  "k8.hasil.ket": "Pick one to use it again.",
  "k8.kapan.judul": "When & where",
  "k8.kapan.ket": "Connected platforms are ticked by default.",
  "k8.kapan.kapan": "When",
  "k8.kapan.draf": "Save as a draft",
  "k8.kapan.drafKet": "Not published until it is scheduled.",
  "k8.kapan.jadwalKet": "Publishes by itself at its time.",
  "k8.kapan.sekarangKet": "Publishes right away.",
  "k8.kapan.simpanDraf": "Save draft",
  "k8.kapan.slotKet": "Filled with the next free slot.",
  "k8.kapan.belumSiap": "{{nama}} cannot be used yet: {{sebab}}.",
  "k8.kurang.judul": "The internal title is empty.",
  "k8.kurang.caption": "The caption is empty.",
  "k8.kurang.gambar": "Make or upload an image first.",
  "k8.kurang.slide": "A slide has no image yet. Make its image, or remove the slide.",
  "k8.kurang.slideAcuan": "Some slides have no image yet. Make them first.",
  "k8.kurang.jam": "Choose the date and time.",
  "k8.toast.draf": "Draft saved under Waiting for you",
  "k7.gambar.sunting": "Edit images",
  "k7.video.judul": "Video",
  "k7.video.ket": "One video. You can upload its cover yourself.",
  "k7.video.unggah": "Upload video",
  "k7.video.sunting": "Edit video",
  "k7.video.toastUnggah": "Video replaced",
  "k7.video.syarat": "Uploaded video: vertical 9:16 MP4, 3 to 90 seconds, up to {{maks}} MB.",
  "k7.sampul.judul": "Video cover",
  "k7.sampul.ket": "The image shown before the video plays. If empty, Instagram and Facebook pick a frame themselves.",
  "k7.sampul.kosong": "No cover yet.",
  "k7.sampul.alt": "Video cover",
  "k7.sampul.unggah": "Upload cover",
  "k7.sampul.ganti": "Replace cover",
  "k7.sampul.lepas": "Remove cover",
  "k7.sampul.syarat": "PNG, JPG, or WEBP, up to {{maks}} MB. Best vertical 9:16, like the video.",
  "k7.sampul.toast": "Cover set",
  "k7.sampul.toastLepas": "Cover removed",
  "k8.video.unggah": "Upload your own video",
  "k8.video.toast": "{{nama}} is now the video",
  "k7.sunting.ket": "What you do here only takes effect after Save images.",
  "k7.sunting.simpan": "Save images",
  "k7.sunting.toast": "Images saved",
  "k7.sunting.belumBerubah": "Nothing changed yet",
  "k7.sunting.belumDisimpan": "Images not saved yet",
  "k7.sunting.slideKosong": "A slide has no image yet",
  "k7.sunting.tanpaBahan": "Existing images cannot be changed with a direction yet",
  "k6.video": "Video of the content {{judul}}",
  "k8.kurang.tanpaPlatform": "No platform can be used yet, so content cannot be made.",
  "k9.ket": "People still handled by the bot.",
  "k9.ringkas": "{{n}} lead(s) handled by the bot",
  "k9.lengkapN": "{{n}} with complete data",
  "k9.cari": "Search leads",
  "k9.cariContoh": "Search by name or contact",
  "k9.gagal": "Leads failed to load",
  "k9.jalur": "Lead stages",
  "k9.semua": "All",
  "k9.semuaKet": "Handled by the bot",
  "k9.tahap.jajaki": "Exploring",
  "k9.tahap.kumpul": "Collecting data",
  "k9.tahap.lengkap": "Data complete",
  "k9.tahap.tidakLanjut": "Not pursued",
  "k9.tahapKet.jajaki": "The bot answers questions",
  "k9.tahapKet.kumpul": "The bot asks for basic data",
  "k9.tahapKet.lengkap": "The bot offers a meeting",
  "k9.tahapKet.tidakLanjut": "Can be restored",
  "k9.keProspek": "Managed by the team",
  "k9.daftar": "Lead list",
  "k9.kosongJudul": "No leads yet",
  "k9.kosongIsi": "Leads appear here once the bot recognises a potential customer in a conversation.",
  "k9.tahapKosong": "No leads at this stage",
  "k9.cariKosong": "Nothing matches “{{kata}}”",
  "k9.kolom.calon": "Lead",
  "k9.kolom.tahap": "Stage",
  "k9.kolom.keadaan": "Status",
  "k9.kolom.data": "Data",
  "k9.kolom.aktif": "Last active",
  "k9.keadaan.botMati": "The bot is off for this person. The team replies.",
  "k9.keadaan.menjajaki": "The bot answers their questions.",
  "k9.keadaan.kurang": "The bot is completing their data.",
  "k9.keadaan.kurangDaftar": "The bot is asking for: {{daftar}}.",
  "k9.keadaan.mauMeeting": "Wants a meeting. The bot is offering times.",
  "k9.keadaan.belumMau": "Does not want a meeting yet.",
  "k9.keadaan.belumDitanya": "Not asked about a meeting yet.",
  "k9.keadaan.tidakLanjut": "Set aside. The bot still answers general questions.",
  "k9.pulihkan": "Restore",
  "k9.toast.pulih": "{{nama}} restored",
  "k9.kaki": "{{n}} lead(s) · any row opens its details",
  "k9.menunggu": "Waiting for your decision",
  "k9.menungguN": "{{n}} waiting for your decision",
  "k9.terima.tombol": "Accept",
  "k9.terima.tanya": "Accept {{nama}}?",
  "k9.terimaDini.tombol": "Accept now",
  "k9.terimaDini.tanya": "Accept {{nama}} now?",
  "k9.terimaDini.ket": "Their details are not complete yet. This candidate moves to Prospects, and the bot keeps collecting the details, then offers a meeting without waiting for another decision. No message is sent now, and this acceptance cannot be withdrawn from the screen.",
  "k9.toast.terimaDini": "{{nama}} accepted. The bot continues collecting their details.",
  "k9.terima.ket": "This lead moves to Prospects, and the bot offers a meeting as soon as they reply again.",
  "k9.tolak.tombol": "Reject",
  "k9.tolak.judul": "Reject {{nama}}?",
  "k9.tolak.ket": "The bot will not offer a meeting but still answers general questions. This lead moves to Not pursued and can be restored.",
  "k9.tolak.alasan": "Reason",
  "k9.tolak.catatan": "Note for the team (optional)",
  "k9.tolak.catatanContoh": "For example: contact again next year",
  "k9.alasan.luar_sasaran": "Outside our target",
  "k9.alasan.belum_siap": "Not ready to buy",
  "k9.alasan.sudah_ditangani": "Already handled elsewhere",
  "k9.alasan.lainnya": "Other",
  "k9.toast.terima": "{{nama}} accepted",
  "k9.toast.tolak": "{{nama}} rejected",
  "k9.keadaan.menunggu": "Data complete. The bot has not offered a meeting yet.",
  "k9.keadaan.ditolak": "Rejected: {{alasan}}.",
  "k9.diputuskan": "{{oleh}} · {{kapan}}",
  "hari.1": "Mon",
  "hari.2": "Tue",
  "hari.3": "Wed",
  "hari.4": "Thu",
  "hari.5": "Fri",
  "hari.6": "Sat",
  "hari.7": "Sun",
  "pm.tanpaTarif": "rate not known yet",
  "pm.biayaToken": "{{masuk}} in · {{keluar}} out per 1 million tokens",
  "pm.kiraBalasan": "about {{biaya}} per {{per}} replies, from this team's {{n}} replies in the last {{hari}} days",
  "pm.kiraKonsep": "about {{biaya}} per concept, from this team's {{n}} concepts in the last {{hari}} days",
  "pm.biayaGambar": "{{biaya}} per image",
  "pm.biayaDetik": "{{biaya}} per second of video",
  "pm.utama": "Main model",
  "pm.bawaan": "Smova default",
  "pm.bawaanKet": "Smova decides the model and its order.",
  "pm.cadangan": "Backups if the main model fails, in order",
  "pm.tanpaCadangan": "No backup yet. If the main model fails, the request fails.",
  "pm.naik": "Move {{nama}} up",
  "pm.turun": "Move {{nama}} down",
  "pm.lepas": "Remove {{nama}} from backups",
  "pm.modelCadangan": "Backup model",
  "pm.tambahCadangan": "Add backup",
  "pm.gagal": "The model list did not load",
  "pm.kosong": "The Smova catalogue has no model for this purpose yet.",
  "pm.minggu.judul": "This week",
  "pm.minggu.ket": "From the saved schedule.",
  "pm.minggu.selalu": "24 hours",
  "p1.ket": "How the bot replies to DMs and comments.",
  "p1.tab.label": "Chatbot sections",
  "p1.tab.persona": "Persona & policy",
  "p1.tab.data": "Prospect data",
  "p1.tab.jadwal": "Reply schedule",
  "p1.tab.model": "Model",
  "p1.wajib": "Required.",
  "p1.maks": "At most {{n}} characters.",
  "p1.emailSalah": "That email address is incomplete.",
  "p1.persona.gagal": "The persona did not load",
  "p1.identitas.judul": "Bot identity",
  "p1.identitas.ket": "The name and tone the bot uses when it replies.",
  "p1.identitas.nama": "Bot name",
  "p1.identitas.perusahaan": "Company name",
  "p1.identitas.bidang": "Line of business",
  "p1.identitas.bidangKet": "One sentence on what your company does. The bot uses it to introduce itself.",
  "p1.identitas.email": "Referral email",
  "p1.identitas.emailKet": "The bot gives it when a prospect asks to be contacted by email.",
  "p1.identitas.gaya": "Tone",
  "p1.gaya.formal": "Formal",
  "p1.gaya.ramah": "Friendly",
  "p1.gaya.santai": "Casual",
  "p1.kebijakan.judul": "Business policy",
  "p1.kebijakan.ket": "The limits the bot keeps when a conversation turns to sales.",
  "p1.kebijakan.melayani": "Serves",
  "p1.kebijakan.demo": "Demo or trial",
  "p1.kebijakan.catatan": "Special notes",
  "p1.kebijakan.catatanKet": "Extra rules the bot always reads.",
  "p1.melayani.b2b": "Businesses (B2B)",
  "p1.melayani.b2c": "Individuals (B2C)",
  "p1.melayani.keduanya": "Both",
  "p1.demo.meeting": "Through a meeting",
  "p1.demo.mandiri": "Self-serve",
  "p1.pratinjau.judul": "What the bot reads",
  "p1.pratinjau.ket": "From the saved values. Changes after Save.",
  "p1.pagar.judul": "Always in force",
  "p1.pagar.ket": "These rules are built into the bot and nobody can switch them off.",
  "p1.pagar.1": "The bot never claims to be human, even when a customer insists or is upset.",
  "p1.pagar.2": "The bot does not name products missing from your knowledge documents. It would rather say it does not know.",
  "p1.pagar.3": "The bot promises nothing that is not in these settings.",
  "p1.data.judul": "Data the bot collects",
  "p1.data.ket": "The bot asks for the switched-on data, one by one from the top, before offering a meeting.",
  "p1.data.gagal": "The prospect data did not load",
  "p1.data.ditanyakan": "Asked before a meeting",
  "p1.data.tambahan": "Not asked; recorded if the prospect mentions it",
  "p1.data.terisi": "{{n}} prospects have filled it in",
  "p1.data.berhenti": "No longer collected",
  "p1.data.naik": "Move {{nama}} up",
  "p1.data.turun": "Move {{nama}} down",
  "p1.data.banyakJudul": "The bot asks for {{n}} pieces of data",
  "p1.data.banyakIsi": "The more it asks, the more the chat feels like a form, and buyers drop out midway. Switch off what your team can ask in the meeting.",
  "p1.data.ubahNama": "Rename",
  "p1.data.namaBaru": "New name for {{nama}}",
  "p1.data.toastNama": "Question renamed",
  "p1.tipe.teks": "text",
  "p1.tipe.angka": "number",
  "p1.tipe.email": "email",
  "p1.tipe.telepon": "phone",
  "p1.tambahan.judul": "Extra questions",
  "p1.tambahan.ket": "Data beyond Smova's defaults. Switched-off ones stop being collected; existing answers are kept.",
  "p1.tambahan.kosong": "No extra questions yet.",
  "p1.tambahan.pertanyaan": "Data to ask for",
  "p1.tambahan.pertanyaanKet": "The name of the data, as your team will read it.",
  "p1.tambahan.kunci": "Stored as {{kunci}}. The key cannot be changed later.",
  "p1.tambahan.contoh": "Example: Number of employees",
  "p1.tambahan.tipe": "Answer type",
  "p1.tambahan.tambah": "Add question",
  "p1.tambahan.tambahKet": "The bot asks it from the next conversation on.",
  "p1.tambahan.toast": "Question added",
  "p1.jadwal.judul": "Reply schedule",
  "p1.jadwal.ket": "When the bot replies by itself.",
  "p1.jadwal.gagal": "The schedule did not load",
  "p1.jadwal.mode": "The bot replies",
  "p1.jadwal.selalu": "Always, 24 hours",
  "p1.jadwal.mingguan": "Weekly",
  "p1.jadwal.hari": "Days",
  "p1.jadwal.mulai": "From",
  "p1.jadwal.selesai": "Until",
  "p1.jadwal.luar": "Outside those hours",
  "p1.jadwal.luarKet": "The conversation still lands in the inbox either way.",
  "p1.jadwal.diam": "Stay silent",
  "p1.jadwal.balas": "Send one message",
  "p1.jadwal.pesan": "Out-of-hours message",
  "p1.jadwal.pesanKet": "Sent once per conversation.",
  "p1.jadwal.pesanBawaan": "Sent once per conversation. This is Smova's default text; saving makes your own copy.",
  "p1.jadwal.hariKosong": "Choose at least one day.",
  "p1.jadwal.jamTerbalik": "The end time must be after the start time.",
  "p1.jadwal.pesanKosong": "Write the message, or choose Stay silent.",
  "p1.jadwal.luarPesan": "out-of-hours message",
  "p1.jadwal.luarDiam": "silent",
  "p1.model.judul": "Chat reply model",
  "p1.model.ket": "The model that writes DM and comment replies. This choice is billed, so it waits for Save.",
  "p2.ket": "When, to whom, and how the bot offers meetings.",
  "p2.pratinjau.judul": "What the bot offers now",
  "p2.pratinjau.gagal": "Preview did not load",
  "p2.pratinjau.tanggal": "A prospect who qualifies today is offered {{tanggal}}, starting between {{awal}} and {{akhir}}.",
  "p2.pratinjau.atau": ", or ",
  "p2.pratinjau.kosongTanggal": "There is no date the bot can offer in the next two weeks.",
  "p2.pratinjau.durasi": "Each meeting lasts {{durasi}} minutes, so it ends by {{selesai}} at the latest.",
  "p2.pratinjau.satu": "At most 1 meeting a day: one meeting locks the whole day.",
  "p2.pratinjau.banyak": "At most {{n}} meetings a day; times already taken are not offered again.",
  "p2.pratinjau.jamKosong": "Start times on an empty day:",
  "p2.pratinjau.bawaan": "Meeting hours were never saved: the bot uses 08:00 to 15:00.",
  "p2.pratinjau.ket": "Worked out from the fields below, and updated as soon as you save. Holidays and whole-team leave are included.",
  "p2.jam.judul": "When",
  "p2.jam.ket": "Days, hours, and how many meetings a day. Applies to the whole team.",
  "p2.jam.gagal": "Meeting hours did not load",
  "p2.jam.hariKet": "Saturday and Sunday are never offered.",
  "p2.jam.mulai": "Start time",
  "p2.jam.selesai": "End time",
  "p2.jam.selesaiKet": "Meetings must be over by this time.",
  "p2.jam.durasi": "Meeting length",
  "p2.jam.tidakMuat": "With {{durasi}}-minute meetings, the end time must be {{jam}} or later.",
  "p2.jam.belumDiatur": "Never saved: the bot currently offers start times from 08:00 to 15:00.",
  "p2.jam.setengah": "Days and hours were saved, but the rest was not: {{pesan}}",
  "p2.maks.label": "Meetings per day, at most",
  "p2.maks.ket": "Default 1. A full day is not offered, and times already taken are skipped.",
  "p2.maks.kurang": "Decrease",
  "p2.maks.tambah": "Increase",
  "p2.kapasitas.judul": "A limit of {{maks}} a day does not fit",
  "p2.kapasitas.isi": "{{awal}} to {{selesai}} only fits {{n}} meetings of {{durasi}} minutes with a {{jeda}}-minute gap. The bot offers at most {{n}}.",
  "p2.cepat.label": "Earliest date",
  "p2.cepat.satuan": "days after today",
  "p2.cepat.ket": "1 = tomorrow, 2 = the day after. Weekends and holidays are skipped.",
  "p2.belumSetelan": "Length, meetings per day, and earliest date can be set once a Smova operator has prepared this tenant's meeting settings.",
  "p2.syarat.data": "Prospect data that must be collected",
  "p2.syarat.dataKosong": "The bot does not collect any prospect data yet.",
  "p2.syarat.jedaHariSalah": "Enter 0 to 30 days.",
  "p2.syarat.jedaMenit": "Gap between meetings",
  "p2.syarat.jedaMenitKet": "Free time between two meetings on the same day.",
  "p2.syarat.bentuk": "Meeting format",
  "p2.syarat.lokasi": "In-person location",
  "p2.syarat.lokasiKet": "The bot's first suggestion when a prospect chooses to meet in person. The prospect can still name another place.",
  "p2.syarat.lokasiWajib": "Enter the location, or choose Online only.",
  "p2.syarat.menit": "{{n}} min",
  "p2.bentuk.online": "Online only",
  "p2.bentuk.offline": "In person only",
  "p2.bentuk.keduanya": "Both",
  "p2.bagaimana.judul": "How",
  "p2.bagaimana.ket": "The meeting format the bot offers.",
  "p2.bagaimana.gagal": "Meeting format did not load",
  "p2.siapa.judul": "To whom",
  "p2.siapa.ket": "The bot only offers a time once this data has been collected.",
  "p2.siapa.dataKet": "Added to the data that is required in Chatbot.",
  "p2.siapa.gagal": "Prospect requirements did not load",
  "p2.libur.judul": "Holidays",
  "p2.libur.ket": "The whole team is off. Individual leave is set by each person in Meetings.",
  "p2.libur.gagal": "Holidays did not load",
  "p2.libur.kosong": "No upcoming holidays.",
  "p2.libur.tanggal": "Date",
  "p2.libur.keterangan": "Description",
  "p2.libur.contoh": "Example: Eid al-Fitr",
  "p2.libur.tambah": "Add",
  "p2.libur.akanDatang": "Upcoming · {{n}}",
  "p2.libur.lewat": "Past dates are not shown.",
  "p2.libur.lewatTambah": "That date has passed. Pick today or a later date.",
  "p2.libur.hapus": "Remove holiday {{tanggal}}",
  "p2.libur.toastTambah": "{{tanggal}} marked as a holiday",
  "p2.libur.toastHapus": "Holiday {{tanggal}} removed",
  "p2.gerbang.judul": "Team approval",
  "p2.gerbang.ket": "The team chooses which leads are offered a meeting.",
  "p2.gerbang.label": "Ask the team to approve before the bot offers a meeting",
  "p2.gerbang.nyala": "On: the bot stops once a lead's data is complete. The team accepts or rejects it under Leads, or from its card in the Telegram group.",
  "p2.gerbang.mati": "Off: once the data above is collected, the bot offers a meeting right away.",
  "p2.gerbang.gagal": "Approval setting did not load",
  "p3.ket": "The chain from source material to publishing, for Instagram and Facebook",
  "p3.gagal": "The content settings did not load",
  "p3.tab.label": "Automatic content sections",
  "p3.tab.rantai": "Chain & schedule",
  "p3.tab.sumber": "Sources & style",
  "p3.tab.referensi": "References",
  "p3.tab.model": "Models",
  "p3.cariTakAda": "Finding material is not in your plan, so its schedule and sources are not set here. Ask the Smova operator.",
  "p3.rantai.judul": "Content chain",
  "p3.rantai.ket": "For content from the automatic search. Content from /campaign, /analyze, and the trend button always waits for you in Content.",
  "p3.rantai.langkah": "Step {{n}}",
  "p3.rantai.terkunci": "Not in your plan. Ask the Smova operator.",
  "p3.langkah.cari.judul": "Find material",
  "p3.langkah.cari.nyala": "The bot looks for news and trends on the schedule below.",
  "p3.langkah.cari.mati": "No search runs. No new material comes in.",
  "p3.langkah.cari.ya": "Running",
  "p3.langkah.cari.tidak": "Off",
  "p3.langkah.susun.judul": "Draft concepts",
  "p3.langkah.susun.nyala": "Incoming material is drafted straight into a caption and an image prompt.",
  "p3.langkah.susun.mati": "Material waits until the team creates content themselves.",
  "p3.langkah.susun.ya": "Running",
  "p3.langkah.susun.tidak": "Off",
  "p3.langkah.konsep.judul": "Approve concepts automatically",
  "p3.langkah.konsep.nyala": "Concepts go straight on to image creation without review.",
  "p3.langkah.konsep.mati": "Concepts wait in Content › Waiting for you.",
  "p3.langkah.konsep.ya": "Automatic",
  "p3.langkah.konsep.tidak": "Team reviews",
  "p3.langkah.gambar.judul": "Approve images automatically",
  "p3.langkah.gambar.nyala": "Finished images are scheduled into their slot and publish on their own.",
  "p3.langkah.gambar.mati": "Images wait in Content › Waiting for you.",
  "p3.langkah.gambar.ya": "Automatic",
  "p3.langkah.gambar.tidak": "Team reviews",
  "p3.jadwal.judul": "Search schedule",
  "p3.jadwal.ket": "How often the bot looks for new material.",
  "p3.jadwal.kali": "How often",
  "p3.jadwal.sehari": "{{n}}× a day",
  "p3.jadwal.mulai": "Starting at",
  "p3.jadwal.hari": "Days",
  "p3.jadwal.hariKosong": "Choose at least one day.",
  "p3.jadwal.jamJalan": "The bot searches at {{jam}}.",
  "p3.jadwal.asingJudul": "This schedule was written outside this screen",
  "p3.jadwal.asingIsi": "Its form is not recognised, and it keeps running as it is. Replace it with a regular schedule to manage it from here.",
  "p3.jadwal.pakaiBiasa": "Use a regular schedule",
  "p3.jadwal.toastBiasa": "Schedule replaced: once a day at 09.00, Monday to Friday",
  "p3.buang.judul": "Content left waiting",
  "p3.buang.ket": "Concepts and images nobody decided on.",
  "p3.buang.hari": "Discard after (days)",
  "p3.buang.hariKet": "From the automatic search and from /campaign, along with their data. Enter 0 to never discard.",
  "p3.buang.salah": "Enter a whole number from 0 to 365.",
  "p3.slot.referensi": "Reference of slot {{n}}",
  "p3.slot.kepala.referensi": "Reference",
  "p3.slot.bawaanTanda": "{{nama}} (default)",
  "p3.slot.tanpaPilihan": "No references yet",
  "p3.slot.referensiKosong": "Pick a reference for this slot.",
  "p3.slot.aturReferensi": "Manage references",
  "p3.slot.tanpaReferensiJudul": "No references yet",
  "p3.slot.tanpaReferensi": "Publishing slots need a reference: its direction, type, brand images, and image prompt.",
  "p3.slot.kepala.jam": "Time",
  "p3.slot.kepala.platform": "Platform",
  "p3.arah.umum.judul": "General",
  "p3.arah.produk.judul": "With product",
  "p3.arah.iklan.judul": "Product ad",
  "p3.iklan.label": "Advertised products",
  "p3.iklan.ket": "Content from this reference takes one document each time, in turn. Tick product documents only, not the profile or terms.",
  "p3.iklan.mati": "{{nama}} · off in Knowledge",
  "p3.iklan.kosongJudul": "No product has been chosen yet",
  "p3.iklan.kosong": "This reference cannot make an ad until a document is ticked.",
  "p3.iklan.wajib": "Tick at least one product for the Product ad direction.",
  "p3.arah.pengetahuan": "Its material comes from Knowledge: {{n}} documents are on.",
  "p3.arah.pengetahuanKosongJudul": "No Knowledge document is switched on yet",
  "p3.arah.pengetahuanKosong": "Content with the With product and Product ad directions is written as general until a document exists.",
  "p3.arah.bukaPengetahuan": "Open Knowledge",
  "p3.slot.judul": "Publishing slots",
  "p3.slot.ket": "When automatic content publishes each day. Each slot uses one reference; its direction, type, brand images, and prompt are set in the References tab.",
  "p3.slot.jam": "Time of slot {{n}}",
  "p3.slot.tujuan": "Platforms for the {{jam}} slot",
  "p3.slot.hapus": "Remove the {{jam}} slot",
  "p3.slot.tambah": "Add slot",
  "p3.slot.penuh": "At most {{n}} slots a day.",
  "p3.slot.ringkas": "{{konten}} posts and {{gambar}} images are made per day.",
  "p3.slot.video": "Video slots stop at the draft. The team creates or uploads the video in Content.",
  "p3.slot.belumSiap": "{{nama}} is not ready to publish: {{sebab}}",
  "p3.slot.jamSalah": "Enter a time for this slot.",
  "p3.slot.slideSalah": "A carousel has 2 to {{n}} slides.",
  "p3.slot.tujuanKosong": "Choose at least one platform for this slot.",
  "p3.jenis.foto": "Photo",
  "p3.jenis.carousel": "Carousel",
  "p3.jenis.video": "Video",
  "p3.sumber.judul": "Sources & topics",
  "p3.sumber.ket": "Where the bot looks for material, and on which topics.",
  "p3.sumber.sumber": "Sources",
  "p3.sumber.sumberKet": "You choose keywords, not news sites. The search results decide which sites appear.",
  "p3.sumber.sumberKosong": "Choose at least one source.",
  "p3.sumber.topik": "Topics",
  "p3.sumber.topikKet": "Separate with commas.",
  "p3.sumber.topikKosong": "Enter at least one topic.",
  "p3.sumber.bahasa": "Language of the material",
  "p3.sumber.bahasaKet": "Sets the language and country of the search results. Topics in another language pull in unrelated news.",
  "p3.gaya.judul": "Brand visual style",
  "p3.gaya.ket": "The brand's visual taste. The technical image rules stay with the system.",
  "p3.gaya.teks": "Visual style",
  "p3.gaya.teksKet": "Palette, kind of image, mood. May be empty: the style then comes from the brand images used automatically.",
  "p3.gaya.contoh": "Example: flat illustration, navy and green palette, plain background",
  "p3.ref.judul": "Image library",
  "p3.ref.daftar": "Image library",
  "p3.ref.dipakaiOleh": "Used by: {{daftar}}",
  "p3.ref.belumDipakai": "Not used by any reference yet",
  "p3.ref.sebagaiBingkai": "{{nama}} (frame)",
  "p3.ref.sebagaiPenutup": "{{nama}} (closing page)",
  "p3.rk.judul": "Content references",
  "p3.rk.ket": "One reference is one package: writing direction, type, brand images, and its image prompt. Publishing slots and Create content simply pick it.",
  "p3.rk.gagal": "References did not load",
  "p3.rk.daftar": "Reference list",
  "p3.rk.baru": "New reference",
  "p3.rk.bawaan": "Default",
  "p3.rk.bawaanKet": "used by /campaign, news picked from Telegram, and concepts from the Materials tab",
  "p3.rk.simpanDulu": "Save or discard this change first to open another reference.",
  "p3.rk.slot": "Slot {{jam}}",
  "p3.rk.tanpaSlot": "Not used by a slot yet",
  "p3.rk.carouselN": "Carousel, {{n}} slides",
  "p3.rk.gambarN": "{{n}} brand images",
  "p3.rk.nama": "Reference name",
  "p3.rk.namaKet": "This name appears in the reference choice of each publishing slot and in Create content.",
  "p3.rk.namaKosong": "Give this reference a name.",
  "p3.rk.arah": "Writing direction",
  "p3.rk.arahKet.umum": "Information, insight, or a story around the news. No product is mentioned.",
  "p3.rk.arahKet.produk": "The news is tied to one product from Knowledge. If no document fits, it is written as general.",
  "p3.rk.arahKet.iklan": "An ad for one product, without news. The product rotates through the ones ticked below.",
  "p3.rk.jenis": "Type",
  "p3.rk.jenisKet.carousel": "Each slide is one image, so the cost multiplies.",
  "p3.rk.jenisKet.video": "Video content stops at draft; the team makes or uploads the video in Content. Brand images and the image prompt are not used.",
  "p3.rk.slide": "Number of slides",
  "p3.rk.gambar": "Images for this reference",
  "p3.rk.gambarKet": "Give each image one role. Brand images are seen by the AI as reference, up to {{maks}}. The frame is a transparent 4:5 PNG holding the logo and contact details: the AI sees it as the canvas, then the frame is pasted back from its original file once the image is done, so it is always the same. The closing page becomes the last carousel slide and is not drawn by the AI.",
  "p3.rk.gambarKosong": "No images in the library yet. Upload one here.",
  "p3.rk.gambarDaftar": "Library images and their roles",
  "p3.rk.gambarHitung": "{{n}} of {{maks}} brand images picked.",
  "p3.rk.peranUntuk": "Role of {{nama}}",
  "p3.rk.peran.tanpa": "Not used",
  "p3.rk.peran.brand": "Brand image",
  "p3.rk.peran.bingkai": "Frame",
  "p3.rk.peran.bingkaiBukanPng": "Frame (must be PNG)",
  "p3.rk.peran.penutup": "Closing page",
  "p3.rk.peranKet.tanpa": "Not used by this reference",
  "p3.rk.peranKet.brand": "Image {{n}} in the prompt",
  "p3.rk.peranKet.bingkai": "Image 1 in the prompt (the canvas), then pasted back from this file",
  "p3.rk.peranKet.penutup": "Last carousel slide; not seen by the AI",
  "p3.rk.hilang.bingkai": "The saved frame is no longer in the library.",
  "p3.rk.hilang.penutup": "The saved closing page is no longer in the library.",
  "p3.rk.hilang.lepas.bingkai": "Remove frame",
  "p3.rk.hilang.lepas.penutup": "Remove closing page",
  "p3.rk.penutupHitung": "A {{n}}-slide carousel: {{gambar}} drawn by the AI, then this page.",
  "p3.rk.berbingkai": "framed",
  "p3.rk.toastUnggahPilih": "“{{nama}}” was uploaded. Pick its role in the list.",
  "p3.rk.prompt": "Image prompt",
  "p3.rk.belumJudul": "No references yet",
  "p3.rk.belumIsi": "Automatic content has no reference yet. Fill in the first one below, then Save.",
  "p3.rk.tanpaBawaanJudul": "No default reference yet",
  "p3.rk.tanpaBawaanIsi": "Open one of the references, tick Default, then Save. Until then, /campaign and news picked from Telegram have no reference.",
  "p3.rk.baruKet": "A new reference can be picked by publishing slots and Create content once it is saved.",
  "p3.rk.satuSaja": "There is only one reference so far, so every slot uses it. Add another with the New reference button.",
  "p3.rk.gantiBawaan": "The default reference cannot be deleted. To change the default, open another reference and tick Default.",
  "p3.rk.dipakaiSlot": "Used by slot {{jam}}.",
  "p3.rk.hapusDipakai": "Move that slot to another reference first if you want to delete this one.",
  "p3.rk.belumDipakai": "Not used by any slot yet. Pick it in the Chain & schedule tab, Publishing slots card.",
  "p3.rk.hapus": "Delete reference",
  "p3.rk.hapusTanya": "Delete the reference “{{nama}}”?",
  "p3.rk.hapusRincian": "The reference is deleted and cannot be restored. Content already made does not change.",
  "p3.rk.toastHapus": "“{{nama}}” deleted",
  "p3.rk.uji.judul": "Test this reference",
  "p3.rk.uji.ket": "Uses the fields above, including unsaved ones. The result does not go into Content and is not sent to Telegram.",
  "p3.rk.uji.topik": "Sample topic",
  "p3.rk.uji.topikContoh": "e.g. Health insurance claims are rising this year",
  "p3.rk.uji.produk": "Product to test",
  "p3.rk.uji.tanpaProduk": "Tick the product first",
  "p3.rk.uji.tulisan": "Test the writing",
  "p3.rk.uji.caption": "Caption",
  "p3.rk.uji.dari": "From Knowledge: {{daftar}}",
  "p3.rk.uji.tanpaBahan": "No Knowledge document fits; written as general.",
  "p3.rk.uji.prompt": "Image prompt",
  "p3.rk.uji.ragam": "Layout number {{n}}, picked by the system from the topic and caption.",
  "p3.rk.uji.slide": "Slide {{n}}",
  "p3.rk.uji.gambar": "Make {{n}} sample images",
  "p3.rk.uji.berbayar": "Paid",
  "p3.rk.uji.gambarTanya": "Make {{n}} sample images?",
  "p3.rk.uji.gambarRincian": "Each image is billed like a regular content image. The result is not saved.",
  "p3.rk.uji.gambarYa": "Make images",
  "p3.rk.uji.hasilGambar": "Sample images",
  "p3.rk.uji.altGambar": "Sample image, slide {{n}}",
  "p3.rk.uji.penutup": "Closing page",
  "p3.rk.uji.berpenutup": "The last slide is the fixed closing page, at no image cost.",
  "p3.rk.uji.altPenutup": "Closing page: {{nama}}",
  "p3.ref.ket": "All images of this tenant: logos, mascots, style samples, frames, and closing pages. Each image's role is set in each reference above; here you manage its name, its note, and retiring it.",
  "p3.ref.unggah": "Upload image",
  "p3.ref.mengunggah": "Uploading…",
  "p3.ref.gagalUnggah": "The image was not uploaded",
  "p3.ref.gagal": "The image library could not be loaded",
  "p3.ref.belumJudul": "The image library is empty",
  "p3.ref.belumIsi": "Without images in the library, content images are made without a logo or any brand asset.",
  "p3.ref.tanpaUntuk": "No note yet on what this image is for.",
  "p3.ref.ubah": "Edit",
  "p3.ref.nama": "Image name",
  "p3.ref.untuk": "What this image is for",
  "p3.ref.untukContoh": "Example: Official logo. Place it top left, do not redraw it.",
  "p3.ref.untukKet": "Read by the AI along with the image. Leave empty if the AI should not pick this image by itself.",
  "p3.ref.toastUbah": "Image details saved",
  "p3.ref.pensiun": "Retire",
  "p3.ref.pensiunTanya": "Retire “{{nama}}”?",
  "p3.ref.pensiunRincian": "This image is no longer used for new content. Existing content does not change.",
  "p3.ref.toastPensiun": "“{{nama}}” retired",
  "p3.ref.toastUnggah": "“{{nama}}” uploaded.",
  "p3.ref.dikecilkan": "The image was resized before upload.",
  "p3.prompt.teksKet": "Topic, caption, brief, and the image list are still sent when not inserted, appended to the end of the prompt.",
  "p3.prompt.contoh": "Write the instructions for the AI here.",
  "p3.prompt.kosong": "Write the instructions first.",
  "p3.prompt.sisipkan": "Insert",
  "p3.tempat.topik": "Topic",
  "p3.tempat.caption": "Caption",
  "p3.tempat.pesan": "Key message",
  "p3.tempat.brief": "Brief",
  "p3.tempat.bahan": "Image list",
  "p3.tempat.slideKe": "Slide no.",
  "p3.tempat.jumlah": "Slide count",
  "p3.tempat.ragam": "Layout",
  "p3.tempatKet.topik": "the headline and summary from the search",
  "p3.tempatKet.caption": "the caption the AI already wrote for this content",
  "p3.tempatKet.pesan": "the key message of the content",
  "p3.tempatKet.brief": "direction from the Fix button in Telegram or the brief in Create content",
  "p3.tempatKet.bahan": "the images sent along, numbered, with what each is for",
  "p3.tempatKet.slideKe": "the number of the slide being written",
  "p3.tempatKet.jumlah": "the number of carousel slides",
  "p3.tempatKet.ragam": "a number from 1 to 6 picked by the system for each piece of content, the same on all its slides; replace 6 with the number of layouts written in the prompt",
  "p3.model.teks": "Text model",
  "p3.model.teksKet": "Writes captions, key messages, and image prompts.",
  "p3.model.gambar": "Image model",
  "p3.model.gambarKet": "Creates the content images. This choice is felt most in cost.",
  "p3.model.video": "Video model",
  "p3.model.videoKet": "Used when the team creates a video in Content.",
  "p4.ket": "Documents the bot answers from",
  "p4.ringkas": "{{n}} documents used by the bot · {{potongan}} chunks",
  "p4.unggah.tombol": "Upload document",
  "p4.unggah.memproses": "Processing…",
  "p4.unggah.gagal": "The document was not uploaded",
  "p4.unggah.jenisSalah": "“{{nama}}” cannot be read yet. Accepted: .txt, .md, .csv, and .json. Save a PDF or Word file as .txt first.",
  "p4.unggah.terlaluBesar": "The file is {{kb}} KB. The limit is {{maks}} KB; split it into several documents.",
  "p4.unggah.toast": "{{nama}} added: {{n}} chunks ready for the bot",
  "p4.dok.judul": "Documents",
  "p4.dok.ket": "The bot reads only the documents that are on. Their contents are not shown here.",
  "p4.dok.gagal": "The documents did not load",
  "p4.dok.kosong": "No documents yet",
  "p4.dok.kosongKet": "The bot has nothing to answer from yet. Upload your first document.",
  "p4.dok.cari": "Search documents",
  "p4.dok.tidakCocok": "No document matches.",
  "p4.dok.namaVersi": "{{nama}} ({{versi}})",
  "p4.dok.hapus": "Delete",
  "p4.dok.hapusTanya": "Permanently delete {{nama}}?",
  "p4.dok.hapusKet": "Its content and chunks leave the bot’s knowledge, and this cannot be undone. If a content reference advertises this document, it is removed from there too. To stop using it for now, just switch it off.",
  "p4.dok.hapusYa": "Delete permanently",
  "p4.dok.toastHapus": "{{nama}} deleted",
  "p4.dok.toastHapusRef": "{{nama}} deleted, and removed from reference {{daftar}}",
  "p4.dok.rincian": "{{n}} chunks · processed {{tanggal}}",
  "p4.dok.belumDiproses": "Not processed yet, so the bot cannot use it. Upload the file again.",
  "p4.dok.jenis": "Text, Markdown, CSV, or JSON up to 1 MB. The file name becomes the document title, and uploading the same name replaces its contents.",
  "p4.uji.contoh": "Type a question the way your customers would",
  "p4.uji.menguji": "Testing…",
  "p4.uji.gagal": "The test did not run",
  "p4.ambil.judul": "Answer test",
  "p4.ambil.ket": "Which chunks the bot finds, and why. Cheap, run it as often as you like.",
  "p4.ambil.label": "Question for the answer test",
  "p4.ambil.tombol": "Test",
  "p4.ambil.nolJudul": "0 chunks found",
  "p4.ambil.nolIsi": "“{{pertanyaan}}” found nothing in the documents that are on. Add a section covering it to one of them.",
  "p4.ambil.ketemu": "{{n}} chunks found · {{karakter}} characters",
  "p4.ambil.untuk": "For “{{pertanyaan}}”",
  "p4.ambil.cuplikan": "Excerpts of the chunks found",
  "p4.chat.judul": "Conversation test",
  "p4.chat.ket": "One answer from your documents, then checked for whether it uses the chunks found. It calls a real model, so every test is billed.",
  "p4.chat.label": "Lead message for the conversation test",
  "p4.chat.tombol": "Send to the bot",
  "p4.chat.prospek": "Lead",
  "p4.chat.bot": "Bot",
  "p4.chat.uji": "test",
  "p4.chat.pakai": "The answer uses the chunks found ({{n}} chunks).",
  "p4.chat.karang": "The answer does not use the chunks found ({{n}} chunks).",
  "p4.chat.karangIsi": "It was most likely made up. Check your documents.",
  "p4.chat.biaya": "This test cost {{biaya}}.",
  "p4.dok.aksi": "Actions for {{nama}}",
  "p4.dok.lihat": "See what the bot reads",
  "p4.dok.hapusMenu": "Delete document…",
  "p4.kelompok.produk": "Products · {{n}}",
  "p4.kelompok.peran": "Overview and company profile · {{n}}",
  "p4.kelompok.umum": "General · {{n}}",
  "p4.peran.produk": "Product",
  "p4.peran.ringkasan": "Overview",
  "p4.peran.profil": "Company profile",
  "p4.peran.umum": "General",
  "p4.tanda.kembar": "Duplicate alias",
  "p4.tanda.tanpaKepala": "No header",
  "p4.tanda.tipeAsing": "Unknown TYPE",
  "p4.cara.judul": "How the bot reads documents",
  "p4.cara.ket": "Write these three lines at the top of each document. The bot uses them to pick which document to read when a customer asks.",
  "p4.cara.contoh": "TYPE: product\nPRODUCT: Business Plan\nALIASES: business plan, office plan, team subscription",
  "p4.cara.type": "product, overview (summary of all products), or company profile. Anything else is read as a general document.",
  "p4.cara.product": "the product name; write all for a general document.",
  "p4.cara.aliases": "terms customers type, separated by commas. Each term in one document only: a duplicated term does not route questions.",
  "p4.baca.judul": "What the bot reads",
  "p4.baca.ditulis": "(written “{{teks}}”)",
  "p4.baca.dariNama": "(from the file name)",
  "p4.baca.arti.produk": "A single-product document. Questions that name the product or one of its aliases are routed here.",
  "p4.baca.arti.ringkasan": "Read in full for general product questions, such as “what products do you have?”.",
  "p4.baca.arti.profil": "Read in full for questions about the company, its founders, and contacts.",
  "p4.baca.arti.umum": "Read through its aliases and by similarity. Recognised TYPEs: product, overview, and company profile.",
  "p4.baca.mirip": "Did you mean “{{tipe}}”? Fix the TYPE line, then upload the file again under the same name.",
  "p4.baca.tidakDitulis": "Not written",
  "p4.baca.semua": "(general document, not one product)",
  "p4.baca.alias": "Aliases · {{n}}",
  "p4.baca.aliasKet": "Questions that mention any of these are routed to this document. Its file name (“{{nama}}”) is recognised too.",
  "p4.baca.aliasKosong": "No aliases yet. The bot only recognises its file name (“{{nama}}”).",
  "p4.baca.aliasDaftar": "Aliases of this document",
  "p4.baca.merek": "brand name, also in {{daftar}}: used when the question is only that name",
  "p4.baca.kembar": "also in {{daftar}}: does not route questions, unless the question is only this name",
  "p4.baca.dariProduk": "from PRODUCT",
  "p4.baca.mati": "This document is off, so the bot does not read it.",
  "p4.baca.tanpaKepala": "The bot only recognises this document by its file name. Write TYPE, PRODUCT, and ALIASES at the top, then upload the file again under the same name.",
  "p4.baca.kembarSaran": "Remove the duplicate alias from one of the documents, then upload that file again under the same name.",
  "p4.baca.tidakAda": "This document's header has not been read yet. Reload the page.",
  "p4.ambil.potongan": "Chunks found",
  "p4.ambil.lain": "… and {{n}} more chunks",
  "p4.kenapa.label": "Why:",
  "p4.kenapa.alias": "the question mentions {{alias}}, an alias of {{dokumen}}, so that is what was read.",
  "p4.kenapa.ikut": "The overview ({{dokumen}}) was checked too.",
  "p4.kenapa.merek": "the question is only the name {{alias}}, used by {{dokumen}}. All of them were read.",
  "p4.kenapa.perusahaan": "a question about the company, so the whole company profile ({{dokumen}}) was read.",
  "p4.kenapa.bidang": "no product is named, but it mentions “{{kata}}”, a word several products use. The overview ({{dokumen}}) was read in full.",
  "p4.kenapa.umum": "a general product question (“{{kata}}”), so the overview ({{dokumen}}) was read in full.",
  "p4.kenapa.mirip": "no product or alias is named, so it was searched by similarity.",
  "p4.kenapa.miripNol": "no product or alias is named, so it was searched by similarity, and no chunk was close enough.",
  "p4.saran.label": "What you can do:",
  "p4.saran.umum": "if this question belongs to one product, add its term to that product document's ALIASES.",
  "p4.saran.nol": "if a document covers this, add the term to that document's ALIASES. If not, the bot has no material to answer it yet.",
  "p5.ket": "The people on your team and their Telegram links",
  "p5.ringkas": "{{n}} people · {{belum}} have not linked Telegram",
  "p5.gagal": "The list of people did not load",
  "p5.kosong": "No people yet",
  "p5.kosongKet": "People are added by the Smova operator.",
  "p5.aksi": "Actions for {{nama}}",
  "p5.peserta": "Can be a meeting participant",
  "p5.pesertaNama": "Can be a meeting participant: {{nama}}",
  "p5.nama.belum": "No name yet",
  "p5.belumDanNama": "{{n}} people haven't linked Telegram, {{m}} have no name yet",
  "p5.kelompok.nonaktif": "Inactive · {{n}}",
  "p5.nama.isi": "Add name",
  "p5.nama.ubah": "Change name",
  "p5.nama.label": "Name",
  "p5.nama.ket": "Shown to others in the attendee picker and group messages. If left empty, they are shown by their Telegram name or {{akun}}.",
  "p5.nama.toast": "Name saved: {{nama}}",
  "p5.nama.toastKosong": "Name cleared. They are shown by their Telegram name or {{akun}}.",
  "p5.nama.belumJudul": "{{n}} people have no name yet",
  "p5.nama.belumIsi": "Those without a name are shown by their Telegram name or email in the attendee picker and group messages. Add the name from the ⋯ button on their row.",
  "p5.belumJudul": "{{n}} people have not linked Telegram",
  "p5.belumIsi": "They still read the group notifications, but buttons such as “Take & Handle” refuse them until they are linked. Their /join code is made from the ⋯ button on their row.",
  "p5.orang.judul": "People on the team",
  "p5.orang.ket": "Adding people and changing roles is done by the Smova operator. Each person sets their own leave in Meetings.",
  "p5.sebutan": "{{nama}}, meeting participant",
  "p5.nonaktif": "Inactive account, so cannot be a meeting participant.",
  "p5.tertaut": "Telegram linked",
  "p5.tertautNama": "Telegram linked · @{{nama}}",
  "p5.belumJoin": "Not joined yet",
  "p5.izin": "leave {{tanggal}}",
  "p5.izinLagi": "+{{n}} more dates",
  "p5.izinGagal": "The leave dates did not load.",
  "p5.kode.buat": "Create a /join code",
  "p5.kode.label": "/join code",
  "p5.kode.baru": "valid until {{sampai}}",
  "p5.kode.lama": "existing code, valid until {{sampai}}",
  "p5.kode.catatan": "The code belongs to one person and works once. Give it to that person, who then types /join CODE once in the team's Telegram group.",
  "p5.saring.label": "Filter people",
  "p5.saring.semua": "All",
  "p5.saring.belum": "Not linked",
  "p5.saring.sudah": "Linked",
  "p5.cari": "Search people",
  "p5.tidakCocok": "No one matches.",
  "p6.ket": "The accounts Smova uses on your team's behalf",
  "p6.gagal": "The connections did not load",
  "p6.operator.judul": "Managed by the Smova operator",
  "p6.operator.isi": "Need to change an account or a token? Contact the Smova operator.",
  "p6.akun.terakhir": "Last received a message {{kapan}}",
  "p6.akun.belumPernah": "Has never received a message",
  "p6.keadaan.tersambung": "Connected",
  "p6.keadaan.nonaktif": "Inactive",
  "p6.keadaan.belum": "Not connected",
  "p6.kap.dm": "Reply to DMs",
  "p6.kap.komentar": "Reply to comments",
  "p6.kap.terbit": "Publish content",
  "p6.bisa.bisa": "Available",
  "p6.bisa.tidak_bisa": "Not offered by the platform",
  "p6.bisa.belum_dibangun": "Not built yet",
  "p6.bedaKap": "“Not offered by the platform” means the platform does not open it up. “Not built yet” means the platform can and Smova has not built it.",
  "p6.grup.judul": "Telegram groups",
  "p6.grup.ket": "Where team notifications go: DMs, leads, meetings, and content.",
  "p6.grup.kosong": "No group is registered yet",
  "p6.grup.kosongKet": "Without a group, your team receives no notifications. Ask the Smova operator to register your group.",
  "p6.grup.tanpaNama": "Unnamed group",
  "p6.grup.aktif": "Active",
  "p6.grup.nonaktif": "Inactive",
  "p6.grup.catatan": "Everyone in the group can read the notifications. The buttons work only for people who have joined; Team shows who has not.",
  "p7.ket": "This month's AI spend and the features in your plan",
  "p7.ringkas": "{{bulan}} · {{n}} days left this month",
  "p7.berhenti.judul": "This month's budget has been reached",
  "p7.berhenti.isi": "Stopped right now: {{daftar}}. Contact the Smova operator if you need a higher budget.",
  "p7.berhenti.image": "image creation",
  "p7.berhenti.video": "video creation",
  "p7.berhenti.drafting": "content drafting",
  "p7.berhenti.chatbot": "chat replies",
  "p7.belanja.judul": "AI spend this month",
  "p7.belanja.ket": "Against the budget set by the Smova operator.",
  "p7.belanja.kunci": "Budget set by Smova",
  "p7.belanja.gagal": "This month's spend did not load",
  "p7.belanja.dari": "of {{pagu}}",
  "p7.belanja.tanpaPagu": "no budget",
  "p7.belanja.tanpaPaguKet": "This team has no budget yet, so nothing stops its usage. Contact the Smova operator to have a limit set.",
  "p7.belanja.batang": "Budget used",
  "p7.belanja.persen": "{{n}}% used · warning at {{ambang}}%",
  "p7.belanja.sisa": "{{sisa}} left",
  "p7.tanpaTarif.judul": "{{n}} calls have no rate yet",
  "p7.tanpaTarif.isi": "The spend figure is a lower bound, not the total.",
  "p7.urutan.judul": "When the budget is reached",
  "p7.urutan.ket": "What stops, in order.",
  "p7.urutan.aset": "Images and videos stop being created",
  "p7.urutan.konten": "Content drafting stops",
  "p7.urutan.chatbot": "Chat replies to customers, last of all",
  "p7.urutan.sudah": "already stopped",
  "p7.urutan.sebab": "Chat replies go last because they face your customers.",
  "p7.hari.judul": "Per day",
  "p7.hari.ket": "Spend for each day.",
  "p7.hari.puncak": "Highest {{biaya}} on {{tanggal}}.",
  "p7.hari.rentang": "Range of days",
  "p7.hari.nHari": "{{n}} days",
  "p7.hari.gagal": "The usage did not load",
  "p7.hari.kosong": "No usage recorded in the last {{n}} days.",
  "p7.hari.baris": "{{tanggal}}: {{biaya}}",
  "p7.rinci.judul": "Where it went",
  "p7.rinci.ket": "By activity, last {{n}} days.",
  "p7.rinci.panggilan": "Model calls",
  "p7.rinci.token": "Tokens",
  "p7.rinci.biaya": "Cost",
  "p7.rinci.kegiatan": "Activity",
  "p7.rinci.jumlah": "Count",
  "p7.rinci.tanpaTarif": "{{n}} calls with no known rate",
  "p7.rinci.model": "Models that replied to chats",
  "p7.rinci.modelTakTercatat": "not recorded",
  "p7.rinci.balasan": "{{n}} replies",
  "p7.fitur.judul": "Features in your plan",
  "p7.fitur.ket": "Ask the Smova operator for anything not in your plan.",
  "p7.fitur.kunci": "Managed by Smova",
  "p7.fitur.gagal": "The feature list did not load",
  "p7.fitur.tidakAda": "not in your plan",
  "op.kanal.instagram": "Instagram",
  "op.kanal.facebook": "Facebook",
  "op.kanal.telegram": "Telegram",
  "op.kanalKeadaan.ok": "connected",
  "op.kanalKeadaan.perhatian": "token not valid",
  "op.kanalKeadaan.tanpa": "not connected",
  "op.pagu.dari": "{{pakai}} / {{pagu}}",
  "op.pagu.tanpa": "{{pakai}} · no budget",
  "op.pagu.persen": "{{n}}% used, warning at {{ambang}}%",
  "op.onboarding": "{{n}}/{{dari}}",
  "s1.ket": "All tenants · {{hari}}",
  "s1.gagal": "The tenant list did not load",
  "s1.angka.tenant": "Tenants",
  "s1.angka.tenantKet": "{{live}} live · {{test}} test · {{draft}} draft",
  "s1.angka.tenantBuka": "Open the list",
  "s1.angka.perhatian": "Need attention",
  "s1.angka.perhatianKet": "What hurts customers comes first",
  "s1.angka.gagal": "Inbound messages failed, 24 hours",
  "s1.angka.gagalKet": "Webhooks that did not finish processing",
  "s1.angka.gagalBuka": "See inbound events",
  "s1.angka.biaya": "AI cost in {{bulan}}",
  "s1.angka.biayaKet": "of a total budget of {{pagu}}",
  "s1.angka.biayaTanpa": "no tenant has a budget yet",
  "s1.angka.biayaBuka": "Open usage",
  "s1.perhatian.judul": "Need attention",
  "s1.perhatian.ket": "What hurts customers comes first.",
  "s1.perhatian.kosong": "Nothing needs attention",
  "s1.perhatian.kosongKet": "Every token is valid, no message failed, and no budget has been reached.",
  "s1.perhatian.tokenMati": "The Meta token for {{tenant}} is not valid",
  "s1.perhatian.tokenMatiKet": "The bot cannot reply and content cannot publish until the token is replaced.",
  "s1.perhatian.tokenMatiBuka": "Open connections",
  "s1.perhatian.tokenSegera": "The Meta token for {{tenant}} expires {{tanggal}}",
  "s1.perhatian.tokenSegeraKet": "Instagram and Facebook stop if it is not replaced.",
  "s1.perhatian.tokenSegeraBuka": "Open connections",
  "s1.perhatian.gagal": "{{n}} inbound messages for {{tenant}} failed to process",
  "s1.perhatian.gagalKet": "In the last 24 hours. Those customers got no reply.",
  "s1.perhatian.gagalBuka": "See inbound events",
  "s1.perhatian.alurGagal": "{{n}} flows of {{tenant}} stopped with a failure",
  "s1.perhatian.alurGagalKet": "In the last 24 hours: a timer, a bot reply, or something that was not delivered.",
  "s1.perhatian.alurGagalBuka": "Open flow trace",
  "s1.perhatian.timerTerlambat": "{{nama}} is late: last ran {{kapan}}",
  "s1.perhatian.timerTerlambatKet": "Its scheduled work is not running: content is not published, reminders are not sent, or the cleanup does not run until the timer is back.",
  "s1.perhatian.timerTerlambatBuka": "Open System",
  "s1.perhatian.timerGagal": "{{nama}} failed on its last run",
  "s1.perhatian.timerGagalKet": "The reason is on the System screen.",
  "s1.perhatian.timerGagalBuka": "Open System",
  "s1.perhatian.paguLewat": "{{tenant}} is over budget: {{n}}%",
  "s1.perhatian.paguLewatKet": "Images and videos have stopped; content and chat replies follow.",
  "s1.perhatian.paguLewatBuka": "Open budget",
  "s1.perhatian.paguDekat": "{{tenant}} has used {{n}}% of its budget",
  "s1.perhatian.paguDekatKet": "It has passed its warning threshold.",
  "s1.perhatian.paguDekatBuka": "Open budget",
  "s1.perhatian.onboarding": "{{tenant}} stopped at step {{n}} of 7",
  "s1.perhatian.onboardingKet": "Its onboarding is not finished.",
  "s1.perhatian.onboardingBuka": "Continue",
  "s1.tenant.judul": "Tenants",
  "s1.kartu.pemakaian": "Usage",
  "s1.kartu.onboarding": "Onboarding",
  "s1.kartu.batang": "Budget used by {{nama}}",
  "s2.ket": "All tenants",
  "s2.ringkas": "{{n}} tenants",
  "s2.gagal": "The tenant list did not load",
  "s2.saring": "Filter by mode",
  "s2.semua": "All",
  "s2.baru": "New tenant",
  "s2.daftar": "Tenant list",
  "s2.kosong": "No tenants yet",
  "s2.kosongKet": "Create the first tenant, then follow its onboarding steps.",
  "s2.tidakAda": "No tenant is in this mode",
  "s2.tidakAdaKet": "Choose another filter.",
  "s2.belumAktif": "never",
  "s2.kolom.tenant": "Tenant",
  "s2.kolom.mode": "Mode",
  "s2.kolom.sambungan": "Connections",
  "s2.kolom.onboarding": "Onboarding",
  "s2.kolom.pemakaian": "Usage",
  "s2.kolom.aktif": "Last active",
  "s3.ket": "A new tenant starts in Draft mode: the bot stays silent until you move it.",
  "s3.remah": "Breadcrumb",
  "s3.data.judul": "Tenant details",
  "s3.data.ket": "The rest is filled in through the onboarding steps after the tenant is created.",
  "s3.nama": "Tenant name",
  "s3.namaContoh": "Example: Smile Dental Clinic",
  "s3.zona": "Time zone",
  "s3.mode": "Starting mode",
  "s3.buat": "Create tenant",
  "s3.toast": "{{nama}} created, in Draft mode",
  "s4.ket": "{{zona}} · id {{id}}…",
  "s4.gagal": "The tenant did not load",
  "s4.tidakAda": "Tenant not found",
  "s4.tidakAdaKet": "The address may be wrong, or this tenant is not in this system.",
  "s4.tab.label": "Tenant detail sections",
  "s4.tab.ikhtisar": "Overview",
  "s4.tab.sambungan": "Connections",
  "s4.tab.orang": "People",
  "s4.tab.paket": "Plan & budget",
  "s4.tab.aktivitas": "Activity",
  "s4.mode.ubah": "Change mode",
  "s4.mode.judul": "Change the mode of {{nama}}",
  "s4.mode.ket": "The mode decides who receives the bot's replies.",
  "s4.mode.legenda": "Tenant mode",
  "s4.mode.sekarang": "current",
  "s4.mode.arti.draft": "The bot is silent for everyone.",
  "s4.mode.arti.test": "The bot answers test accounts only.",
  "s4.mode.arti.live": "The bot answers every message.",
  "s4.mode.pilihLain": "Choose another mode",
  "s4.mode.pindah": "Move to {{mode}}",
  "s4.mode.akibat.draft": "Every reply from {{nama}} stops, including to leads in mid-conversation.",
  "s4.mode.akibat.test": "Real leads are no longer answered. Only test accounts receive replies.",
  "s4.mode.akibat.live": "The bot starts replying to every Instagram and Facebook account that contacts {{nama}}.",
  "s4.mode.toast": "{{nama}} moved to {{mode}} mode",
  "s4.angka.pakai": "Usage this month",
  "s4.angka.onboarding": "Onboarding",
  "s4.angka.berikutnya": "Next: {{langkah}}",
  "s4.angka.selesai": "Handed over to the client",
  "s4.angka.terkunci": "The next step is still locked",
  "s4.angka.mode": "Mode",
  "s4.kurang.judul": "What is still missing for the bot to run",
  "s4.ob.judul": "Onboarding",
  "s4.ob.ket": "{{n}} of {{dari}} steps done.",
  "s4.ob.berikutnya": "Next",
  "s4.ob.buka": "Open",
  "s4.ob.langkah.tenant": "Tenant created",
  "s4.ob.langkah.tim": "Telegram group and team linked",
  "s4.ob.langkah.pengetahuan": "Knowledge uploaded by the Tenant Admin",
  "s4.ob.langkah.paket": "Features and models chosen",
  "s4.ob.langkah.sambungan": "Instagram connected with a valid token",
  "s4.ob.langkah.pesan_masuk": "First message received",
  "s4.ob.langkah.serah_terima": "The Tenant Admin has signed in",
  "s4.ob.keadaan.selesai": "done",
  "s4.ob.keadaan.sekarang": "next",
  "s4.ob.keadaan.menunggu": "not yet",
  "s4.ob.keadaan.terkunci": "locked until the earlier steps are done",
  "s4.konfig.judul": "Client configuration",
  "s4.konfig.ket": "Set by the Tenant Admin. Read-only here.",
  "s4.konfig.bacaSaja": "Read-only",
  "s4.konfig.belum": "not set",
  "s4.konfig.bot": "Bot",
  "s4.konfig.botIsi": "{{nama}} · {{gaya}}",
  "s4.konfig.melayani": "Serves",
  "s4.konfig.jadwal": "Reply schedule",
  "s4.konfig.jadwal24": "Around the clock",
  "s4.konfig.jadwalIsi": "{{n}} days · {{mulai}}–{{selesai}}",
  "s4.konfig.pengetahuan": "Knowledge",
  "s4.konfig.pengetahuanIsi": "{{n}} of {{dari}} documents in use",
  "s4.konfig.model": "Chat model",
  "s4.konfig.modelBawaan": "Smova default",
  "s4.konfig.slot": "Publishing slots",
  "s4.konfig.dokumen": "Knowledge documents",
  "s4.mati.judul": "Features that are off",
  "s4.mati.ket": "What is off explains how this tenant behaves.",
  "s4.jejak.judul": "Change log",
  "s4.jejak.ket": "Who changed what, newest first.",
  "s4.jejak.gagal": "The change log did not load",
  "s4.jejak.kosong": "No changes recorded yet",
  "s4.jejak.oleh": "by {{siapa}}",
  "s4.jejak.sistem": "the system",
  "s4.jejak.apa.settings": "Settings",
  "s4.jejak.apa.persona": "Persona",
  "s4.jejak.apa.jadwal": "Schedule",
  "s4.jejak.apa.libur": "Holiday",
  "s4.jejak.apa.template": "Message template",
  "s4.jejak.apa.meeting_setelan": "Meeting rules",
  "s4.jejak.apa.model": "Model",
  "s4.jejak.apa.field_profil": "Lead data",
  "s4.jejak.apa.pengetahuan": "Knowledge document",
  "s4.jejak.apa.web_user": "User account",
  "s4.jejak.apa.tenant": "Tenant",
  "s4.jejak.apa.pagu": "Budget",
  "s4.jejak.apa.fitur": "Feature",
  "s4.jejak.apa.orang": "Person (prospect and conversation)",
  "s4.jejak.aksi.dihapus": "permanently deleted",
  "s4.jejak.aksi.created": "created",
  "s4.jejak.aksi.updated": "changed",
  "s4.jejak.aksi.deleted": "deleted",
  "s4.jejak.aksi.activated": "activated",
  "s4.jejak.aksi.deactivated": "deactivated",
  "s4.masuk.judul": "Latest inbound messages",
  "s4.masuk.ket": "Webhooks from this tenant's platforms.",
  "s4.masuk.semua": "This tenant's event trail",
  "s4.masuk.gagal": "The inbound messages did not load",
  "s4.masuk.kosong": "No inbound messages yet",
  "s4.masuk.kosongKet": "No webhook has arrived for this tenant yet.",
  "s4.orang.judul": "People at {{nama}}",
  "s4.orang.ket": "The Active switch saves right away. Changing a role asks first.",
  "s4.orang.kosong": "No people yet",
  "s4.orang.kosongKet": "Add the first Tenant Admin for this tenant.",
  "s4.orang.tambah": "Add person",
  "s4.orang.nama": "Name",
  "s4.orang.email": "Email",
  "s4.orang.emailKet": "Used to sign in. One email, one account across Smova.",
  "s4.orang.namaKet": "What the team reads in the attendee picker, group messages, and notes.",
  "s4.orang.peran": "Role",
  "s4.orang.sandi": "Initial password",
  "s4.orang.formKet": "They sign in with this email and initial password; give the password to them. Telegram is linked with a /join code from the Tenant Admin.",
  "s4.orang.toastTambah": "{{nama}} added",
  "s4.orang.sebutan": "{{nama}}, account active",
  "s4.orang.aktif": "account active",
  "s4.orang.nonaktif": "account inactive, cannot sign in",
  "s4.orang.ubahPeran": "Change role",
  "s4.orang.peranTanya": "Make {{nama}} a {{peran}}?",
  "s4.orang.peranAkibat.tenant_admin": "The role decides which menus are visible. A Tenant Admin can open Settings.",
  "s4.orang.peranAkibat.tenant_marketing": "The role decides which menus are visible. A Tenant Marketing user can no longer open Settings.",
  "s4.orang.peranYa": "Make {{peran}}",
  "s4.orang.toastPeran": "{{nama}} is now {{peran}}",
  "s4.orang.taut": "Link Telegram",
  "s4.orang.tgId": "Telegram ID",
  "s4.orang.tgIdKet": "A number, not the username. Leave empty to unlink.",
  "s4.orang.tgNama": "Telegram username",
  "s4.orang.toastTaut": "Telegram link saved",
  "s4.fitur.judul": "Available features",
  "s4.fitur.ket": "Dependencies are enforced on each row. The Tenant Admin chooses whether the automatic ones run.",
  "s4.fitur.butuh": "needs {{daftar}}",
  "s4.fitur.dibutuhkan": "used by {{daftar}}",
  "s4.pagu.judul": "AI budget",
  "s4.pagu.ket": "The monthly limit on AI spend.",
  "s4.pagu.pagu": "Monthly budget (USD)",
  "s4.pagu.paguKet": "Leave empty for no budget.",
  "s4.pagu.paguSalah": "Enter a number from 0 to {{n}}, or leave it empty.",
  "s4.pagu.ambang": "Warn at (%)",
  "s4.pagu.ambangKet": "The team is told when usage reaches this figure.",
  "s4.pagu.ambangSalah": "Enter a whole number from 10 to 100.",
  "s4.model.judul": "Models",
  "s4.model.ket": "Chosen by the Tenant Admin. Read-only here.",
  "s4.model.chat": "Chat",
  "s4.model.text": "Content text",
  "s4.model.image": "Images",
  "s4.model.video": "Video",
  "s4.tutup": "Close",
  "s4.akun.tanpaAdapter": "This platform cannot be connected from Smova yet.",
  "s4.akun.tokenAda": "token stored",
  "s4.akun.tokenTiada": "no token loaded",
  "s4.akun.aktif": "{{platform}} account active",
  "s4.akun.aktifKet": "An inactive account receives no messages and publishes no content.",
  "s4.akun.sambung": "Connect account",
  "s4.akun.ganti": "Replace account or token",
  "s4.akun.uji": "Test connection",
  "s4.akun.ujiLulus": "The connection works",
  "s4.akun.ujiGagal": "The connection failed",
  "s4.akun.id": "Account or Page ID",
  "s4.akun.idKet": "This ID decides which tenant Meta messages go to. Check it twice.",
  "s4.akun.token": "New token",
  "s4.akun.tokenKet": "Leave empty to change only the account. Stored encrypted and never shown again.",
  "s4.akun.berakhir": "Token expires on",
  "s4.akun.simpan": "Save account",
  "s4.akun.sambungTanya": "Connect this {{platform}} account?",
  "s4.akun.sambungAkibat": "Messages from this account start arriving at this tenant.",
  "s4.akun.gantiTanya": "Replace this tenant's {{platform}} account?",
  "s4.akun.gantiAkibat": "The old account is turned off. If a token is entered, the old token is replaced and cannot be restored from here.",
  "s4.akun.toast": "{{platform}} account saved",
  "s4.akun.toastToken": "{{platform}} account saved, token replaced",
  "s4.akun.peringatan": "Saved, with a note",
  "s4.tukar.judul": "Exchange a Meta token",
  "s4.tukar.ket": "A short-lived user token is exchanged for a long-lived Page token, then stored.",
  "s4.tukar.token": "User token",
  "s4.tukar.halaman": "Page ID",
  "s4.tukar.halamanKet": "Leave empty if the token has only one Page.",
  "s4.tukar.tombol": "Exchange and store",
  "s4.tukar.toast": "Page token stored",
  "s4.tukar.hasil": "Token for {{nama}} stored",
  "s4.tukar.berakhir": "Expires {{tanggal}}.",
  "s4.tukar.tanpaAkhir": "No expiry date.",
  "s4.grup.ket": "Where team notifications are sent.",
  "s4.grup.gagal": "The groups did not load",
  "s4.grup.kosong": "No group yet. Without one, the team gets no notifications.",
  "s4.grup.sebutan": "Group {{nama}}",
  "s4.grup.chat": "Group chat_id",
  "s4.grup.chatKet": "A number, usually starting with -100.",
  "s4.grup.label": "Group name",
  "s4.grup.tambah": "Add group",
  "s4.grup.toast": "Group added",
  "s4.kred.judul": "Credentials",
  "s4.kred.ket": "Stored encrypted. The contents are never shown again.",
  "s4.kred.gagal": "The credentials did not load",
  "s4.kred.kosong": "No credential has been loaded yet.",
  "s4.kred.muat": "Load a key",
  "s4.kred.diisi": "loaded {{tanggal}}",
  "s4.kred.berakhir": "expires {{tanggal}}",
  "s4.kred.tanpaAkhir": "no expiry date",
  "s4.kred.berlaku": "Valid",
  "s4.kred.kedaluwarsa": "Expired",
  "s4.kred.lama": "Replaced",
  "s4.kred.penyedia": "Provider",
  "s4.kred.berakhirPada": "Expires on",
  "s4.kred.nilai": "Key or token",
  "s4.kred.simpan": "Save key",
  "s4.kred.tanya": "Replace this tenant's {{penyedia}} key?",
  "s4.kred.akibat": "The old key stops being used and cannot be restored from here.",
  "s4.kred.toast": "{{penyedia}} key saved",
  "s4.uji.judul": "Test accounts",
  "s4.uji.ket": "Only these accounts get bot replies while the tenant is in Test mode.",
  "s4.uji.gagal": "The test accounts did not load",
  "s4.uji.kosong": "No test accounts yet. In Test mode, the bot is silent for everyone.",
  "s4.uji.baru": "New test account",
  "s4.uji.tambah": "Add test account",
  "s4.uji.hapus": "Remove test account {{akun}}",
  "s4.uji.toastTambah": "{{akun}} is now a test account",
  "s4.uji.toastHapus": "{{akun}} is no longer a test account",
  "s6.ket": "AI spend across all tenants, {{bulan}}",
  "s6.angka.total": "Spend this month",
  "s6.angka.lewat": "Tenants past their threshold",
  "s6.angka.lewatKet": "At the warning threshold or over budget.",
  "s6.tenant.judul": "By tenant",
  "s6.tenant.ket": "This month, against each budget. Budgets are changed in the tenant detail.",
  "s6.rinci.judul": "One tenant in detail",
  "s6.rinci.tenant": "Tenant",
  "s7.ket": "Features and AI models tenants can use",
  "s7.tab.label": "Catalog sections",
  "s7.tab.fitur": "Features",
  "s7.tab.model": "AI models",
  "s7.dipakai": "used by {{n}} tenants",
  "s7.fitur.judul": "Features",
  "s7.fitur.ket": "This list changes with Smova releases, not from this screen. Turning a feature on for one tenant is in the tenant detail, Plan & budget tab.",
  "s7.fitur.gagal": "The feature catalog did not load",
  "s7.fitur.kosong": "The feature catalog is empty",
  "s7.fitur.butuh": "needs",
  "s7.fitur.ditawarkan": "Offered",
  "s7.fitur.ditarik": "Withdrawn",
  "s7.model.judul": "AI models",
  "s7.model.ket": "Active models can be picked by a Tenant Admin for their purpose.",
  "s7.model.gagal": "The model catalog did not load",
  "s7.model.kosong": "No models in the catalog yet",
  "s7.model.tambah": "Add model",
  "s7.model.id": "Model ID at the provider",
  "s7.model.nama": "Display name",
  "s7.model.penyedia": "Provider",
  "s7.model.peran": "Appears under",
  "s7.model.tingkat": "Tier",
  "s7.model.tanpaTingkat": "No tier",
  "s7.tingkat.hemat": "Economy",
  "s7.tingkat.seimbang": "Balanced",
  "s7.tingkat.terbaik": "Best",
  "s7.model.formKet": "The model ID and where it appears cannot be changed after saving: a wrong model is deactivated and registered again. Rates can follow later.",
  "s7.model.toastTambah": "{{nama}} added to the catalog",
  "s7.model.rasio": "Default ratio",
  "s7.model.rasioPenyedia": "Provider default",
  "s7.model.simpanRasio": "Save ratio",
  "s7.model.toastRasio": "Default ratio for {{nama}} saved",
  "s7.model.nonaktifkan": "Deactivate",
  "s7.model.aktifkan": "Activate",
  "s7.model.nonaktifTanya": "Deactivate {{nama}}?",
  "s7.model.nonaktifDipakai": "{{n}} tenants are using it. It will be skipped: they move to their next fallback, or to the Smova default if they have none.",
  "s7.model.nonaktifBebas": "No tenant is using it. It disappears from the Tenant Admin choices.",
  "s7.model.toastNonaktif": "{{nama}} deactivated",
  "s7.model.toastAktif": "{{nama}} activated",
  "s7.tarif.kosong": "Rate not set",
  "s7.tarif.input_per_juta": "Input rate per 1 million tokens (US$)",
  "s7.tarif.output_per_juta": "Output rate per 1 million tokens (US$)",
  "s7.tarif.per_gambar": "Rate per image (US$)",
  "s7.tarif.per_detik": "Rate per second of video (US$)",
  "s7.harga.input_per_juta": "{{harga}} in per 1 million tokens",
  "s7.harga.output_per_juta": "{{harga}} out per 1 million tokens",
  "s7.harga.per_gambar": "{{harga}} per image",
  "s7.harga.per_detik": "{{harga}} per second of video",
  "s7.kem.referensi": "accepts reference images",
  "s7.kem.rasioDiabaikan": "ratio ignored when a reference is used",
  "s7.kem.detik": "{{nilai}} seconds",
  "s7.kem.belumSinkron": "capabilities not synced yet",
  "s8.ket": "Service health and operator accounts",
  "s8.ketLingkungan": "Service health and operator accounts · {{lingkungan}} environment",
  "s8.gagal": "System health did not load",
  "s8.periksa.judul": "Checks",
  "s8.periksa.ket": "Read from data already recorded. Opening this screen calls no provider.",
  "s8.nada.ok": "Fine",
  "s8.nada.warn": "Needs a look",
  "s8.nada.bad": "Problem",
  "s8.cek.migrasi.nama": "Database migration",
  "s8.cek.migrasi.ket": "The schema revision in effect on this database.",
  "s8.cek.tenant.nama": "Tenants by mode",
  "s8.cek.tenant.ket": "Only live tenants send anything out.",
  "s8.cek.webhook.nama": "Inbound webhooks, 24 hours",
  "s8.cek.webhook.ket": "Those without a tenant arrived at an unregistered account and always need follow-up.",
  "s8.cek.biaya.nama": "Calls without a rate, 30 days",
  "s8.cek.biaya.ket": "While above zero, every cost figure is a lower bound, not a total.",
  "s8.cek.model.nama": "Active models without a rate",
  "s8.cek.model.ket": "Rates are filled from the provider's price list, with the rate script on the server.",
  "s8.cek.timer_terbit.nama": "Publishing timer",
  "s8.cek.timer_terbit.ket": "Every 10 minutes. Reported late after 30 minutes without a tick.",
  "s8.cek.timer_scraping.nama": "Source-scan timer",
  "s8.cek.timer_scraping.ket": "Every hour; each tenant's schedule decides whether it does anything. Late after 3 hours.",
  "s8.cek.timer_pengingat.nama": "Day-before reminder",
  "s8.cek.timer_pengingat.ket": "Every day at 08:00. Late after 26 hours.",
  "s8.cek.timer_sapu.nama": "Media and draft cleanup",
  "s8.cek.timer_sapu.ket": "Every day at 03:00: orphaned media, stale drafts, and run records older than 90 days. Late after 26 hours.",
  "s8.timer.berhasil": "Last ran {{kapan}}",
  "s8.timer.gagal": "Last ran {{kapan}}, and failed",
  "s8.timer.terlambat": "Late: last ran {{kapan}}",
  "s8.timer.belum": "No run recorded yet",
  "s8.webhook": "The last webhook was received {{kapan}}.",
  "s8.webhookBelum": "No webhook has ever been received.",
  "s8.operator.judul": "Smova operators",
  "s8.operator.ket": "Accounts that can open every tenant.",
  "s8.operator.kosong": "No operator accounts",
  "s8.operator.masuk": "last signed in {{kapan}}",
  "s8.operator.belumMasuk": "never signed in",
  "s5.ket": "Every flow leaves a run record, from its trigger to what it sent out",
  "s5.tab.label": "Flow trace sections",
  "s5.tab.jalan": "Run records",
  "s5.tab.masuk": "Inbound messages",
  "s5.tenant": "Tenant",
  "s5.semuaTenant": "All tenants",
  "s5.saring.label": "Filter by state",
  "s5.saring.semua": "All",
  "s5.saring.dengan": "{{nama}} · {{n}}",
  "s5.jalan.judul": "Run records",
  "s5.langkah": "Steps of {{nama}}",
  "s5.gagal": "Run records could not be loaded",
  "s5.kosong": "No run records yet",
  "s5.kosongKet": "A row appears once a DM arrives, a timer does some work, or a screen sends something out.",
  "s5.kosongSaring": "No flows match this filter",
  "s5.kosongSaringKet": "Pick another filter.",
  "s5.sebagian": "Showing {{n}} of {{total}} runs.",
  "s5.lagi": "Show more",
  "s5.status.berhasil": "Succeeded",
  "s5.status.gagal": "Failed",
  "s5.status.ditahan": "Held",
  "s5.status.berjalan": "Running",
  "s5.keadaan.ok": "done",
  "s5.keadaan.warn": "needs a look",
  "s5.keadaan.bad": "failed",
  "s5.keadaan.idle": "not carried out",
  "s5.alur.dm": "Inbound DM",
  "s5.alur.komentar": "Inbound comment",
  "s5.alur.telegram": "Telegram",
  "s5.alur.tombol": "Telegram button",
  "s5.alur.rekaman": "Meeting recording",
  "s5.alur.terbit": "Scheduled publishing",
  "s5.alur.pengingat": "Day-before reminder",
  "s5.alur.scraping": "Source scan",
  "s5.alur.sapu_konsep": "Draft cleanup",
  "s5.alur.kabar_meeting": "Meeting notice to the group",
  "s5.alur.kabar_jadwal_prospek": "Schedule DM to prospect",
  "s5.alur.tawaran_meeting": "Meeting offer",
  "s5.masuk.tenant": "Tenant",
  "s5.masuk.semuaTenant": "All tenants",
  "s5.masuk.tanpaTenant": "No tenant",
  "s5.masuk.saring": "Filter by status",
  "s5.masuk.hitungGagal": "The event counts did not load",
  "s5.masuk.kejadian.judul": "Events",
  "s5.masuk.kejadian.ket": "Newest first, without message content. Opening an event's content is recorded in the audit trail: who, when, and which event.",
  "s5.masuk.gagal": "The event list did not load",
  "s5.masuk.kosong": "No matching events",
  "s5.masuk.kosongKet": "Loosen the filters, or wait for the next webhook.",
  "s5.masuk.buka": "Open content",
  "s5.masuk.tutup": "Close content",
  "s5.masuk.isi": "Raw event content",
  "s5.masuk.isiGagal": "The event content did not load",
  "s5.masuk.sebagian": "Showing {{n}} of {{total}} events.",
  "s5.masuk.lagi": "Show more",
  "k6.tolakTanya": "Reject this content?",
  "k6.tolakKet": "It leaves the list and is not published on any platform. You can still undo it from the notification afterwards.",
  "k7.gambar.perbesar": "View the full-size image",
  "k7.gambar.tabBaru": "Open in a new tab",
  "umum.ubah": "Edit",
  "k4.catatanSebut": "note for {{meeting}}",
  "k4.catatanAjak": "No note yet. Write down what was discussed and agreed.",
  "k4.catatanMeetingContoh": "What was discussed and agreed?",
  "k4.catatanMeetingKet": "For the team only. Not sent to anyone.",
  "k4.toast.catatanMeetingHapus": "Note for {{meeting}} deleted",
  "k4.rekamanNanti": "Recordings can be added from the day of the meeting.",
  "k4.tanpaRekaman": "No recordings",
  "k4.aksiLain": "More actions for {{meeting}}",
  "k4.kelompok.perlu": "Needs action",
  "k4.kelompok.datang": "Upcoming",
  "k4.kelompok.riwayat": "History",
  "k4.keadaan.terjadwal": "Scheduled",
  "k4.keadaan.perluDitutup": "Not closed yet",
  "k4.keadaan.tanpaTanggal": "No date yet",
  "k4.pesertaBelum": "No attendees yet",
  "k4.salahCatat": "Outcome recorded wrongly?",
  "k4.saring.label": "Filter notes",
  "k4.saring.semua": "All {{n}}",
  "k4.saring.jenis": "{{jenis}} {{n}}",
  "k4.saringKosong": "No notes of this kind yet.",
  "k4.jenis.tim": "Team note",
  "k4.jenis.meeting": "Meeting note",
  "k4.jenis.bot": "From the bot",
  "k4.catatanRincian": "Note details",
  "k4.toast.catatanUbah": "Note updated",
  "k4.catatanHapus": "Delete note",
  "k4.catatanHapusTanya": "Delete the note \"{{judul}}\"?",
  "k4.catatanHapusKet": "The note disappears from this page and cannot be restored.",
  "k4.toast.catatanHapus": "Note deleted",
  "k4.lihatMeeting": "View the meeting",
  "k4.kamus.judul": "Three kinds of notes",
  "k4.kamus.ket": "All of them are for the team only. Nothing is sent to the prospect.",
  "k4.kamus.tim": "What happened outside chat and meetings: calls, proposals, visits. Written by the team on this tab.",
  "k4.kamus.meeting": "What was discussed and agreed in one meeting. Written on its meeting card, and shown here too.",
  "k4.kamus.bot": "Written by the bot when it hands something to the team, for example when a prospect asks for a time outside the offered options.",
  "k9.terima.ketKirim": "This message is sent to them right away, as long as it is within 24 hours of their last message:",
  "k9.terima.ketPindah": "This lead moves to Prospects. If the message cannot be sent, the bot offers it as soon as they reply again.",
  "k9.terima.kirim": "Accept and send the offer",
  "k9.toast.terimaHasil": "{{nama}} accepted. {{hasil}}",
  "k1.grup.judul": "You're not in the team's Telegram group yet",
  "k1.grup.masuk": "Join the team group with this link:",
  "k1.grup.masukNama": "Join the {{grup}} group with this link:",
  "k1.grup.tanpaTautan": "The Smova operator hasn't added the group link yet. Ask your Tenant Admin for it.",
  "k1.grup.join": "Type /join CODE once in the group. Your Tenant Admin gives you the code.",
  "k1.grup.joinAdmin": "Type /join CODE once in the group. Make the code in Team, the ⋯ button on your row, Create /join code.",
  "p5.grupTautan": "Link to join the group:",
  "p6.grup.tanpaTautan": "No invite link yet. The Smova operator adds it.",
  "s4.grup.tautan": "Invite link for {{nama}}",
  "s4.grup.tautanKet": "From Telegram: group info › Invite via link. Shown to people who haven't /joined, in Connections, Team, and Today.",
  "s4.grup.tautanSimpan": "Save link",
  "s4.grup.tautanToast": "Invite link saved",
  "s4.grup.tautanCabut": "Invite link removed",
  "hapusOrang.menu": "Delete this person…",
  "hapusOrang.menuLabel": "More actions for {{nama}}",
  "hapusOrang.tanya": "Permanently delete {{nama}}?",
  "hapusOrang.menghitung": "Counting what will be deleted…",
  "hapusOrang.gagalHitung": "Couldn't count what will be deleted",
  "hapusOrang.ditahan": "{{nama}} can't be deleted yet",
  "hapusOrang.ikut": "Also deleted: {{rincian}}.",
  "hapusOrang.jumlah": "{{apa}}: {{n}}",
  "hapusOrang.apa.pesan": "Incoming messages",
  "hapusOrang.apa.balasan_tim": "Team replies",
  "hapusOrang.apa.prospek": "Prospects",
  "hapusOrang.apa.meeting": "Meetings",
  "hapusOrang.apa.catatan_proses": "Notes",
  "hapusOrang.apa.jejak": "Logs",
  "hapusOrang.ket": "All of their DMs and comments in Smova, their prospect data, meetings with recordings, and notes are removed and can't be restored. If they write again, the bot treats them as a new person. The original DMs on Instagram or Facebook and their cards in the Telegram group are not deleted.",
  "hapusOrang.ya": "Delete permanently",
  "hapusOrang.toast": "{{nama}} permanently deleted",
  "landing.judulHalaman": "Smova by Seleris · Instagram DM assistant",
  "landing.oleh": "by",
  "landing.nav.label": "Main navigation",
  "landing.nav.merekAtas": "Smova by Seleris, back to top",
  "landing.nav.caraKerja": "How it works",
  "landing.nav.konten": "Content",
  "landing.nav.tanyaJawab": "FAQ",
  "landing.nav.kontak": "Contact",
  "landing.nav.masuk": "Sign in",
  "landing.mintaDemo": "Request a demo",
  "landing.mintaDemoWa": "Request a demo on WhatsApp",
  "landing.waPesan": "Hello Seleris, I would like to see a demo of Smova",
  "landing.contohKet": "Example. The prospect and the conversation are made up; the answers come from Seleris documents.",
  "landing.hero.pil": "An Instagram DM assistant, set up and looked after by Seleris",
  "landing.hero.judul1": "A message arrives Saturday night.",
  "landing.hero.judul2": "By Monday morning, the meeting",
  "landing.hero.judul3": "is already in your team group.",
  "landing.hero.lede": "Smova answers your company's Instagram DMs from your own product documents, asks the prospect for their details one at a time, then books a meeting from the schedule you set.",
  "landing.hero.waKet": "Opens WhatsApp with the message already written.",
  "landing.hero.status": "Today: replies to Instagram DMs, and publishes content to Instagram and Facebook.",
  "landing.jaga.judul": "What the bot always holds to",
  "landing.jaga.1": "Mentions only the products in your documents.",
  "landing.jaga.2": "Checks the schedule again before booking a meeting.",
  "landing.jaga.3": "Never claims to be human, and promises nothing beyond your settings.",
  "landing.panggung.cip1": "Saturday 9:47 PM · office closed",
  "landing.panggung.cip2": "Monday 10:00 AM WIB · presentation booked",
  "landing.panggung.cip3": "Answered from Seleris documents",
  "landing.panggung.maskot": "The Seleris astronaut mascot waving",
  "landing.ponsel.label": "Example Instagram DM: Rina Kartika asks about Seleris Care, and the Seleris Assistant answers from Seleris documents and asks for her company name",
  "landing.ponsel.dm": "Instagram DM",
  "landing.ponsel.waktu": "Saturday 9:47 PM",
  "landing.ponsel.labelKlien": "Rina Kartika · prospect",
  "landing.ponsel.klien1": "Good evening. We want health checks for 400 employees across 5 branches. Is Seleris Care available for companies? Could you present next week?",
  "landing.ponsel.labelBot": "Seleris Assistant · bot",
  "landing.ponsel.bot1": "Good evening. Yes. For companies there is the Seleris Care Prime package: the check is a face video of about 30 seconds from a smartphone camera, with no medical device and no physical contact. So the presentation fits your needs, may I have your company name?",
  "landing.ponsel.klien2": "PT Mitra Niaga Logistik.",
  "landing.ponsel.tulis": "Message…",
  "landing.ck.pil": "How it works, with the same example",
  "landing.ck.judul1": "From one Saturday-night DM",
  "landing.ck.judul2": "to the summary after the meeting.",
  "landing.ck.sub": "You prepare the product documents and the scheduling rules. The bot uses both when it answers, and your team is notified in a Telegram group.",
  "landing.ck.l1Tag": "Saturday 9:47 PM",
  "landing.ck.l1Judul": "The DM is answered from your documents",
  "landing.ck.l1Ket": "Rina asks about Seleris Care. The bot answers from the Seleris product documents.",
  "landing.ck.l2Tag": "In the same conversation",
  "landing.ck.l2Judul": "Details are asked one at a time",
  "landing.ck.l2Ket": "Company, address, contact person, email, phone, and questions of your own.",
  "landing.ck.l3Tag": "From your schedule",
  "landing.ck.l3Judul": "A meeting time is booked",
  "landing.ck.l3Ket": "The bot offers times that are still free, checks again, then books one.",
  "landing.ck.l4Tag": "When the meeting is booked",
  "landing.ck.l4Judul": "The team hears about it on Telegram",
  "landing.ck.l4Ket": "One matter, one card in the team group, and that card is the one that gets updated.",
  "landing.ck.l5Tag": "Monday 11:05 AM",
  "landing.ck.l5Judul": "A summary after the meeting",
  "landing.ck.l5Ket": "A voice note in the group, or an uploaded audio recording, becomes a transcript and a summary.",
  "landing.ck.dataJudul": "Prospect details",
  "landing.ck.dataKet": "Steps 2 and 3, collected from the DM",
  "landing.data.perusahaan": "Company",
  "landing.data.perusahaanIsi": "PT Mitra Niaga Logistik",
  "landing.data.alamat": "Address",
  "landing.data.alamatIsi": "Jl. Raya Cakung, East Jakarta",
  "landing.data.pic": "Contact person",
  "landing.data.picIsi": "Rina Kartika, HR Manager",
  "landing.data.email": "Email",
  "landing.data.emailIsi": "rina•••@•••.co.id",
  "landing.data.telepon": "Phone",
  "landing.data.teleponIsi": "0813 •••• 2290",
  "landing.data.karyawan": "Employees",
  "landing.data.karyawanIsi": "400 employees across 5 branches",
  "landing.data.tambahan": "your own question",
  "landing.ck.hariJudul": "Days the bot offers",
  "landing.ck.senin": "Monday",
  "landing.ck.selasa": "Tuesday",
  "landing.ck.rabu": "Wednesday",
  "landing.ck.jamKet": "Free start times on Monday: 8:00 AM–3:30 PM WIB. Rina picks 10:00 AM.",
  "landing.ck.tercatat": "The online Seleris Care presentation on Monday at 10:00 AM WIB is booked.",
  "landing.grup.nama": "Seleris team",
  "landing.grup.ket": "Team Telegram group",
  "landing.grup.ketLangkah": "Team Telegram group · steps 4 and 5",
  "landing.grup.meetingJudul": "New meeting scheduled",
  "landing.grup.meetingWaktu": "Monday at 10:00 AM WIB",
  "landing.grup.meetingAjak": "Please choose in Smova who will join the meeting.",
  "landing.grup.waktuSesudah": "Monday 11:05 AM",
  "landing.grup.suara": "Voice note after the meeting",
  "landing.ringkas.kepala": "Prospect page · PT Mitra Niaga Logistik",
  "landing.ringkas.label": "Summary",
  "landing.ringkas.isi": "The HR team wants Seleris Care Prime for 400 employees across 5 branches. They asked for a price quote and a sample report.",
  "landing.ringkas.ket": "The transcript is kept on the same page.",
  "landing.ck.bawah": "When a DM needs a person, a “DM needs a human” card arrives in the group.",
  "landing.ck.bawahTautan": "See how the team takes over",
  "landing.po.pil": "When the answer has to come from a person",
  "landing.po.judul1": "The bot knows when to stop.",
  "landing.po.judul2": "The team is called with one card.",
  "landing.po.sub": "On Monday afternoon, Rina writes again and asks for a price quote for 400 employees. Price quotes, complaints, requests to talk to a person, and messages left for someone are not the bot's job. Smova passes them to the team group, with the reason.",
  "landing.po.b1Judul": "Take & Handle",
  "landing.po.b1Ket": "One tap in the group and the conversation is yours. The bot stops replying to that person until you hand it back. You type your replies in the Smova dashboard, on a laptop or a phone.",
  "landing.po.b2Judul": "One matter, one card",
  "landing.po.b2Ket": "If the person writes again, the same card is updated instead of a new message. Who is handling it is written on the card, so the group stays easy to read.",
  "landing.po.b3Judul": "No visitor is left hanging",
  "landing.po.b3Ket": "For a message left for someone, the bot says it has been passed to the team, without promising who or when, and still offers help with anything about your company.",
  "landing.tg.label": "Smova · 1:05 PM",
  "landing.tg.judul": "DM needs a human",
  "landing.tg.sebab": "The bot has replied, but this needs a person: asking for a price quote.",
  "landing.tg.kutip": "“For 400 employees, roughly how much would it cost?”",
  "landing.tg.baruKepala": "1 new message since this card · last at 1:15 PM, waiting for the team:",
  "landing.tg.baruIsi": "“Looking forward to the quote.”",
  "landing.tg.ambil": "Take & Handle",
  "landing.tg.buka": "Open in Smova",
  "landing.tg.ditangani": "Handled by Dita · 1:08 PM",
  "landing.tg.diam": "The bot stays quiet for @rina.mitraniaga until it is handed back in Smova.",
  "landing.tg.pengatur": "State of the example card",
  "landing.tg.kartuMasuk": "Card arrives",
  "landing.tg.diambilDita": "Taken by Dita",
  "landing.tg.rinaMenulisLagi": "Rina writes again",
  "landing.tg.ket": "The same card is updated; no new message appears in the group. Example: names and messages are made up.",
  "landing.konten.pil": "Instagram and Facebook content",
  "landing.konten.judul1": "Regular content is drafted,",
  "landing.konten.judul2": "your team just approves it.",
  "landing.konten.sub": "AI writes the caption and makes the images, as a single photo or a carousel of 2–10 slides. Your brand frame and logo are placed from their original files. Once your team approves, the content is published on schedule to Instagram and Facebook, in WIB time.",
  "landing.konten.alur": "Content flow",
  "landing.konten.alur1": "Drafted by AI",
  "landing.konten.alur2": "Approved by the team",
  "landing.konten.alur3": "Published on schedule, WIB",
  "landing.konten.gambar1": "Seleris Instagram post titled Manfaat tidur cukup bagi daya tahan tubuh (the benefits of enough sleep for immunity), comparing rooms labelled Tidur berantakan and Tidur yang cukup, with the astronaut mascot, the Seleris logo, and the seleris.ai contact below",
  "landing.konten.gambar2": "Seleris Instagram post titled Kenapa cek kesehatan rutin sebelum usia 40 (why regular check-ups before 40), with the astronaut mascot holding a magnifying glass next to a check-up device",
  "landing.konten.ket": "Examples of content Smova made for Seleris: caption, images, and the brand frame.",
  "landing.batas.pil": "Clear limits",
  "landing.batas.judul1": "The bot answers on behalf of your company.",
  "landing.batas.judul2": "You set its limits.",
  "landing.batas.aturJudul": "What you control",
  "landing.batas.atur1": "The bot's name and tone: formal, friendly, or casual.",
  "landing.batas.atur2": "Who you serve. If you only serve companies, the bot politely tells individual buyers that your service is for companies.",
  "landing.batas.atur3": "When the bot replies: around the clock, or only on certain days and hours. Outside those hours the bot stays quiet or sends one message you wrote, and the conversation still lands in the team's list.",
  "landing.batas.atur4": "The details asked before a meeting, and their order.",
  "landing.batas.atur5": "Meeting days, hours, length, and daily limit, plus days off.",
  "landing.batas.biayaJudul": "AI spending under control",
  "landing.batas.biayaKet": "AI spending has a monthly limit. When it is reached, image generation stops first, then content drafting. Chat replies to customers stop last. Spending is shown per day in Smova.",
  "landing.batas.bisaJudul": "What works today",
  "landing.batas.kemampuan": "Capability",
  "landing.batas.fb": "Facebook Page",
  "landing.batas.membalasDm": "Replying to DMs",
  "landing.batas.membalasKomentar": "Replying to comments",
  "landing.batas.menerbitkan": "Publishing content",
  "landing.batas.angka": "Per-post numbers",
  "landing.batas.bisa": "Yes",
  "landing.batas.belum": "Not yet",
  "landing.batas.tunggu": "Waiting for Meta approval",
  "landing.batas.catatan1": "Not yet: the platform allows it, but Smova has not built it yet.",
  "landing.batas.catatan2": "LinkedIn and TikTok are not available yet. The bot does not reply to WhatsApp chats.",
  "landing.batas.catatan3": "Instagram's rule: a DM can only be answered from Smova within 24 hours of the person's last message.",
  "landing.batas.catatan4": "Meeting and publishing times are in WIB.",
  "landing.tj.pil": "FAQ",
  "landing.tj.judul1": "What people usually ask",
  "landing.tj.judul2": "before they start.",
  "landing.tj.tanya1": "How much does it cost?",
  "landing.tj.jawab1": "Seleris gives you the price once it knows which features you need.",
  "landing.tj.jawab1Lanjut": "AI usage has a monthly limit, and spending is shown per day in Smova.",
  "landing.tj.tanya2": "How long until the bot answers customers?",
  "landing.tj.jawab2": "It depends on how ready your material is, especially the product documents. Seleris gives an estimate after seeing your material.",
  "landing.tj.tanya3": "What do we need to prepare?",
  "landing.tj.jawab3_1": "A business Instagram account and the company's Facebook Page.",
  "landing.tj.jawab3_2": "Text documents with your company profile, products, prices, and frequently asked questions. PDF and Word files need to be saved as text first.",
  "landing.tj.jawab3_3": "One Telegram group for the team.",
  "landing.tj.jawab3_4": "The name and email of everyone who will use Smova.",
  "landing.tj.jawab3_5": "One or two personal Instagram accounts for testing.",
  "landing.tj.tanya4": "Does our team have to use Telegram?",
  "landing.tj.jawab4": "Yes, for team notifications. Messages that need a person, new prospects, new meetings, and content waiting for approval are sent to one Telegram group, with their buttons. Each member links their account once with a code from the admin. Replying to customers and setting up the bot happen in the Smova dashboard, in a browser.",
  "landing.tj.tanya5": "Do we have to use every feature?",
  "landing.tj.jawab5": "No. Features are turned on as you need them, for example only replying to chats, replying through to booking meetings, or regular content from your team's own ideas. The system keeps track of features that depend on each other, so no feature is on without the features it needs.",
  "landing.tj.tanya6": "What if the bot gets an answer wrong?",
  "landing.tj.jawab6": "The bot answers from your documents, so the fix is usually in those documents: correct or add the section, then check again with Answer test in Smova. Meanwhile, the team can take over a conversation at any time, and the bot stays quiet for that person until it is handed back.",
  "landing.tj.tanya7": "What happens after a meeting is scheduled?",
  "landing.tj.jawab7": "The day before, the team group receives the list of tomorrow's meetings. This reminder is for the team; prospects are not reminded automatically. After the meeting, reply to that meeting's message in the group with a voice note, or upload the audio recording in Smova. Smova writes the transcript and summary on that prospect's page.",
  "landing.tj.tanya8": "What about our customer data?",
  "landing.tj.jawab8": "Each company's data is kept apart from every other company's. It can be seen by the people at your company, each with their own account, and by the Seleris team that looks after the service. Changes to the bot's settings, schedule, and meeting rules are recorded along with who made them.",
  "landing.mulai.judul": "How to start",
  "landing.mulai.tahap1": "Preparation",
  "landing.mulai.tahap1Ket": "the bot stays quiet",
  "landing.mulai.tahap2": "Closed trial",
  "landing.mulai.tahap2Ket": "the bot answers only test accounts",
  "landing.mulai.tahap3": "Live",
  "landing.mulai.tegas": "Nothing is sent to customers or published on your accounts before the third stage.",
  "landing.pegang.seleris": "What Seleris takes care of",
  "landing.pegang.seleris1": "Connecting Instagram, the Facebook Page, and the Telegram group",
  "landing.pegang.seleris2": "Accounts for everyone on the team",
  "landing.pegang.seleris3": "Which features are on, and the AI spending limit",
  "landing.pegang.seleris4": "When the bot starts answering everyone",
  "landing.pegang.seleris5": "Monitoring and handling outages",
  "landing.pegang.tim": "What your team takes care of",
  "landing.pegang.tim1": "The content of the product documents",
  "landing.pegang.tim2": "The bot's name, tone, and reply hours",
  "landing.pegang.tim3": "Meeting rules and days off",
  "landing.pegang.tim4": "Content direction, brand images, and publishing times",
  "landing.pegang.tim5": "Every decision: replying, accepting prospects, and approving content",
  "landing.kontak.maskot": "The Seleris astronaut mascot winking and giving a thumbs-up while holding a tablet",
  "landing.kontak.judul1": "Want your Instagram DMs",
  "landing.kontak.judul2": "answered like this?",
  "landing.kontak.sub": "Tell us about your business and how your team sells. Smova is set up and looked after by Seleris.",
  "landing.ph.biaya": "[Seleris pricing and partnership terms]",
  "landing.ph.lamaPasang": "[setup time estimate from Seleris]",
  "landing.ph.nomorWa": "[Seleris WhatsApp number]",
  "landing.kaki.merekAtas": "Smova, back to top",
  "landing.kaki.logo": "Seleris logo, Risk Reimagined",
  "landing.kaki.dirawat": "Set up and looked after by Seleris",
  "landing.kaki.masuk": "Sign in to the dashboard"
}
